/**
 * translations.ts — All translatable strings for AbstractID2.
 *
 * Structure: { localeCode: { "English key": "Translated value" } }
 * English keys fall back to themselves, so `en` only needs overrides.
 *
 * Generated from 1039 unique translation keys.
 */

const translations: Record<string, Record<string, string>> = {
	en: {},
	de: {
		'Images': 'Bilder',
		'Not rated': 'Nicht bewertet',
		'Upload progress': 'Upload-Fortschritt',
		'Uploading… {{percent}}%': 'Wird hochgeladen… {{percent}} %',
		'Linked tickets': 'Verknüpfte Tickets',
		'Follow-up of': 'Folgeticket zu',
		'Continued in': 'Fortgesetzt in',
		'Ticket attachments': 'Anhänge des Tickets',
		'Routing': 'Routing',
		'Edit routing': 'Routing bearbeiten',
		'Edit routing for {{name}}': 'Routing für {{name}} bearbeiten',
		'Edit routing for {{category}} on {{product}}': 'Routing für {{category}} bei {{product}} bearbeiten',
		'Show routing for {{name}}': 'Routing für {{name}} anzeigen',
		'Hide routing for {{name}}': 'Routing für {{name}} ausblenden',
		'Product rule only': 'Nur Produktregel',
		'No support-enabled product takes this category.': 'Kein Produkt mit aktiviertem Support verwendet diese Kategorie.',
		'Notified': 'Benachrichtigt',
		'Auto-assigned': 'Automatisch zugewiesen',
		'Routing for {{product}}': 'Routing für {{product}}',
		'Routing for {{category}} on {{product}}': 'Routing für {{category}} bei {{product}}',
		'Applies to every ticket on {{product}}. Category rules add to it; for assignment, a category rule with auto-assign takes precedence.': 'Gilt für jedes Ticket zu {{product}}. Kategorieregeln ergänzen sie; bei der Zuweisung hat eine Kategorieregel mit automatischer Zuweisung Vorrang.',
		'Applies to {{category}} tickets on {{product}}, in addition to the product rule.': 'Gilt für {{category}}-Tickets zu {{product}}, zusätzlich zur Produktregel.',
		'Notify: gets an email and a notification for each new ticket.': 'Benachrichtigen: erhält zu jedem neuen Ticket eine E-Mail und eine Benachrichtigung.',
		'Auto-assign: new tickets go to the least busy of these agents.': 'Automatisch zuweisen: Neue Tickets gehen an den am wenigsten ausgelasteten dieser Agenten.',
		'Notify {{name}}': '{{name}} benachrichtigen',
		'Auto-assign to {{name}}': 'Automatisch {{name}} zuweisen',
		'Auto-assign': 'Automatisch zuweisen',
		'Routing saved.': 'Routing gespeichert.',
		'Failed to save routing': 'Routing konnte nicht gespeichert werden',
		'Assigned to {{name}} automatically': 'Automatisch {{name}} zugewiesen',
		'Owner': 'Inhaber',
		'People': 'Personen',
		'Remove {{name}} from this ticket?': '{{name}} von diesem Ticket entfernen?',
		'A ticket can have at most {{count}} people besides its owner.': 'Ein Ticket kann neben seinem Inhaber höchstens {{count}} Personen haben.',
		'Add someone by email': 'Person per E-Mail hinzufügen',
		'People you add need an Abstract ID account. They can read the ticket, reply to it and get its emails.': 'Hinzugefügte Personen benötigen ein Abstract-ID-Konto. Sie können das Ticket lesen, darauf antworten und erhalten seine E-Mails.',
		'Leave this ticket? You will no longer be able to see it.': 'Dieses Ticket verlassen? Sie können es danach nicht mehr sehen.',
		'Leave ticket': 'Ticket verlassen',
		'{{email}} was added to the ticket.': '{{email}} wurde zum Ticket hinzugefügt.',
		'Failed to add the person': 'Person konnte nicht hinzugefügt werden',
		'{{name}} was removed from the ticket.': '{{name}} wurde vom Ticket entfernt.',
		'Failed to remove the person': 'Person konnte nicht entfernt werden',
		'Deleted the attachment {{filename}}': 'Hat den Anhang {{filename}} gelöscht',
		'Delete {{name}}? The file is erased for good and cannot be restored.': '{{name}} löschen? Die Datei wird endgültig entfernt und kann nicht wiederhergestellt werden.',
		'{{name}} was deleted.': '{{name}} wurde gelöscht.',
		'Failed to delete the attachment': 'Anhang konnte nicht gelöscht werden',
		'Delete {{name}}': '{{name}} löschen',
		'You left the ticket.': 'Sie haben das Ticket verlassen.',
		'Failed to leave the ticket': 'Ticket konnte nicht verlassen werden',
		'{{owner}} added you to this ticket.': '{{owner}} hat Sie zu diesem Ticket hinzugefügt.',
		'Shared by {{name}}': 'Geteilt von {{name}}',
		'The ticket owner\'s support is no longer active, so replies are closed.': 'Der Support des Ticketinhabers ist nicht mehr aktiv, daher sind keine Antworten mehr möglich.',
		'Added {{name}} to the ticket': 'Hat {{name}} zum Ticket hinzugefügt',
		'Removed {{name}} from the ticket': 'Hat {{name}} vom Ticket entfernt',
		'Left the ticket': 'Hat das Ticket verlassen',
		'Support is currently turned off': 'Der Support ist derzeit ausgeschaltet',
		'Tickets cannot be opened or answered right now. Please check back later.': 'Tickets können derzeit nicht eröffnet oder beantwortet werden. Bitte schauen Sie später wieder vorbei.',
		'Support is turned on.': 'Der Support ist eingeschaltet.',
		'Support is turned off.': 'Der Support ist ausgeschaltet.',
		'Support desk': 'Support-Desk',
		'On. Customers whose license includes support can open tickets, and agents answer them from the Support Desk.': 'Ein. Kunden, deren Lizenz Support umfasst, können Tickets eröffnen; Agenten beantworten sie im Support-Desk.',
		'Off. Support is hidden from customers and agents and the automatic sweeps are paused. Tickets and settings are kept.': 'Aus. Der Support ist für Kunden und Agenten ausgeblendet, automatische Abläufe pausieren. Tickets und Einstellungen bleiben erhalten.',
		'Support desk enabled': 'Support-Desk aktiviert',
		'Notify': 'Benachrichtigen',
		'Team address only': 'Nur Team-Adresse',
		'There are no support agents yet. Assign the support role first.': 'Es gibt noch keine Support-Agenten. Weisen Sie zuerst die Support-Rolle zu.',
		'Agents': 'Agenten',
		'Editor mode': 'Editormodus',
		'Write': 'Schreiben',
		'Markdown supported': 'Markdown wird unterstützt',
		'Nothing to preview yet.': 'Noch nichts zur Vorschau.',
		'Preview {{name}}': 'Vorschau von {{name}}',
		'The full image could not be loaded.': 'Das vollständige Bild konnte nicht geladen werden.',
		'or drop them here': 'oder hier ablegen',
		'No access to support?': 'Kein Zugang zum Support?',
		'Consider purchasing a license to get instant access to our in-house engineering team. Otherwise, you can get help from the Abstract community and on the Abstract Discord.': 'Mit einer Lizenz erhalten Sie sofort Zugang zu unserem hauseigenen Engineering-Team. Alternativ finden Sie Hilfe in der Abstract-Community und auf dem Abstract-Discord.',
		'Abstract Community': 'Abstract-Community',
		'Abstract Discord': 'Abstract-Discord',
		'Community URL': 'Community-URL',
		'Discord invite': 'Discord-Einladung',
		'Offered to users without access to support. Leave blank to offer none.': 'Wird Nutzern ohne Zugang zum Support angeboten. Leer lassen, um nichts anzubieten.',
		'A question or a minor inconvenience.': 'Eine Frage oder eine kleine Unannehmlichkeit.',
		'A resolved ticket untouched this long is closed. 0 turns this off.': 'Ein gelöstes Ticket, das so lange unberührt bleibt, wird geschlossen. 0 schaltet dies ab.',
		'A short summary of the problem': 'Eine kurze Zusammenfassung des Problems',
		'A ticket waiting on the customer this long is resolved. 0 turns this off.': 'Ein Ticket, das so lange auf den Kunden wartet, wird gelöst. 0 schaltet dies ab.',
		'Activity': 'Aktivität',
		'Add category': 'Kategorie hinzufügen',
		'Add note': 'Notiz hinzufügen',
		'Agent': 'Agent',
		'Agents and automation': 'Agenten und Automatisierung',
		'All open': 'Alle offenen',
		'All products': 'Alle Produkte',
		'Another product already uses this prefix.': 'Ein anderes Produkt verwendet dieses Präfix bereits.',
		'Any priority': 'Jede Priorität',
		'Any product': 'Jedes Produkt',
		'Any status': 'Jeder Status',
		'Anyone': 'Alle',
		'Anything you would like to add? (optional)': 'Möchten Sie noch etwas hinzufügen? (optional)',
		'Apply': 'Anwenden',
		'Ask for logs': 'Nach Logs fragen',
		'Assign to me': 'Mir zuweisen',
		'Assign to…': 'Zuweisen an…',
		'Assigned to {{name}}': '{{name}} zugewiesen',
		'Assignee': 'Zuständig',
		'Attach files': 'Dateien anhängen',
		'Attachments': 'Anhänge',
		'Auto-close after (days)': 'Automatisch schließen nach (Tagen)',
		'Auto-resolve after (days)': 'Automatisch lösen nach (Tagen)',
		'Awaiting agent': 'Wartet auf Agent',
		'Awaiting customer': 'Wartet auf Kunde',
		'Back to support': 'Zurück zum Support',
		'Back to the desk': 'Zurück zum Support Desk',
		'Breaching': 'SLA verletzt',
		'Bulk actions': 'Massenaktionen',
		'Templates': 'Vorlagen',
		'Template saved.': 'Vorlage gespeichert.',
		'Categories': 'Kategorien',
		'Categories are optional. They help customers say what a ticket is about.': 'Kategorien sind optional. Sie helfen Kunden zu sagen, worum es in einem Ticket geht.',
		'Category cleared': 'Kategorie entfernt',
		'Category deleted.': 'Kategorie gelöscht.',
		'Category saved.': 'Kategorie gespeichert.',
		'Category set to {{name}}': 'Kategorie auf {{name}} gesetzt',
		'Choose a product': 'Produkt auswählen',
		'Choose a product.': 'Wählen Sie ein Produkt.',
		'Clear selection': 'Auswahl aufheben',
		'Close this ticket? You can open a follow-up later if you need to.': 'Dieses Ticket schließen? Bei Bedarf können Sie später ein Folgeticket eröffnen.',
		'Close ticket': 'Ticket schließen',
		'Closed': 'Geschlossen',
		'Closed automatically': 'Automatisch geschlossen',
		'Comment': 'Kommentar',
		'Conversation': 'Unterhaltung',
		'Could not check your license': 'Ihre Lizenz konnte nicht geprüft werden',
		'Create ticket': 'Ticket erstellen',
		'Customers file tickets against a product while their license for it includes support. Agents answer them from the Support Desk.': 'Kunden eröffnen Tickets zu einem Produkt, solange ihre Lizenz dafür Support umfasst. Agenten beantworten sie im Support Desk.',
		'Delete the template “{{name}}”?': 'Vorlage „{{name}}“ löschen?',
		'Delete the category “{{name}}”?': 'Kategorie „{{name}}“ löschen?',
		'Describe the problem.': 'Beschreiben Sie das Problem.',
		'Dissatisfied': 'Unzufrieden',
		'Edit template': 'Vorlage bearbeiten',
		'Edit {{name}}': '{{name}} bearbeiten',
		'Enable support for a product under Settings → Admin → Support.': 'Aktivieren Sie den Support für ein Produkt unter Einstellungen → Admin → Support.',
		'Enter a whole number of days.': 'Geben Sie eine ganze Anzahl von Tagen ein.',
		'Enter the requester’s email address.': 'Geben Sie die E-Mail-Adresse des Anfragenden ein.',
		'Every ticket filed against a support-enabled product.': 'Alle Tickets zu Produkten mit aktiviertem Support.',
		'Failed to delete the template': 'Vorlage konnte nicht gelöscht werden',
		'Failed to delete the category': 'Kategorie konnte nicht gelöscht werden',
		'Failed to download the attachment': 'Anhang konnte nicht heruntergeladen werden',
		'Failed to load support': 'Support konnte nicht geladen werden',
		'Failed to load support settings': 'Support-Einstellungen konnten nicht geladen werden',
		'Failed to load the ticket': 'Ticket konnte nicht geladen werden',
		'Failed to load tickets': 'Tickets konnten nicht geladen werden',
		'No tickets yet': 'Noch keine Tickets',
		'Failed to open the ticket': 'Ticket konnte nicht eröffnet werden',
		'Failed to save support for this product': 'Support für dieses Produkt konnte nicht gespeichert werden',
		'Failed to save support settings': 'Support-Einstellungen konnten nicht gespeichert werden',
		'Failed to save the template': 'Vorlage konnte nicht gespeichert werden',
		'Failed to save the category': 'Kategorie konnte nicht gespeichert werden',
		'Failed to send the message': 'Nachricht konnte nicht gesendet werden',
		'Failed to send the reply': 'Antwort konnte nicht gesendet werden',
		'Failed to submit the rating': 'Bewertung konnte nicht gesendet werden',
		'Failed to update the ticket': 'Ticket konnte nicht aktualisiert werden',
		'Failed to update the tickets': 'Tickets konnten nicht aktualisiert werden',
		'Filed by {{name}}': 'Eröffnet von {{name}}',
		'Files to attach': 'Anzuhängende Dateien',
		'First response': 'Erste Antwort',
		'First response (hours)': 'Erste Antwort (Stunden)',
		'First response target for {{priority}}': 'Ziel für erste Antwort bei {{priority}}',
		'Follows up on {{key}}': 'Folgeticket zu {{key}}',
		'For requests that reached the team another way — by phone, chat or email.': 'Für Anfragen, die das Team auf anderem Weg erreicht haben – per Telefon, Chat oder E-Mail.',
		'Get help with the Abstract products you hold a license for.': 'Erhalten Sie Hilfe zu den Abstract-Produkten, für die Sie eine Lizenz besitzen.',
		'Give the ticket a subject.': 'Geben Sie dem Ticket einen Betreff.',
		'High': 'Hoch',
		'Holders of this role are agents. Administrators always are.': 'Inhaber dieser Rolle sind Agenten. Administratoren sind es immer.',
		'How did we do?': 'Wie war unser Support?',
		'Insert template…': 'Vorlage einfügen…',
		'Insert placeholder:': 'Platzhalter einfügen:',
		'Internal note': 'Interne Notiz',
		'Last activity': 'Letzte Aktivität',
		'Last heard': 'Zuletzt gemeldet',
		'Low': 'Niedrig',
		'Met': 'Eingehalten',
		'Mine': 'Meine',
		'Missed': 'Verfehlt',
		'Neutral': 'Neutral',
		'New': 'Neu',
		'New template': 'Neue Vorlage',
		'New ticket': 'Neues Ticket',
		'New ticket on behalf of a customer': 'Neues Ticket im Namen eines Kunden',
		'No templates yet': 'Noch keine Vorlagen',
		'No categories': 'Keine Kategorien',
		'No category': 'Keine Kategorie',
		'No product has support enabled': 'Für kein Produkt ist Support aktiviert',
		'No product offers you support right now': 'Derzeit bietet Ihnen kein Produkt Support',
		'No support role — administrators only': 'Keine Support-Rolle – nur Administratoren',
		'No target': 'Kein Ziel',
		'No ticket matches this view and these filters.': 'Kein Ticket entspricht dieser Ansicht und diesen Filtern.',
		'Nobody': 'Niemand',
		'None of the Abstract products offer support through Abstract ID yet.': 'Noch kein Abstract-Produkt bietet Support über Abstract ID an.',
		'Normal': 'Normal',
		'Not yet assigned': 'Noch nicht zugewiesen',
		'Note added.': 'Notiz hinzugefügt.',
		'Nothing in this view': 'Nichts in dieser Ansicht',
		'Offered for new tickets': 'Für neue Tickets angeboten',
		'On': 'An',
		'Only the person who opened this ticket can reply to it.': 'Nur die Person, die dieses Ticket eröffnet hat, kann darauf antworten.',
		'Your support entitlement could not be confirmed right now. Please try again shortly.': 'Ihr Support-Anspruch kann gerade nicht bestätigt werden. Bitte versuchen Sie es in Kürze erneut.',
		'Open': 'Offen',
		'Open (any)': 'Offen (alle)',
		'Open a follow-up': 'Folgeticket eröffnen',
		'Opened': 'Eröffnet',
		'Operating system': 'Betriebssystem',
		'Overdue by {{time}}': '{{time}} überfällig',
		'Paused · {{time}} left': 'Pausiert · noch {{time}}',
		'Prefix': 'Präfix',
		'Priority': 'Priorität',
		'Priority changed from {{from}} to {{to}}': 'Priorität von {{from}} auf {{to}} geändert',
		'Priority…': 'Priorität…',
		'Product': 'Produkt',
		'Product version': 'Produktversion',
		'Production is down and there is no workaround.': 'Die Produktion steht still und es gibt keine Umgehungslösung.',
		'Products': 'Produkte',
		'Rated {{rating}} out of 5': 'Mit {{rating}} von 5 bewertet',
		'Rating': 'Bewertung',
		'Receives SLA breach alerts for tickets nobody is assigned to.': 'Erhält SLA-Verletzungswarnungen für Tickets, die niemandem zugewiesen sind.',
		'Remove {{name}}': '{{name}} entfernen',
		'Reopen ticket': 'Ticket wieder öffnen',
		'Replies the team reuses. Placeholders are filled in from the ticket when a reply is inserted.': 'Antworten, die das Team wiederverwendet. Platzhalter werden beim Einfügen aus dem Ticket befüllt.',
		'Reply': 'Antworten',
		'Reply sent.': 'Antwort gesendet.',
		'Requester': 'Anfragender',
		'Requester email': 'E-Mail des Anfragenden',
		'Resolution': 'Lösung',
		'Resolution (hours)': 'Lösung (Stunden)',
		'Resolution target for {{priority}}': 'Lösungsziel für {{priority}}',
		'Resolved': 'Gelöst',
		'Resolved automatically after no reply': 'Automatisch gelöst, da keine Antwort kam',
		'SLA': 'SLA',
		'SLA targets must be positive numbers of hours, or blank for none.': 'SLA-Ziele müssen positive Stundenzahlen sein oder leer für keines.',
		'Satisfaction': 'Zufriedenheit',
		'Satisfied': 'Zufrieden',
		'Save settings': 'Einstellungen speichern',
		'Save the answers the team gives most often, and insert them from any ticket.': 'Speichern Sie die häufigsten Antworten des Teams und fügen Sie sie in jedes Ticket ein.',
		'Search key, subject or requester…': 'Schlüssel, Betreff oder Anfragenden suchen…',
		'Search tickets…': 'Tickets suchen…',
		'Select all': 'Alle auswählen',
		'Select {{key}}': '{{key}} auswählen',
		'Service level': 'Service-Level',
		'Service levels': 'Service-Level',
		'Set assignee': 'Zuständigen festlegen',
		'Set priority': 'Priorität festlegen',
		'Set status': 'Status festlegen',
		'Showing {{from}} to {{to}} of {{total}}': '{{from}} bis {{to}} von {{total}}',
		'Shown as a hint when a customer picks it.': 'Wird als Hinweis angezeigt, wenn ein Kunde sie auswählt.',
		'Something is not working as expected.': 'Etwas funktioniert nicht wie erwartet.',
		'Status after sending': 'Status nach dem Senden',
		'Status changed to {{to}}': 'Status auf {{to}} geändert',
		'Status: automatic': 'Status: automatisch',
		'Status: {{status}}': 'Status: {{status}}',
		'Status…': 'Status…',
		'Submit rating': 'Bewertung senden',
		'Submit ticket': 'Ticket senden',
		'Support': 'Support',
		'Support Desk': 'Support Desk',
		'Support Desk — {{count}} unassigned': 'Support Desk – {{count}} nicht zugewiesen',
		'Support available': 'Support verfügbar',
		'Support comes with an active license. The support page explains the situation for each product.': 'Support ist in einer aktiven Lizenz enthalten. Die Support-Seite erklärt die Situation für jedes Produkt.',
		'Support for {{name}}': 'Support für {{name}}',
		'Support is not available for this product yet.': 'Für dieses Produkt ist noch kein Support verfügbar.',
		'Support is not available yet': 'Support ist noch nicht verfügbar',
		'Support needs licensing turned on for the product, and a ticket prefix — the LOD in LOD-1042.': 'Support erfordert aktivierte Lizenzierung für das Produkt und ein Ticket-Präfix – das LOD in LOD-1042.',
		'Support not available': 'Support nicht verfügbar',
		'Support role': 'Support-Rolle',
		'Support saved for {{name}}.': 'Support für {{name}} gespeichert.',
		'Support settings saved.': 'Support-Einstellungen gespeichert.',
		'Targets in hours of wall-clock time from when the ticket was opened. The resolution clock pauses while a ticket waits on the customer. Leave blank for no target.': 'Ziele in Stunden Echtzeit ab Eröffnung des Tickets. Die Lösungsuhr pausiert, solange ein Ticket auf den Kunden wartet. Leer lassen für kein Ziel.',
		'Team email': 'Team-E-Mail',
		'Tell us what is going wrong. The more detail, the faster we can help.': 'Sagen Sie uns, was nicht funktioniert. Je mehr Details, desto schneller können wir helfen.',
		'Thank you for your feedback.': 'Vielen Dank für Ihr Feedback.',
		'The customer must already have an account.': 'Der Kunde muss bereits ein Konto haben.',
		'The license server for this product did not answer. Please try again shortly.': 'Der Lizenzserver dieses Produkts hat nicht geantwortet. Bitte versuchen Sie es in Kürze erneut.',
		'The prefix must be 2–10 uppercase letters or digits.': 'Das Präfix muss aus 2–10 Großbuchstaben oder Ziffern bestehen.',
		'The product the ticket is filed against': 'Das Produkt, zu dem das Ticket eröffnet wurde',
		'The requester\'s first name': 'Vorname des Anfragenden',
		'The requester\'s full name': 'Vollständiger Name des Anfragenden',
		'The ticket reference, e.g. LOD-1042': 'Die Ticketreferenz, z. B. LOD-1042',
		'This ticket is closed.': 'Dieses Ticket ist geschlossen.',
		'This ticket is closed. If the problem is back, open a follow-up and we will pick it up from here.': 'Dieses Ticket ist geschlossen. Wenn das Problem wieder auftritt, eröffnen Sie ein Folgeticket – wir machen dort weiter.',
		'Ticket': 'Ticket',
		'Ticket closed.': 'Ticket geschlossen.',
		'Ticket opened': 'Ticket eröffnet',
		'Ticket prefix for {{name}}': 'Ticket-Präfix für {{name}}',
		'Ticket reopened.': 'Ticket wieder geöffnet.',
		'Ticket updated': 'Ticket aktualisiert',
		'Ticket updated.': 'Ticket aktualisiert.',
		'Ticket {{key}} opened.': 'Ticket {{key}} eröffnet.',
		'Tickets': 'Tickets',
		'Title': 'Titel',
		'Turn on licensing for this product first.': 'Aktivieren Sie zuerst die Lizenzierung für dieses Produkt.',
		'Unassigned': 'Nicht zugewiesen',
		'Updated {{count}} ticket(s).': '{{count}} Ticket(s) aktualisiert.',
		'Urgent': 'Dringend',
		'Very dissatisfied': 'Sehr unzufrieden',
		'Very satisfied': 'Sehr zufrieden',
		'Views': 'Ansichten',
		'Waiting for support': 'Wartet auf Support',
		'Waiting for you': 'Wartet auf Sie',
		'What did you do, what did you expect, and what happened instead? Markdown is supported.': 'Was haben Sie getan, was haben Sie erwartet und was ist stattdessen passiert? Markdown wird unterstützt.',
		'When something is not working, open a ticket and the support team will get back to you.': 'Wenn etwas nicht funktioniert, eröffnen Sie ein Ticket und das Support-Team meldet sich bei Ihnen.',
		'Write a note only the support team can see…': 'Notiz schreiben, die nur das Support-Team sieht…',
		'Write your reply…': 'Antwort schreiben…',
		'You do not hold a license for this product.': 'Sie besitzen keine Lizenz für dieses Produkt.',
		'Your license for this product does not include support.': 'Ihre Lizenz für dieses Produkt umfasst keinen Support.',
		'Your license for this product has expired.': 'Ihre Lizenz für dieses Produkt ist abgelaufen.',
		'Your name': 'Ihr Name',
		'Your tickets': 'Ihre Tickets',
		'Your work is significantly impaired.': 'Ihre Arbeit ist erheblich beeinträchtigt.',
		'{{count}} selected': '{{count}} ausgewählt',
		'{{name}} filed this ticket using a seat of your license. You can follow it, but only they can reply.': '{{name}} hat dieses Ticket über einen Platz Ihrer Lizenz eröffnet. Sie können es verfolgen, aber nur diese Person kann antworten.',
		'{{time}} left': 'noch {{time}}',
		'Columns': 'Spalten',
		'Reset columns': 'Spalten zurücksetzen',
		'2FA': '2FA',
		'Newsletter': 'Newsletter',
		'Enabled': 'Aktiviert',
		'Disabled': 'Deaktiviert',
		'Opted out': 'Abgemeldet',
		'Subscribed': 'Abonniert',
		'Local': 'Lokal',
		'Review your active sessions to sign out elsewhere.': 'Aktive Sitzungen prüfen, um sich anderswo abzumelden.',
		'Sign out on this device. Your other devices stay signed in.': 'Auf diesem Gerät abmelden. Ihre anderen Geräte bleiben angemeldet.',
		'All {{count}} of your licenses for this product have expired.': 'Alle {{count}} Ihrer Lizenzen für dieses Produkt sind abgelaufen.',
		'No active licenses': 'Keine aktiven Lizenzen',
		'Show {{count}} expired': '{{count}} abgelaufene anzeigen',
		'Add all': 'Alle hinzufügen',
		'Add one at a time': 'Einzeln hinzufügen',
		'Add several at once': 'Mehrere auf einmal hinzufügen',
		'Added {{count}}.': '{{count}} hinzugefügt.',
		'Added {{count}}. Skipped: {{skipped}}.': '{{count}} hinzugefügt. Übersprungen: {{skipped}}.',
		'Email addresses': 'E-Mail-Adressen',
		'Everyone on that list already has seats on this license.': 'Alle auf dieser Liste haben bereits Plätze auf dieser Lizenz.',
		'None of those look like email addresses.': 'Keine davon sieht wie eine E-Mail-Adresse aus.',
		'Paste at least one email address.': 'Fügen Sie mindestens eine E-Mail-Adresse ein.',
		'Separate addresses with commas, spaces or new lines. People who already have seats are skipped.': 'Trennen Sie Adressen mit Kommas, Leerzeichen oder Zeilenumbrüchen. Personen, die bereits Plätze haben, werden übersprungen.',
		'colleague@example.com, another@example.com': 'kollege@beispiel.de, weitere@beispiel.de',
		'seats each': 'Plätze je Person',
		'{{count}} already assigned': '{{count}} bereits zugewiesen',
		'{{count}} not a valid address': '{{count}} keine gültige Adresse',
		'{{needed}} seat(s) needed for {{people}} people, but only {{available}} left.': '{{needed}} Platz/Plätze für {{people}} Personen erforderlich, aber nur {{available}} verfügbar.',
		'Group {{number}}': 'Gruppe {{number}}',
		'Link {{number}}': 'Link {{number}}',
		'Remove group': 'Gruppe entfernen',
		'Remove link': 'Link entfernen',
		'Add group': 'Gruppe hinzufügen',
		'Download Groups': 'Download-Gruppen',
		'Heading for builds the backend files under no group. Blank uses “Other”.': 'Überschrift für Builds, die das Backend keiner Gruppe zuordnet. Leer bedeutet „Sonstige“.',
		'Name for ungrouped builds': 'Name für nicht gruppierte Builds',
		'Names the groups the licensing backend files builds under. Order here is the order they appear; an unmapped group still shows, under its raw identifier.': 'Benennt die Gruppen, unter denen das Lizenz-Backend Builds ablegt. Die Reihenfolge hier ist die Anzeigereihenfolge; eine nicht zugeordnete Gruppe erscheint weiterhin unter ihrer Kennung.',
		'Other': 'Sonstige',
		'Get a License URL': 'URL zum Lizenzerwerb',
		'Get a license': 'Lizenz erwerben',
		'Get a license for {{name}}': 'Lizenz für {{name}} erwerben',
		'Offered to users who hold no license for this product. Blank makes no offer.': 'Wird Nutzern angeboten, die keine Lizenz für dieses Produkt besitzen. Leer bedeutet kein Angebot.',
		'Add link': 'Link hinzufügen',
		'Display Name': 'Anzeigename',
		'Documentation': 'Dokumentation',
		'Documentation Links': 'Dokumentations-Links',
		'Shown below the user\'s licenses for this product, and linked from its card on the dashboard.': 'Wird unter den Lizenzen des Nutzers für dieses Produkt angezeigt und von dessen Karte im Dashboard verlinkt.',
		'What customers call this product. Used across the license pages; blank uses the application name.': 'Wie Kunden dieses Produkt nennen. Wird auf allen Lizenzseiten verwendet; leer bedeutet den Anwendungsnamen.',
		'{{count}} expired': '{{count}} abgelaufen',
		'Download {{name}}': '{{name}} herunterladen',
		'Builds appear here once they are linked to an entitlement on one of your active licenses.': 'Builds erscheinen hier, sobald sie mit einer Berechtigung einer Ihrer aktiven Lizenzen verknüpft sind.',
		'It offers {{count}} download(s) for your account.': 'Es bietet {{count}} Download(s) für Ihr Konto.',
		'Link builds to the entitlements your licenses grant to make them downloadable.': 'Verknüpfen Sie Builds mit den Berechtigungen Ihrer Lizenzen, damit sie herunterladbar werden.',
		'No downloads available': 'Keine Downloads verfügbar',
		'Download': 'Herunterladen',
		'Downloads': 'Downloads',
		'Failed to load downloads': 'Downloads konnten nicht geladen werden',
		'Failed to start the download': 'Download konnte nicht gestartet werden',
		'Latest': 'Neueste',
		'Add': 'Hinzufügen',
		'Add a seat': 'Einen Platz hinzufügen',
		'Assign at least one seat.': 'Weisen Sie mindestens einen Platz zu.',
		'Assign seats to a colleague': 'Plätze an Kolleg:innen vergeben',
		'Discard changes': 'Änderungen verwerfen',
		'Email address': 'E-Mail-Adresse',
		'Enter a valid email address.': 'Geben Sie eine gültige E-Mail-Adresse ein.',
		'Every seat on this license is yours to use. Assign a block below to share it.': 'Alle Plätze dieser Lizenz stehen Ihnen zur Verfügung. Vergeben Sie unten ein Kontingent, um sie zu teilen.',
		'Give blocks of seats to colleagues. They activate their own machines against the seats you assign; removing a block takes the seats back.': 'Vergeben Sie Platzkontingente an Kolleg:innen. Diese aktivieren ihre eigenen Rechner gegen die zugewiesenen Plätze; das Entfernen eines Kontingents holt die Plätze zurück.',
		'No seats left to assign. Reduce a block above first.': 'Keine Plätze mehr zu vergeben. Reduzieren Sie zuerst ein Kontingent oben.',
		'Not yet saved': 'Noch nicht gespeichert',
		'Only {{count}} seat(s) left to assign.': 'Nur noch {{count}} Platz/Plätze zu vergeben.',
		'Remove a seat': 'Einen Platz entfernen',
		'Remove assignment': 'Zuweisung entfernen',
		'Seat budget': 'Platzkontingent',
		'That person already has seats on this license.': 'Diese Person hat bereits Plätze auf dieser Lizenz.',
		'{{assigned}} of {{total}} assigned': '{{assigned}} von {{total}} vergeben',
		'{{count}} seat(s) left for your own machines.': '{{count}} Platz/Plätze bleiben für Ihre eigenen Rechner.',
		'{{count}} seat(s) over the license total.': '{{count}} Platz/Plätze über dem Lizenzkontingent.',
		'{{used}} of {{seats}} in use': '{{used}} von {{seats}} in Verwendung',
		'It holds {{count}} license(s) for your account.': 'Es hält {{count}} Lizenz(en) für Ihr Konto.',
		'The backend answered, but refused to list your licenses. Check that it shares the same JWT_KEY as Abstract ID.': 'Das Backend hat geantwortet, aber die Auflistung Ihrer Lizenzen verweigert. Prüfen Sie, ob es denselben JWT_KEY wie Abstract ID verwendet.',
		'This application is inactive, so its licenses are hidden from users regardless of the settings below.': 'Diese Anwendung ist inaktiv; ihre Lizenzen bleiben für Nutzer unabhängig von den Einstellungen unten verborgen.',
		'A backend URL is required to enable licensing.': 'Zum Aktivieren der Lizenzierung ist eine Backend-URL erforderlich.',
		'Adapter': 'Adapter',
		'Backend reachable': 'Backend erreichbar',
		'Failed to save licensing configuration': 'Lizenzkonfiguration konnte nicht gespeichert werden',
		'Failed to test the licensing backend': 'Lizenz-Backend konnte nicht getestet werden',
		'Licensing Backends': 'Lizenz-Backends',
		'Licensing saved for {{name}}.': 'Lizenzierung für {{name}} gespeichert.',
		'No licensing backends': 'Keine Lizenz-Backends',
		'No sublicense entitlement is configured on the backend, so seats can never be re-assigned.': 'Im Backend ist keine Sublizenz-Berechtigung konfiguriert, daher können Plätze nie weitergegeben werden.',
		'Products whose licenses users can see from their Abstract ID account. Abstract ID stores no license data — it reads each backend live, as the signed-in user.': 'Produkte, deren Lizenzen Nutzer in ihrem Abstract-ID-Konto sehen können. Abstract ID speichert keine Lizenzdaten — es liest jedes Backend live als angemeldeter Nutzer.',
		'Show all applications': 'Alle Anwendungen anzeigen',
		'Test connection': 'Verbindung testen',
		'This backend serves a different application.': 'Dieses Backend bedient eine andere Anwendung.',
		'Turn on "Show all applications" to point a product at its license server.': 'Aktivieren Sie „Alle Anwendungen anzeigen“, um ein Produkt auf seinen Lizenzserver zu verweisen.',
		'Unsaved': 'Nicht gespeichert',
		'Users would see an empty license list. Check the URL points at this product’s license server.': 'Nutzer würden eine leere Lizenzliste sehen. Prüfen Sie, ob die URL auf den Lizenzserver dieses Produkts zeigt.',
		'{{configured}} of {{total}} applications have a licensing backend.': '{{configured}} von {{total}} Anwendungen haben ein Lizenz-Backend.',
		'License Activation Revoked': 'Lizenzaktivierung widerrufen',
		'Support Ticket Created': 'Support-Ticket erstellt',
		'Support Ticket Updated': 'Support-Ticket aktualisiert',
		'Support Settings Changed': 'Support-Einstellungen geändert',
		'License Seats Updated': 'Lizenzplätze aktualisiert',
		'API base including the version prefix, e.g. https://license.example.com/api/v1': 'API-Basis inklusive Versionspräfix, z. B. https://license.example.com/api/v1',
		'Activated': 'Aktiviert',
		'All seats on this license are yours to use.': 'Alle Plätze dieser Lizenz stehen Ihnen selbst zur Verfügung.',
		'Allow seat re-assignment': 'Platzvergabe erlauben',
		'Assign seats': 'Plätze zuweisen',
		'Assigned seat': 'Zugewiesener Platz',
		'Assigned seats ({{assigned}}) exceed the license total ({{total}}).': 'Zugewiesene Plätze ({{assigned}}) überschreiten das Lizenzkontingent ({{total}}).',
		'Back to licenses': 'Zurück zu den Lizenzen',
		'Backend URL': 'Backend-URL',
		'Discard': 'Verwerfen',
		'Entitlements': 'Berechtigungen',
		'Every assignment needs an email address.': 'Jede Zuweisung benötigt eine E-Mail-Adresse.',
		'Expired': 'Abgelaufen',
		'Expires': 'Läuft ab',
		'Failed to load activations': 'Aktivierungen konnten nicht geladen werden',
		'Failed to load license': 'Lizenz konnte nicht geladen werden',
		'Failed to load licenses': 'Lizenzen konnten nicht geladen werden',
		'Failed to release seats': 'Plätze konnten nicht freigegeben werden',
		'Failed to save seat assignments': 'Platzzuweisungen konnten nicht gespeichert werden',
		'Give blocks of seats to colleagues. They activate their own machines against the seats you assign; removing an assignment takes the seats back.': 'Vergeben Sie Platzkontingente an Kolleginnen und Kollegen. Diese aktivieren ihre eigenen Rechner gegen die zugewiesenen Plätze; das Entfernen einer Zuweisung holt die Plätze zurück.',
		'Lets users see this product\'s licenses and activations from their Abstract ID account. Abstract ID stores no license data — it reads the backend live, as the signed-in user.': 'Ermöglicht Nutzern, Lizenzen und Aktivierungen dieses Produkts in ihrem Abstract-ID-Konto zu sehen. Abstract ID speichert keine Lizenzdaten — es liest das Backend live als angemeldeter Nutzer.',
		'License': 'Lizenz',
		'Licenses': 'Lizenzen',
		'Licenses issued to you across Abstract products, and the machines using them.': 'Ihre Lizenzen über alle Abstract-Produkte hinweg und die Rechner, die sie nutzen.',
		'Builds available to you for each Abstract product you are licensed for.': 'Builds, die Ihnen für jedes Abstract-Produkt zur Verfügung stehen, für das Sie lizenziert sind.',
		'Guides and references for each Abstract product.': 'Anleitungen und Referenzen zu jedem Abstract-Produkt.',
		'No documentation': 'Keine Dokumentation',
		'This product publishes no documentation yet.': 'Für dieses Produkt wurde noch keine Dokumentation veröffentlicht.',
		'Licensing': 'Lizenzierung',
		'Licensing Backend': 'Lizenz-Backend',
		'Machine': 'Rechner',
		'Machines': 'Rechner',
		'Machines currently using a seat of this license.': 'Rechner, die derzeit einen Platz dieser Lizenz belegen.',
		'My Licenses': 'Meine Lizenzen',
		'No licensed products': 'Keine lizenzierten Produkte',
		'No licenses': 'Keine Lizenzen',
		'No machine has activated this license yet.': 'Noch kein Rechner hat diese Lizenz aktiviert.',
		'No machines': 'Keine Rechner',
		'No seats assigned': 'Keine Plätze zugewiesen',
		'None of the products you have access to manage licenses through Abstract ID.': 'Keines Ihrer Produkte verwaltet Lizenzen über Abstract ID.',
		'Release {{count}} seat(s)': '{{count}} Platz/Plätze freigeben',
		'Released': 'Freigegeben',
		'Released {{count}} seat(s).': '{{count}} Platz/Plätze freigegeben.',
		'Renews': 'Verlängert',
		'Save assignments': 'Zuweisungen speichern',
		'Seat assignments': 'Platzzuweisungen',
		'Seat assignments saved.': 'Platzzuweisungen gespeichert.',
		'Seats': 'Plätze',
		'Select': 'Auswählen',
		'Select {{machine}}': '{{machine}} auswählen',
		'The backend still decides per license whether its owner may delegate seats; this only hides the controls for the whole product.': 'Das Backend entscheidet weiterhin pro Lizenz, ob deren Inhaber Plätze weitergeben darf; dies blendet die Steuerelemente lediglich für das gesamte Produkt aus.',
		'Valid': 'Gültig',
		'You have no licenses for this product yet.': 'Sie haben noch keine Lizenzen für dieses Produkt.',
		'Your Licenses': 'Ihre Lizenzen',
		'colleague@example.com': 'kollege@beispiel.de',
		'{{assigned}} of {{total}} seats assigned': '{{assigned}} von {{total}} Plätzen zugewiesen',
		'{{count}} active': '{{count}} aktiv',
		'{{count}} free': '{{count}} frei',
		'{{count}} license(s)': '{{count}} Lizenz(en)',
		'Collapse sidebar': 'Seitenleiste einklappen',
		'Expand sidebar': 'Seitenleiste ausklappen',
		'Something went wrong': 'Etwas ist schiefgelaufen',
		'Switch to dark mode': 'Zum dunklen Modus wechseln',
		'Switch to light mode': 'Zum hellen Modus wechseln',
		'Allow pop-ups for this site to sign in with Microsoft.': 'Erlauben Sie Pop-ups für diese Seite, um sich mit Microsoft anzumelden.',
		'and access the following': 'und auf Folgendes zugreifen',
		'and access your profile information': 'und auf Ihre Profilinformationen zugreifen',
		'2FA Disabled': '2FA deaktiviert',
		'2FA Enabled': '2FA aktiviert',
		'2FA Not Set': '2FA nicht eingerichtet',
		'2FA QR Code': '2FA QR-Code',
		'2FA is enabled': '2FA ist aktiviert',
		'2FA is not enabled': '2FA ist nicht aktiviert',
		'6-digit code': '6-stelliger Code',
		'A short bio or description...': 'Kurze Biografie oder Beschreibung...',
		'About': 'Über mich',
		'Access Granted': 'Zugriff gewährt',
		'Access Key ID': 'Access Key ID',
		'Account': 'Konto',
		'Account Status': 'Kontostatus',
		'Action': 'Aktion',
		'Action Types': 'Aktionstypen',
		'Action URL (optional)': 'Aktions-URL (optional)',
		'Actions': 'Aktionen',
		'Activation Email': 'Aktivierungs-E-Mail',
		'Active': 'Aktiv',
		'Active Sessions': 'Aktive Sitzungen',
		'Add Link': 'Link hinzufügen',
		'Add a passkey to sign in without a password.': 'Fügen Sie einen Passkey hinzu, um sich ohne Passwort anzumelden.',
		'Add an extra layer of security using a TOTP authenticator app.': 'Fügen Sie eine zusätzliche Sicherheitsebene mit einer TOTP-Authenticator-App hinzu.',
		'Add external links that appear in the application sidebar for all users. Upload an icon image (128×128 PNG) and set the order to control placement alongside registered applications.': 'Fügen Sie externe Links hinzu, die in der Seitenleiste für alle Benutzer angezeigt werden. Laden Sie ein Icon-Bild (128×128 PNG) hoch und legen Sie die Reihenfolge fest.',
		'Add passkey': 'Passkey hinzufügen',
		'Added': 'Hinzugefügt',
		'Admin': 'Admin',
		'Admin Notes': 'Admin-Notizen',
		'Administration': 'Administration',
		'Administrator': 'Administrator',
		'Administrators': 'Administratoren',
		'Admins': 'Admins',
		'All Actions': 'Alle Aktionen',
		'All Roles': 'Alle Rollen',
		'All Statuses': 'Alle Status',
		'All Users (active + imported)': 'Alle Benutzer (aktiv + importiert)',
		'All apps': 'Alle Apps',
		'All auth types': 'Alle Authentifizierungstypen',
		'All caught up!': 'Alles erledigt!',
		'All rights reserved.': 'Alle Rechte vorbehalten.',
		'All sessions revoked.': 'Alle Sitzungen widerrufen.',
		'All statuses': 'Alle Status',
		'All users (active + imported)': 'Alle Benutzer (aktiv + importiert)',
		'Allow Duplicate Emails': 'Doppelte E-Mail-Adressen erlauben',
		'Allowed redirect domains for authorization. One URL per line.': 'Erlaubte Weiterleitungsdomains für die Autorisierung. Eine URL pro Zeile.',
		'Already exist': 'Bereits vorhanden',
		'Already exist (skipped):': 'Bereits vorhanden (übersprungen):',
		'Already have an account?': 'Bereits ein Konto?',
		'Always Visible': 'Immer sichtbar',
		'Amount': 'Betrag',
		'Amt': 'Anz.',
		'Analytics': 'Statistiken',
		'Apple Key ID': 'Apple Key ID',
		'Apple Private Key (.p8)': 'Apple Private Key (.p8)',
		'Apple Services ID': 'Apple Services ID',
		'Apple sign-in failed. Please try again.': 'Apple-Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
		'Apple sign-up failed. Please try again.': 'Apple-Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
		'Apple Team ID': 'Apple Team ID',
		'Application': 'Anwendung',
		'Application (client) ID': 'Anwendungs-ID (Client)',
		'Application Created': 'Anwendung erstellt',
		'Application Deleted': 'Anwendung gelöscht',
		'Application Name': 'Anwendungsname',
		'Application Updated': 'Anwendung aktualisiert',
		'Application Usage': 'Anwendungsnutzung',
		'Application name is required.': 'Anwendungsname ist erforderlich.',
		'Application not found or is no longer active.': 'Anwendung nicht gefunden oder nicht mehr aktiv.',
		'Application updated successfully.': 'Anwendung erfolgreich aktualisiert.',
		'Applications': 'Anwendungen',
		'Applications:': 'Anwendungen:',
		'Apply Crop': 'Zuschnitt anwenden',
		'Apps you’re registered with': 'Apps, bei denen Sie registriert sind',
		'Are you sure?': 'Sind Sie sicher?',
		'Assign CSV columns to user fields. <strong>Email</strong> is required.': 'Ordnen Sie CSV-Spalten den Benutzerfeldern zu. <strong>E-Mail</strong> ist erforderlich.',
		'At least 8 characters': 'Mindestens 8 Zeichen',
		'Audience': 'Zielgruppe',
		'Audience:': 'Zielgruppe:',
		'Audit Entries': 'Audit-Einträge',
		'Audit Logs': 'Audit-Protokolle',
		'Audit Trail': 'Audit-Verlauf',
		'Auth Provider': 'Authentifizierungsanbieter',
		'Authentication': 'Authentifizierung',
		'Authorization Successful': 'Autorisierung erfolgreich',
		'Authorization URLs': 'Autorisierungs-URLs',
		'Authorization failed. Please try again.': 'Autorisierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
		'Authorize': 'Autorisieren',
		'Authorized': 'Autorisiert',
		'Auto-Approve': 'Automatisch genehmigen',
		'Auto-Approve Users': 'Benutzer automatisch genehmigen',
		'Auto-approve': 'Automatisch genehmigen',
		'Available Tokens': 'Verfügbare Token',
		'Available placeholders:': 'Verfügbare Platzhalter:',
		'Avatar removed.': 'Avatar entfernt.',
		'Avatar uploaded.': 'Avatar hochgeladen.',
		'Avg. interval per email': 'Durchschn. Intervall pro E-Mail',
		'Awaiting Approval': 'Genehmigung ausstehend',
		'Already Authorized': 'Bereits autorisiert',
		'Back': 'Zurück',
		'Back to Applications': 'Zurück zu Anwendungen',
		'Back to Newsletters': 'Zurück zu Newslettern',
		'Back to Users': 'Zurück zu Benutzern',
		'Back to inline preview': 'Zurück zur Inline-Vorschau',
		'Back to sign in': 'Zurück zur Anmeldung',
		'Backup Codes': 'Backup-Codes',
		'Backup code': 'Backup-Code',
		'Bal': 'Saldo',
		'Balance': 'Guthaben',
		'Base URL for accessing files publicly. If empty, uses the default path.': 'Basis-URL für den öffentlichen Dateizugriff. Wenn leer, wird der Standardpfad verwendet.',
		'Basic Information': 'Grundlegende Informationen',
		'Batch Configuration & Timing': 'Batch-Konfiguration & Timing',
		'Bio or description...': 'Biografie oder Beschreibung...',
		'Blacklisted IPs': 'Gesperrte IPs',
		'Body:': 'Inhalt:',
		'Bonus': 'Bonus',
		'Bounced Recipients Excluded': 'Zurückgewiesene Empfänger ausgeschlossen',
		'Bounced users excluded': 'Zurückgewiesene Benutzer ausgeschlossen',
		'Branding text and links shown on the login and registration pages.': 'Branding-Text und Links auf den Anmelde- und Registrierungsseiten.',
		'Brief description (optional)': 'Kurzbeschreibung (optional)',
		'Brief description of the application...': 'Kurzbeschreibung der Anwendung...',
		'Brief description...': 'Kurzbeschreibung...',
		'Bucket Name': 'Bucket Name',
		'CIDR notation, comma-separated.': 'CIDR-Notation, kommagetrennt.',
		'Cache TTL (seconds)': 'Cache-TTL (Sekunden)',
		'Campaign Details': 'Kampagnendetails',
		'Campaign Name': 'Kampagnenname',
		'Cancel': 'Abbrechen',
		'Cancelled': 'Abgebrochen',
		'Category': 'Kategorie',
		'Category IDs': 'Kategorie-IDs',
		'Change Password': 'Passwort ändern',
		'Changing...': 'Wird geändert...',
		'Check your email': 'Prüfen Sie Ihre E-Mails',
		'Checking for existing users…': 'Prüfe auf vorhandene Benutzer…',
		'Choose a new password.': 'Wählen Sie ein neues Passwort.',
		'City, Country': 'Stadt, Land',
		'Clear': 'Löschen',
		'Click Rate': 'Klickrate',
		'Click the link in the email to verify your account. If you don\'t see it, check your spam folder.': 'Klicken Sie auf den Link in der E-Mail, um Ihr Konto zu verifizieren. Prüfen Sie ggf. Ihren Spam-Ordner.',
		'Clicks': 'Klicks',
		'Client Secret': 'Client Secret',
		'Close': 'Schließen',
		'Close Preview': 'Vorschau schließen',
		'Comma-separated IPs or CIDRs': 'Kommagetrennte IPs oder CIDRs',
		'Comma-separated WordPress category IDs. Leave empty to show all categories.': 'Kommagetrennte WordPress-Kategorie-IDs. Leer lassen, um alle Kategorien anzuzeigen.',
		'Comma-separated. Evaluated after whitelist.': 'Kommagetrennt. Wird nach der Whitelist ausgewertet.',
		'Common ports: 587 (STARTTLS), 465 (TLS), 25 (plain).': 'Übliche Ports: 587 (STARTTLS), 465 (TLS), 25 (unverschlüsselt).',
		'Company': 'Firma',
		'Company name': 'Firmenname',
		'Completing sign-in…': 'Anmeldung wird abgeschlossen…',
		'Configure a Services ID and signing key to show the "Sign in with Apple" button on the login page.': 'Konfigurieren Sie eine Services-ID und einen Signaturschlüssel, um den „Mit Apple anmelden“-Button auf der Anmeldeseite anzuzeigen.',
		'Configure an Entra ID app registration to show the "Sign in with Microsoft" button on the login page.': 'Konfigurieren Sie eine Entra-ID-App-Registrierung, um den „Mit Microsoft anmelden“-Button auf der Anmeldeseite anzuzeigen.',
		'Configure Google OAuth 2.0 to show the "Sign in with Google" button on the login page.': 'Konfigurieren Sie Google OAuth 2.0, um den „Mit Google anmelden"-Button auf der Anmeldeseite anzuzeigen.',
		'Configure an S3-compatible storage backend for file uploads (AWS S3, MinIO, DigitalOcean Spaces, etc.).': 'Konfigurieren Sie ein S3-kompatibles Speicher-Backend für Datei-Uploads (AWS S3, MinIO, DigitalOcean Spaces usw.).',
		'Confirm': 'Bestätigen',
		'Confirm Disable': 'Deaktivierung bestätigen',
		'Confirm Import': 'Import bestätigen',
		'Confirm Password': 'Passwort bestätigen',
		'Confirm new password': 'Neues Passwort bestätigen',
		'Confirm password': 'Passwort bestätigen',
		'Contact Details': 'Kontaktdaten',
		'Content': 'Inhalt',
		'Continue': 'Weiter',
		'Continue to': 'Weiter zu',
		'Continue to Dashboard': 'Weiter zum Dashboard',
		'Continue with Apple': 'Weiter mit Apple',
		'Continue with Google': 'Weiter mit Google',
		'Continue with Microsoft': 'Weiter mit Microsoft',
		'Copied to clipboard': 'In die Zwischenablage kopiert',
		'Copy the token below and paste it into': 'Kopieren Sie den Token unten und fügen Sie ihn ein in',
		'Copy to Clipboard': 'In die Zwischenablage kopieren',
		'Could not detect a WordPress REST API at this URL.': 'WordPress REST API konnte unter dieser URL nicht erkannt werden.',
		'Count': 'Anzahl',
		'Create Application': 'Anwendung erstellen',
		'Create Newsletter': 'Newsletter erstellen',
		'Create Password': 'Passwort erstellen',
		'Create Role': 'Rolle erstellen',
		'Create Template': 'Vorlage erstellen',
		'Create User': 'Benutzer erstellen',
		'Create a Password': 'Passwort erstellen',
		'Create account': 'Konto erstellen',
		'Create an account': 'Konto erstellen',
		'Create credentials at': 'Anmeldedaten erstellen unter',
		'Create, manage and send newsletter campaigns.': 'Newsletter-Kampagnen erstellen, verwalten und versenden.',
		'Created': 'Erstellt',
		'Creating...': 'Wird erstellt...',
		'Credentials & Preview': 'Zugangsdaten & Vorschau',
		'Credit': 'Gutschrift',
		'Crop Profile Picture': 'Profilbild zuschneiden',
		'Current': 'Aktuell',
		'Current Balance': 'Aktuelles Guthaben',
		'Current Password': 'Aktuelles Passwort',
		'Current:': 'Aktuell:',
		'Custom Sidebar Links': 'Benutzerdefinierte Seitenleisten-Links',
		'Dark': 'Dunkel',
		'Dark Mode': 'Dunkelmodus',
		'Dashboard': 'Dashboard',
		'Database': 'Datenbank',
		'Date': 'Datum',
		'Debit': 'Abbuchung',
		'Default Email Master Template': 'Standard-E-Mail-Mastervorlage',
		'Define access roles': 'Zugriffsrollen definieren',
		'Define access roles and assign them to users or applications.': 'Zugriffsrollen definieren und Benutzern oder Anwendungen zuweisen.',
		'Delete': 'Löschen',
		'Delivery': 'Zustellung',
		'Deny': 'Ablehnen',
		'Description': 'Beschreibung',
		'Description (optional)': 'Beschreibung (optional)',
		'Details': 'Details',
		'Detect': 'Erkennen',
		'Detecting...': 'Wird erkannt...',
		'Devices and browsers where you\'re currently signed in.': 'Geräte und Browser, bei denen Sie derzeit angemeldet sind.',
		'Didn\'t receive the email?': 'E-Mail nicht erhalten?',
		'Directory (tenant) ID': 'Verzeichnis-ID (Mandant)',
		'Disable 2FA': '2FA deaktivieren',
		'Dismiss': 'Verwerfen',
		'Display a WordPress news feed on the non-admin user dashboard.': 'WordPress-Newsfeed auf dem Benutzer-Dashboard anzeigen.',
		'Display name for the website link on auth pages.': 'Anzeigename für den Website-Link auf Authentifizierungsseiten.',
		'Display name next to the sender address.': 'Anzeigename neben der Absenderadresse.',
		'Doe': 'Doe',
		'Done': 'Fertig',
		'Draft': 'Entwurf',
		'Edit': 'Bearbeiten',
		'Edit Application': 'Anwendung bearbeiten',
		'Edit Newsletter': 'Newsletter bearbeiten',
		'Edit Role': 'Rolle bearbeiten',
		'Edit Template': 'Vorlage bearbeiten',
		'Edit User': 'Benutzer bearbeiten',
		'Edit your account details': 'Bearbeiten Sie Ihre Kontodaten',
		'Eligible users': 'Berechtigte Benutzer',
		'Email': 'E-Mail',
		'Email OTP Requested': 'E-Mail-OTP angefordert',
		'Email Template Preview': 'E-Mail-Vorlagenvorschau',
		'Email Templates': 'E-Mail-Vorlagen',
		'Email Unverified': 'E-Mail nicht verifiziert',
		'Email Verified': 'E-Mail verifiziert',
		'Email address and verification status': 'E-Mail-Adresse und Verifizierungsstatus',
		'Email address updated successfully.': 'E-Mail-Adresse erfolgreich aktualisiert.',
		'Email is required.': 'E-Mail ist erforderlich.',
		'Email subject line...': 'E-Mail-Betreffzeile...',
		'Emails Sent': 'E-Mails gesendet',
		'Emails Sent This Year': 'Gesendete E-Mails dieses Jahr',
		'Emails This Month': 'E-Mails diesen Monat',
		'Emails This Week': 'E-Mails diese Woche',
		'Emails per batch': 'E-Mails pro Batch',
		'Enable 2FA': '2FA aktivieren',
		'Enable News Feed': 'Newsfeed aktivieren',
		'Enable for port 465. For 587 with STARTTLS leave this off.': 'Für Port 465 aktivieren. Für 587 mit STARTTLS deaktiviert lassen.',
		'Endpoint URL': 'Endpoint URL',
		'Enter a TOTP code or backup code to disable two-factor authentication.': 'Geben Sie einen TOTP-Code oder Backup-Code ein, um die Zwei-Faktor-Authentifizierung zu deaktivieren.',
		'Enter a domain or URL — click': 'Geben Sie eine Domain oder URL ein — klicken Sie',
		'Enter it below.': 'Geben Sie ihn unten ein.',
		'Enter one of your backup codes. Each code can only be used once.': 'Geben Sie einen Ihrer Backup-Codes ein. Jeder Code kann nur einmal verwendet werden.',
		'Enter reset code': 'Zurücksetzungscode eingeben',
		'Enter the 6-digit code from your authenticator to complete setup:': 'Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein, um die Einrichtung abzuschließen:',
		'Enter the 6-digit code from your email:': 'Geben Sie den 6-stelligen Code aus Ihrer E-Mail ein:',
		'Enter the 6-digit code sent to': 'Geben Sie den 6-stelligen Code ein, der gesendet wurde an',
		'Enter the code from your authenticator app.': 'Geben Sie den Code aus Ihrer Authenticator-App ein.',
		'Enter the code sent to your email.': 'Geben Sie den Code ein, der an Ihre E-Mail gesendet wurde.',
		'Enter the email address to send a test message to.': 'Geben Sie die E-Mail-Adresse ein, an die eine Testnachricht gesendet werden soll.',
		'Enter your email and we\'ll send you a reset code.': 'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Zurücksetzungscode.',
		'Enter your email to get started.': 'Geben Sie Ihre E-Mail-Adresse ein, um zu beginnen.',
		'Environment': 'Umgebung',
		'Error': 'Fehler',
		'Estimated duration': 'Geschätzte Dauer',
		'Failed': 'Fehlgeschlagen',
		'Failed to cancel newsletter': 'Newsletter konnte nicht abgebrochen werden',
		'Failed to change password': 'Passwort konnte nicht geändert werden',
		'Failed to create application': 'Anwendung konnte nicht erstellt werden',
		'Failed to create user': 'Benutzer konnte nicht erstellt werden',
		'Failed to delete application': 'Anwendung konnte nicht gelöscht werden',
		'Failed to delete avatar': 'Avatar konnte nicht gelöscht werden',
		'Failed to delete icon': 'Icon konnte nicht gelöscht werden',
		'Failed to delete logo': 'Logo konnte nicht gelöscht werden',
		'Failed to delete newsletter': 'Newsletter konnte nicht gelöscht werden',
		'Failed to delete notification': 'Benachrichtigung konnte nicht gelöscht werden',
		'Failed to delete passkey': 'Passkey konnte nicht gelöscht werden',
		'Failed to delete role': 'Rolle konnte nicht gelöscht werden',
		'Failed to delete template': 'Vorlage konnte nicht gelöscht werden',
		'Failed to disable 2FA': '2FA konnte nicht deaktiviert werden',
		'Failed to load admin statistics': 'Admin-Statistiken konnten nicht geladen werden',
		'Failed to load analytics': 'Statistiken konnten nicht geladen werden',
		'Failed to load application': 'Anwendung konnte nicht geladen werden',
		'Failed to load applications': 'Anwendungen konnten nicht geladen werden',
		'Failed to load audit logs': 'Audit-Protokolle konnten nicht geladen werden',
		'Failed to load data': 'Daten konnten nicht geladen werden',
		'Failed to load image.': 'Bild konnte nicht geladen werden.',
		'Failed to load newsletters': 'Newsletter konnten nicht geladen werden',
		'Failed to load notifications': 'Benachrichtigungen konnten nicht geladen werden',
		'Failed to load passkeys': 'Passkeys konnten nicht geladen werden',
		'Failed to load preview': 'Vorschau konnte nicht geladen werden',
		'Failed to load preview.': 'Vorschau konnte nicht geladen werden.',
		'Failed to load profile': 'Profil konnte nicht geladen werden',
		'Failed to load profile.': 'Profil konnte nicht geladen werden.',
		'Failed to load roles': 'Rollen konnten nicht geladen werden',
		'Failed to load server preview': 'Servervorschau konnte nicht geladen werden',
		'Failed to load sessions': 'Sitzungen konnten nicht geladen werden',
		'Failed to load settings': 'Einstellungen konnten nicht geladen werden',
		'Failed to load staging data.': 'Staging-Daten konnten nicht geladen werden.',
		'Failed to load templates': 'Vorlagen konnten nicht geladen werden',
		'Failed to load transactions': 'Transaktionen konnten nicht geladen werden',
		'Failed to load user': 'Benutzer konnte nicht geladen werden',
		'Failed to mark all as read': 'Alle als gelesen markieren fehlgeschlagen',
		'Failed to mark as read': 'Als gelesen markieren fehlgeschlagen',
		'Failed to pause newsletter': 'Newsletter konnte nicht pausiert werden',
		'Failed to record transaction': 'Transaktion konnte nicht erfasst werden',
		'Failed to register passkey': 'Passkey konnte nicht registriert werden',
		'Failed to rename passkey': 'Passkey konnte nicht umbenannt werden',
		'Failed to resend.': 'Erneutes Senden fehlgeschlagen.',
		'Failed to reset password. Please try again.': 'Passwort konnte nicht zurückgesetzt werden. Bitte versuchen Sie es erneut.',
		'Failed to resume newsletter': 'Newsletter konnte nicht fortgesetzt werden',
		'Failed to revoke session': 'Sitzung konnte nicht widerrufen werden',
		'Failed to revoke sessions': 'Sitzungen konnten nicht widerrufen werden',
		'Failed to revoke sessions.': 'Sitzungen konnten nicht widerrufen werden.',
		'Failed to save SMTP settings': 'SMTP-Einstellungen konnten nicht gespeichert werden',
		'Failed to save newsletter': 'Newsletter konnte nicht gespeichert werden',
		'Failed to save profile': 'Profil konnte nicht gespeichert werden',
		'Failed to save role': 'Rolle konnte nicht gespeichert werden',
		'Failed to save security settings': 'Sicherheitseinstellungen konnten nicht gespeichert werden',
		'Failed to save settings': 'Einstellungen konnten nicht gespeichert werden',
		'Failed to save template': 'Vorlage konnte nicht gespeichert werden',
		'Failed to send code. Please try again.': 'Code konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
		'Failed to send newsletter.': 'Newsletter konnte nicht gesendet werden.',
		'Failed to send notification': 'Benachrichtigung konnte nicht gesendet werden',
		'Failed to send reset email. Please try again.': 'Zurücksetzungs-E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
		'Failed to send test email': 'Test-E-Mail konnte nicht gesendet werden',
		'Failed to send test email.': 'Test-E-Mail konnte nicht gesendet werden.',
		'Failed to send verification code': 'Verifizierungscode konnte nicht gesendet werden',
		'Failed to start 2FA setup': '2FA-Einrichtung konnte nicht gestartet werden',
		'Failed to update application': 'Anwendung konnte nicht aktualisiert werden',
		'Failed to update user': 'Benutzer konnte nicht aktualisiert werden',
		'Failed to upload avatar': 'Avatar konnte nicht hochgeladen werden',
		'Failed to upload icon': 'Icon konnte nicht hochgeladen werden',
		'Failed to upload logo': 'Logo konnte nicht hochgeladen werden',
		'Feed URL': 'Feed-URL',
		'Filtered by Application': 'Gefiltert nach Anwendung',
		'Filtered by application': 'Gefiltert nach Anwendung',
		'Filters': 'Filter',
		'First Name': 'Vorname',
		'First name': 'Vorname',
		'First name is required.': 'Vorname ist erforderlich.',
		'Follow Abstract on Twitter': 'Folgen Sie Abstract auf Twitter',
		'Forgot Password': 'Passwort vergessen',
		'Forgot password?': 'Passwort vergessen?',
		'Found in the top-right of the Apple Developer portal.': 'Oben rechts im Apple Developer Portal zu finden.',
		'Framework': 'Framework',
		'From Email': 'Absender-E-Mail',
		'From Name': 'Absendername',
		'General': 'Allgemein',
		'General Settings': 'Allgemeine Einstellungen',
		'Get started in seconds — it\'s free.': 'Starten Sie in Sekunden — kostenlos.',
		'Give your passkey a name to identify it later (e.g. "MacBook Touch ID").': 'Geben Sie Ihrem Passkey einen Namen zur späteren Identifizierung (z.B. „MacBook Touch ID").',
		'Global': 'Global',
		'Global only': 'Nur global',
		'Go to Dashboard': 'Zum Dashboard',
		'Go to sign in': 'Zur Anmeldung',
		'Good afternoon': 'Guten Tag',
		'Good evening': 'Guten Abend',
		'Good morning': 'Guten Morgen',
		'Google Client ID': 'Google Client ID',
		'Google Client Secret': 'Google Client Secret',
		'Google Sign-In': 'Google-Anmeldung',
		'Google sign-in failed. Please try again.': 'Google-Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
		'Google sign-up failed. Please try again.': 'Google-Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
		'HTML Content': 'HTML-Inhalt',
		'Has password': 'Hat Passwort',
		'Hello Jane!...': 'Hallo Jane!...',
		'Hide password': 'Passwort verbergen',
		'How long to cache feed results server-side. Default: 900 (15 minutes).': 'Wie lange Feed-Ergebnisse serverseitig gecacht werden. Standard: 900 (15 Minuten).',
		'I\'ve saved my codes': 'Ich habe meine Codes gespeichert',
		'ID': 'ID',
		'Identifier of the .p8 key enabled for Sign in with Apple.': 'Kennung des für „Mit Apple anmelden“ aktivierten .p8-Schlüssels.',
		'IP Access Control': 'IP-Zugriffskontrolle',
		'IP Address': 'IP-Adresse',
		'IP Restrictions': 'IP-Beschränkungen',
		'Icon (Font Awesome class)': 'Icon (Font Awesome-Klasse)',
		'Icon Image': 'Icon-Bild',
		'Icon removed.': 'Icon entfernt.',
		'Icon uploaded.': 'Icon hochgeladen.',
		'Identity, simplified.': 'Identität, vereinfacht.',
		'Import': 'Import',
		'Import Users': 'Benutzer importieren',
		'Import failed': 'Import fehlgeschlagen',
		'Imported': 'Importiert',
		'Imported users will be created as dormant accounts (authProvider = \'imported\'). They can receive newsletters and log in via email OTP without needing to register separately.': 'Importierte Benutzer werden als ruhende Konten erstellt (authProvider = \'imported\'). Sie können Newsletter empfangen und sich per E-Mail-OTP anmelden, ohne sich separat registrieren zu müssen.',
		'Importing…': 'Wird importiert…',
		'Inactive': 'Inaktiv',
		'Increase security by creating a password for your account.': 'Erhöhen Sie die Sicherheit, indem Sie ein Passwort für Ihr Konto erstellen.',
		'Info': 'Info',
		'Inline newsletter preview': 'Inline-Newsletter-Vorschau',
		'Insert token:': 'Token einfügen:',
		'Internal notes (only visible to admins)...': 'Interne Notizen (nur für Admins sichtbar)...',
		'Interval between batches': 'Intervall zwischen Batches',
		'Invalid': 'Ungültig',
		'Invalid (skipped):': 'Ungültig (übersprungen):',
		'Invalid application ID.': 'Ungültige Anwendungs-ID.',
		'Invalid code. Please try again.': 'Ungültiger Code. Bitte versuchen Sie es erneut.',
		'Invalid newsletter ID.': 'Ungültige Newsletter-ID.',
		'Invalid or expired code': 'Ungültiger oder abgelaufener Code',
		'Invalid or expired code.': 'Ungültiger oder abgelaufener Code.',
		'Invalid user ID.': 'Ungültige Benutzer-ID.',
		'John': 'John',
		'Join Abstract on Discord': 'Treten Sie Abstract auf Discord bei',
		'Joined': 'Beigetreten',
		'Label': 'Bezeichnung',
		'Language': 'Sprache',
		'Large heading on the auth page branding panel.': 'Große Überschrift auf dem Branding-Panel der Authentifizierungsseite.',
		'Last Login': 'Letzte Anmeldung',
		'Last Name': 'Nachname',
		'Last login:': 'Letzte Anmeldung:',
		'Last name': 'Nachname',
		'Last name is required.': 'Nachname ist erforderlich.',
		'Last used': 'Zuletzt verwendet',
		'Latest News': 'Neueste Nachrichten',
		'Leave all fields empty to use local disk storage.': 'Lassen Sie alle Felder leer, um den lokalen Speicher zu verwenden.',
		'Leave as "None" for a global role that applies across all applications.': 'Belassen Sie es bei „Keine", um eine globale Rolle für alle Anwendungen zu erstellen.',
		'Leave empty for unlimited.': 'Leer lassen für unbegrenzt.',
		'Leave empty to accept any Microsoft account. Set a directory ID to restrict sign-in to one organisation.': 'Leer lassen, um jedes Microsoft-Konto zu akzeptieren. Geben Sie eine Verzeichnis-ID an, um die Anmeldung auf eine Organisation zu beschränken.',
		'Leave empty to auto-generate the plain-text part from the HTML body.': 'Leer lassen, um den Nur-Text-Teil automatisch aus dem HTML-Text zu erzeugen.',
		'Leave empty to disable Google Sign-In.': 'Leer lassen, um Google-Anmeldung zu deaktivieren.',
		'Leave empty to disable Sign in with Apple.': 'Leer lassen, um die Apple-Anmeldung zu deaktivieren.',
		'Leave empty to disable Sign in with Microsoft.': 'Leer lassen, um die Microsoft-Anmeldung zu deaktivieren.',
		'Light': 'Hell',
		'Link icon': 'Link-Icon',
		'Linked from login/register pages and emails.': 'Verlinkt auf Anmelde-/Registrierungsseiten und in E-Mails.',
		'Linked on login and registration pages.': 'Verlinkt auf Anmelde- und Registrierungsseiten.',
		'Live Preview': 'Live-Vorschau',
		'Loading audit logs…': 'Audit-Protokolle werden geladen…',
		'Loading notifications...': 'Benachrichtigungen werden geladen...',
		'Loading notifications…': 'Benachrichtigungen werden geladen…',
		'Loading roles...': 'Rollen werden geladen...',
		'Loading…': 'Wird geladen…',
		'Location': 'Standort',
		'Login Heading': 'Anmelde-Überschrift',
		'Login Subheading': 'Anmelde-Unterüberschrift',
		'Login failed. Please try again.': 'Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
		'Logins (24h)': 'Anmeldungen (24h)',
		'Logo Image': 'Logo-Bild',
		'Logo removed.': 'Logo entfernt.',
		'Logo uploaded.': 'Logo hochgeladen.',
		'Manage Users': 'Benutzer verwalten',
		'Manage active sessions': 'Aktive Sitzungen verwalten',
		'Manage passkey credentials': 'Passkey-Zugangsdaten verwalten',
		'Manage user accounts and permissions': 'Benutzerkonten und Berechtigungen verwalten',
		'Map Columns': 'Spalten zuordnen',
		'Mark all as read': 'Alle als gelesen markieren',
		'Mark as read': 'Als gelesen markieren',
		'Master Template': 'Mastervorlage',
		'Master Template:': 'Mastervorlage:',
		'Max Forgot-Password Requests': 'Max. Passwort-vergessen-Anfragen',
		'Max Reset-Password Attempts': 'Max. Passwort-Zurücksetzungsversuche',
		'Media': 'Medien',
		'Message (optional)': 'Nachricht (optional)',
		'Microsoft sign-in failed. Please try again.': 'Microsoft-Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
		'Microsoft sign-up failed. Please try again.': 'Microsoft-Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
		'Migration Contact Email': 'Migrations-Kontakt-E-Mail',
		'Must be 3–30 characters (letters, numbers, underscores).': 'Muss 3–30 Zeichen lang sein (Buchstaben, Zahlen, Unterstriche).',
		'Must be at least 8 characters.': 'Muss mindestens 8 Zeichen lang sein.',
		'Must match a Return URL registered on the Services ID exactly.': 'Muss exakt mit einer bei der Services-ID registrierten Rückgabe-URL übereinstimmen.',
		'My Application': 'Meine Anwendung',
		'My Applications': 'Meine Anwendungen',
		'My Apps': 'Meine Apps',
		'My Passkey': 'Mein Passkey',
		'My Profile': 'Mein Profil',
		'Name': 'Name',
		'Name your passkey': 'Benennen Sie Ihren Passkey',
		'Name, username, and avatar': 'Name, Benutzername und Avatar',
		'Never': 'Nie',
		'Never used': 'Nie verwendet',
		'New Application': 'Neue Anwendung',
		'New Newsletter': 'Neuer Newsletter',
		'New Password': 'Neues Passwort',
		'New Role': 'Neue Rolle',
		'New Template': 'Neue Vorlage',
		'New email address': 'Neue E-Mail-Adresse',
		'New password': 'Neues Passwort',
		'New password is required.': 'Neues Passwort ist erforderlich.',
		'New passwords do not match.': 'Die neuen Passwörter stimmen nicht überein.',
		'New username': 'Neuer Benutzername',
		'New users': 'Neue Benutzer',
		'New users to import:': 'Neue Benutzer zum Import:',
		'News Feed': 'Newsfeed',
		'Newsletter Cancelled': 'Newsletter abgebrochen',
		'Newsletter Created': 'Newsletter erstellt',
		'Newsletter Deleted': 'Newsletter gelöscht',
		'Newsletter Paused': 'Newsletter pausiert',
		'Newsletter Preview': 'Newsletter-Vorschau',
		'Newsletter Resumed': 'Newsletter fortgesetzt',
		'Newsletter Sent': 'Newsletter gesendet',
		'Newsletter Started': 'Newsletter gestartet',
		'Newsletter Updated': 'Newsletter aktualisiert',
		'Newsletter cancelled.': 'Newsletter abgebrochen.',
		'Newsletter created.': 'Newsletter erstellt.',
		'Newsletter default': 'Newsletter-Standard',
		'Newsletter deleted.': 'Newsletter gelöscht.',
		'Newsletter dispatch started.': 'Newsletter-Versand gestartet.',
		'Newsletter paused.': 'Newsletter pausiert.',
		'Newsletter preview': 'Newsletter-Vorschau',
		'Newsletter resumed.': 'Newsletter fortgesetzt.',
		'Newsletter updated.': 'Newsletter aktualisiert.',
		'Newsletters': 'Newsletter',
		'Next': 'Weiter',
		'No Backend Response': 'Keine Backend-Antwort',
		'No Recipients': 'Keine Empfänger',
		'No active sessions.': 'Keine aktiven Sitzungen.',
		'No application registrations yet.': 'Noch keine Anwendungsregistrierungen.',
		'No applications configured.': 'Keine Anwendungen konfiguriert.',
		'No applications found.': 'Keine Anwendungen gefunden.',
		'No applications match your filters': 'Keine Anwendungen entsprechen Ihren Filtern',
		'No applications registered yet': 'Noch keine Anwendungen registriert',
		'No applications registered.': 'Keine Anwendungen registriert.',
		'No audit logs found.': 'Keine Audit-Protokolle gefunden.',
		'No email templates yet': 'Noch keine E-Mail-Vorlagen',
		'No master template': 'Keine Mastervorlage',
		'No new users to import. All valid email addresses already exist in the system.': 'Keine neuen Benutzer zum Import. Alle gültigen E-Mail-Adressen existieren bereits im System.',
		'No newsletters found.': 'Keine Newsletter gefunden.',
		'No notifications yet.': 'Noch keine Benachrichtigungen.',
		'No passkeys registered yet.': 'Noch keine Passkeys registriert.',
		'No password — signs in via email OTP': 'Kein Passwort — Anmeldung per E-Mail-OTP',
		'No recipients match the audience criteria. Adjust the audience settings before sending.': 'Keine Empfänger entsprechen den Zielgruppenkriterien. Passen Sie die Zielgruppeneinstellungen vor dem Versand an.',
		'No roles defined yet': 'Noch keine Rollen definiert',
		'No roles defined yet.': 'Noch keine Rollen definiert.',
		'No roles match your filters': 'Keine Rollen entsprechen Ihren Filtern',
		'No settings found.': 'Keine Einstellungen gefunden.',
		'No settings found. Save defaults to create the settings row.': 'Keine Einstellungen gefunden. Speichern Sie die Standardwerte, um den Einstellungsdatensatz zu erstellen.',
		'No subject yet': 'Noch kein Betreff',
		'No templates match your filters': 'Keine Vorlagen entsprechen Ihren Filtern',
		'No transactions yet.': 'Noch keine Transaktionen.',
		'No users found': 'Keine Benutzer gefunden',
		'No users match your filters': 'Keine Benutzer entsprechen Ihren Filtern',
		'No, cancel': 'Nein, abbrechen',
		'Non-Registered Redirect URL': 'Weiterleitungs-URL für nicht registrierte Benutzer',
		'None': 'Keine',
		'None (Global)': 'Keine (Global)',
		'Not configured': 'Nicht konfiguriert',
		'Nothing here yet': 'Noch nichts vorhanden',
		'Notifications': 'Benachrichtigungen',
		'OAuth': 'OAuth',
		'Open Rate': 'Öffnungsrate',
		'Open your authenticator app and enter the 6-digit code.': 'Öffnen Sie Ihre Authenticator-App und geben Sie den 6-stelligen Code ein.',
		'Opens': 'Öffnungen',
		'Opt out of newsletters': 'Newsletter abbestellen',
		'Opted-out users excluded': 'Abgemeldete Benutzer ausgeschlossen',
		'Optionally register imported users to one or more applications. This step is optional — you can skip it to import users without application registrations.': 'Registrieren Sie importierte Benutzer optional bei einer oder mehreren Anwendungen. Dieser Schritt ist optional — Sie können ihn überspringen.',
		'Or enter manually:': 'Oder manuell eingeben:',
		'Order': 'Reihenfolge',
		'Overview': 'Übersicht',
		'Page Not Found': 'Seite nicht gefunden',
		'Paragraph text below the heading.': 'Absatztext unter der Überschrift.',
		'Passkey deleted.': 'Passkey gelöscht.',
		'Passkey registered successfully!': 'Passkey erfolgreich registriert!',
		'Passkey renamed.': 'Passkey umbenannt.',
		'Passkey sign-in failed. Please try again.': 'Passkey-Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
		'Passkeys': 'Passkeys',
		'Password': 'Passwort',
		'Password Changed': 'Passwort geändert',
		'Password Reset Completed': 'Passwort-Zurücksetzung abgeschlossen',
		'Password Reset Requested': 'Passwort-Zurücksetzung angefordert',
		'Password changed successfully.': 'Passwort erfolgreich geändert.',
		'Password created successfully.': 'Passwort erfolgreich erstellt.',
		'Password is required.': 'Passwort ist erforderlich.',
		'Password must be at least 6 characters.': 'Passwort muss mindestens 6 Zeichen lang sein.',
		'Password must be at least 8 characters.': 'Passwort muss mindestens 8 Zeichen lang sein.',
		'Passwordless': 'Passwortlos',
		'Passwords do not match.': 'Passwörter stimmen nicht überein.',
		'Paste the full contents of the .p8 file downloaded from Apple.': 'Fügen Sie den vollständigen Inhalt der von Apple heruntergeladenen .p8-Datei ein.',
		'Pause': 'Pausieren',
		'Paused': 'Pausiert',
		'Pending': 'Ausstehend',
		'Performed By': 'Ausgeführt von',
		'Personal Information': 'Persönliche Informationen',
		'Plain text version...': 'Nur-Text-Version...',
		'Plain-Text Fallback (optional)': 'Nur-Text-Fallback (optional)',
		'Platform configuration': 'Plattformkonfiguration',
		'Please enter a backup code.': 'Bitte geben Sie einen Backup-Code ein.',
		'Please enter a new password.': 'Bitte geben Sie ein neues Passwort ein.',
		'Please enter a valid code to disable 2FA.': 'Bitte geben Sie einen gültigen Code ein, um 2FA zu deaktivieren.',
		'Please enter a valid email address.': 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
		'Please enter a valid, available username.': 'Bitte geben Sie einen gültigen, verfügbaren Benutzernamen ein.',
		'Please enter the 6-digit verification code.': 'Bitte geben Sie den 6-stelligen Verifizierungscode ein.',
		'Please enter your current password.': 'Bitte geben Sie Ihr aktuelles Passwort ein.',
		'Please wait while we verify your account.': 'Bitte warten Sie, während wir Ihr Konto verifizieren.',
		'Policies': 'Richtlinien',
		'Preferences': 'Einstellungen',
		'Prev': 'Zurück',
		'Preview': 'Vorschau',
		'Preview (first 5 rows)': 'Vorschau (erste 5 Zeilen)',
		'Preview Consent': 'Einwilligungsvorschau',
		'Preview Token Flow': 'Token-Flow-Vorschau',
		'Previous': 'Zurück',
		'Private Key': 'Privater Schlüssel',
		'Profile': 'Profil',
		'Profile Picture': 'Profilbild',
		'Profile updated successfully.': 'Profil erfolgreich aktualisiert.',
		'Public Content': 'Öffentlicher Inhalt',
		'Public URL (optional)': 'Öffentliche URL (optional)',
		'Purchase': 'Kauf',
		'Quick Actions': 'Schnellaktionen',
		'Rate Limiting': 'Anfragelimitierung',
		'Re-enter your new password': 'Neues Passwort erneut eingeben',
		'Re-enter your password': 'Passwort erneut eingeben',
		'Reason': 'Grund',
		'Recent Activity': 'Letzte Aktivität',
		'Recent Notifications': 'Letzte Benachrichtigungen',
		'Recipient Breakdown': 'Empfängerübersicht',
		'Recipient Email': 'Empfänger-E-Mail',
		'Recipients': 'Empfänger',
		'Record': 'Erfassen',
		'Record Transaction': 'Transaktion erfassen',
		'Redirect URI': 'Weiterleitungs-URI',
		'Refresh': 'Aktualisieren',
		'Refresh Stats': 'Statistiken aktualisieren',
		'Refund': 'Erstattung',
		'Region': 'Region',
		'Register again': 'Erneut registrieren',
		'Register and manage applications that use this identity provider.': 'Anwendungen registrieren und verwalten, die diesen Identitätsanbieter nutzen.',
		'Register and manage apps': 'Apps registrieren und verwalten',
		'Register this exact URL as a Web redirect URI on the app. It must end in /auth/microsoft/callback.': 'Registrieren Sie exakt diese URL als Web-Weiterleitungs-URI in der App. Sie muss auf /auth/microsoft/callback enden.',
		'Register to Applications': 'Bei Anwendungen registrieren',
		'Registration failed. Please try again.': 'Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
		'Reload all administration statistics': 'Alle Administrationsstatistiken neu laden',
		'Remove': 'Entfernen',
		'Remove Icon': 'Icon entfernen',
		'Replace Icon': 'Icon ersetzen',
		'Required for server-side token verification.': 'Erforderlich für serverseitige Token-Verifizierung.',
		'Resend code': 'Code erneut senden',
		'Reset Password': 'Passwort zurücksetzen',
		'Reset code is invalid or expired.': 'Zurücksetzungscode ist ungültig oder abgelaufen.',
		'Reset password': 'Passwort zurücksetzen',
		'Resized to 128×128': 'Auf 128×128 skaliert',
		'Resized to 512×512': 'Auf 512×512 skaliert',
		'Resume': 'Fortsetzen',
		'Retry': 'Erneut versuchen',
		'Return URL': 'Rückgabe-URL',
		'Review': 'Überprüfen',
		'Review Data': 'Daten überprüfen',
		'Review system activity and security events': 'Systemaktivität und Sicherheitsereignisse überprüfen',
		'Review the details below before sending this newsletter.': 'Überprüfen Sie die Details unten, bevor Sie diesen Newsletter versenden.',
		'Review the validation results below before importing.': 'Überprüfen Sie die Validierungsergebnisse unten, bevor Sie importieren.',
		'Revoke': 'Widerrufen',
		'Revoke All Sessions': 'Alle Sitzungen widerrufen',
		'Revoke all others': 'Alle anderen widerrufen',
		'Revoking…': 'Wird widerrufen…',
		'Role': 'Rolle',
		'Role Changed': 'Rolle geändert',
		'Role Created': 'Rolle erstellt',
		'Role Deleted': 'Rolle gelöscht',
		'Role Name': 'Rollenname',
		'Role Updated': 'Rolle aktualisiert',
		'Role name is required.': 'Rollenname ist erforderlich.',
		'Roles': 'Rollen',
		'Row': 'Zeile',
		'S3 Storage': 'S3-Speicher',
		'S3-compatible endpoint (e.g. https://s3.amazonaws.com or your MinIO URL).': 'S3-kompatibler Endpoint (z.B. https://s3.amazonaws.com oder Ihre MinIO-URL).',
		'Sign in with Apple': 'Mit Apple anmelden',
		'Sign in with Microsoft': 'Mit Microsoft anmelden',
		'Sign up with Apple': 'Mit Apple registrieren',
		'Sign up with Microsoft': 'Mit Microsoft registrieren',
		'Signing you out…': 'Sie werden abgemeldet…',
		'SMTP': 'SMTP',
		'SMTP Configuration': 'SMTP-Konfiguration',
		'SMTP Host': 'SMTP-Host',
		'SMTP Port': 'SMTP-Port',
		'SMTP Status': 'SMTP-Status',
		'SMTP connection verified successfully.': 'SMTP-Verbindung erfolgreich verifiziert.',
		'SMTP settings saved successfully.': 'SMTP-Einstellungen erfolgreich gespeichert.',
		'SMTP verification failed': 'SMTP-Verifizierung fehlgeschlagen',
		'Save': 'Speichern',
		'Save Changes': 'Änderungen speichern',
		'Save Profile': 'Profil speichern',
		'Save SMTP': 'SMTP speichern',
		'Save Security Settings': 'Sicherheitseinstellungen speichern',
		'Save Settings': 'Einstellungen speichern',
		'Save these codes in a safe place. Each can be used once if you lose your authenticator. They will not be shown again.': 'Bewahren Sie diese Codes an einem sicheren Ort auf. Jeder Code kann einmal verwendet werden, falls Sie Ihren Authenticator verlieren. Sie werden nicht erneut angezeigt.',
		'Saving...': 'Wird gespeichert...',
		'Scan with your authenticator app:': 'Scannen Sie mit Ihrer Authenticator-App:',
		'Scheduled': 'Geplant',
		'Scoped to Application': 'Anwendungsbezogen',
		'Search': 'Suche',
		'Search applications...': 'Anwendungen suchen...',
		'Search by name or email...': 'Nach Name oder E-Mail suchen...',
		'Search logs...': 'Protokolle durchsuchen...',
		'Search name or subject…': 'Name oder Betreff suchen…',
		'Search roles...': 'Rollen suchen...',
		'Search templates...': 'Vorlagen suchen...',
		'Seconds before expiry during which a refresh is allowed. Default 4320 (72 min).': 'Sekunden vor Ablauf, in denen eine Aktualisierung erlaubt ist. Standard: 4320 (72 Min.).',
		'Secret Access Key': 'Secret Access Key',
		'Secret is configured': 'Secret ist konfiguriert',
		'Secure authentication, role management, and user administration — all in one place.': 'Sichere Authentifizierung, Rollenverwaltung und Benutzerverwaltung — alles an einem Ort.',
		'Security': 'Sicherheit',
		'Security & Access Control': 'Sicherheit & Zugriffskontrolle',
		'Security settings saved successfully.': 'Sicherheitseinstellungen erfolgreich gespeichert.',
		'Select…': 'Auswählen…',
		'Send': 'Senden',
		'Send Notification': 'Benachrichtigung senden',
		'Send Test Email': 'Test-E-Mail senden',
		'Send reset code': 'Zurücksetzungscode senden',
		'Send test email': 'Test-E-Mail senden',
		'Sender Identity': 'Absenderidentität',
		'Sending': 'Wird gesendet',
		'Sending...': 'Wird gesendet...',
		'Sent': 'Gesendet',
		'Sent At': 'Gesendet am',
		'Server': 'Server',
		'Server Preview': 'Servervorschau',
		'Server-rendered newsletter preview': 'Serverseitig gerenderte Newsletter-Vorschau',
		'Service Active': 'Dienst aktiv',
		'Session Locations': 'Sitzungsstandorte',
		'Session revoked.': 'Sitzung widerrufen.',
		'Sessions': 'Sitzungen',
		'Settings': 'Einstellungen',
		'Settings Changed': 'Einstellungen geändert',
		'Settings saved successfully.': 'Einstellungen erfolgreich gespeichert.',
		'Show password': 'Passwort anzeigen',
		'Showing': 'Anzeige',
		'Shown during account migration / data transfer.': 'Wird während der Kontomigration / Datenübertragung angezeigt.',
		'Sidebar link icon removed.': 'Seitenleisten-Link-Icon entfernt.',
		'Sidebar link icon uploaded.': 'Seitenleisten-Link-Icon hochgeladen.',
		'Sign Out': 'Abmelden',
		'Sign in': 'Anmelden',
		'Sign in or Register': 'Anmelden oder Registrieren',
		'Sign in securely with fingerprint, face recognition, or security keys.': 'Melden Sie sich sicher mit Fingerabdruck, Gesichtserkennung oder Sicherheitsschlüsseln an.',
		'Sign in to': 'Anmelden bei',
		'Sign in with Google': 'Mit Google anmelden',
		'Sign in with a passkey': 'Mit Passkey anmelden',
		'Sign in with email code instead': 'Stattdessen mit E-Mail-Code anmelden',
		'Sign in with password': 'Mit Passwort anmelden',
		'Sign up with Google': 'Mit Google registrieren',
		'Signups This Week': 'Registrierungen diese Woche',
		'Signups This Year': 'Registrierungen dieses Jahr',
		'Skip': 'Überspringen',
		'Social Account Linked': 'Social-Konto verknüpft',
		'Stack trace': 'Stack-Trace',
		'Start typing HTML content to see a preview': 'Beginnen Sie mit der Eingabe von HTML-Inhalt, um eine Vorschau zu sehen',
		'Status': 'Status',
		'Status & Features': 'Status & Funktionen',
		'Status:': 'Status:',
		'Stay up to date with your account activity': 'Bleiben Sie über Ihre Kontoaktivitäten auf dem Laufenden',
		'Subject': 'Betreff',
		'Subject Line': 'Betreffzeile',
		'Subject:': 'Betreff:',
		'Success': 'Erfolg',
		'Synced': 'Synchronisiert',
		'System': 'System',
		'System Errors': 'Systemfehler',
		'System Information': 'Systeminformationen',
		'Target': 'Ziel',
		'Template': 'Vorlage',
		'Template Name': 'Vorlagenname',
		'Template Preview': 'Vorlagenvorschau',
		'Template created.': 'Vorlage erstellt.',
		'Template deleted.': 'Vorlage gelöscht.',
		'Template name and subject are required.': 'Vorlagenname und Betreff sind erforderlich.',
		'Template updated.': 'Vorlage aktualisiert.',
		'Terms of Service': 'Nutzungsbedingungen',
		'Terms of Service URL': 'URL der Nutzungsbedingungen',
		'Test email sent to your address.': 'Test-E-Mail an Ihre Adresse gesendet.',
		'Text Content (fallback)': 'Textinhalt (Fallback)',
		'The application you were trying to sign in to was not found or is no longer active.': 'Die Anwendung, bei der Sie sich anmelden wollten, wurde nicht gefunden oder ist nicht mehr aktiv.',
		'The master template used by newsletters when no specific template is selected.': 'Die Mastervorlage, die für Newsletter verwendet wird, wenn keine spezifische Vorlage ausgewählt ist.',
		'The page you\'re looking for doesn\'t exist or has been moved.': 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
		'The secret value, not its ID. Secrets expire — note the expiry date.': 'Der Secret-Wert, nicht dessen ID. Secrets laufen ab — notieren Sie das Ablaufdatum.',
		'The sender address in the email From header.': 'Die Absenderadresse im E-Mail-From-Header.',
		'The verification link may have expired. Please try registering again.': 'Der Verifizierungslink ist möglicherweise abgelaufen. Bitte registrieren Sie sich erneut.',
		'Theme': 'Design',
		'This is a preview of the consent page. No authorization will be performed.': 'Dies ist eine Vorschau der Einwilligungsseite. Es wird keine Autorisierung durchgeführt.',
		'This is a preview of the token staging page. In the real flow, the user\'s JWT would appear below.': 'Dies ist eine Vorschau der Token-Staging-Seite. Im echten Ablauf würde das JWT des Benutzers unten erscheinen.',
		'This is a preview. In the real flow, the user would be redirected back to': 'Dies ist eine Vorschau. Im echten Ablauf würde der Benutzer zurückgeleitet zu',
		'This is a preview. No real token was generated.': 'Dies ist eine Vorschau. Es wurde kein echtes Token generiert.',
		'This page is part of the Microsoft sign-in flow and can be closed.': 'Diese Seite gehört zum Microsoft-Anmeldevorgang und kann geschlossen werden.',
		'Time': 'Zeit',
		'Title (required)': 'Titel (erforderlich)',
		'Toggle dark mode': 'Dunkelmodus umschalten',
		'Token & Session': 'Token & Sitzung',
		'Token Flow': 'Token-Flow',
		'Token Flow Preview': 'Token-Flow-Vorschau',
		'Token Refresh Window (seconds)': 'Token-Aktualisierungsfenster (Sekunden)',
		'Token copied to clipboard': 'Token in die Zwischenablage kopiert',
		'Tokens': 'Token',
		'Tokens are replaced per-recipient at send time. The preview shows sample data.': 'Token werden beim Versand pro Empfänger ersetzt. Die Vorschau zeigt Beispieldaten.',
		'Top Clicked URLs': 'Meistgeklickte URLs',
		'Total Recipients': 'Empfänger gesamt',
		'Total Users': 'Benutzer gesamt',
		'Total batches': 'Batches gesamt',
		'Total rows': 'Zeilen gesamt',
		'Two-Factor Authentication': 'Zwei-Faktor-Authentifizierung',
		'Two-factor authentication': 'Zwei-Faktor-Authentifizierung',
		'Two-factor authentication enabled successfully!': 'Zwei-Faktor-Authentifizierung erfolgreich aktiviert!',
		'Two-factor authentication has been disabled.': 'Zwei-Faktor-Authentifizierung wurde deaktiviert.',
		'Type': 'Typ',
		'URL': 'URL',
		'UUID': 'UUID',
		'Unknown device': 'Unbekanntes Gerät',
		'Unlimited': 'Unbegrenzt',
		'Unnamed': 'Unbenannt',
		'Unnamed User': 'Unbenannter Benutzer',
		'Unsubscribes': 'Abmeldungen',
		'Unverified': 'Nicht verifiziert',
		'Updated': 'Aktualisiert',
		'Upload': 'Hochladen',
		'Upload CSV File': 'CSV-Datei hochladen',
		'Upload Icon': 'Icon hochladen',
		'Upload Logo': 'Logo hochladen',
		'Upload a CSV file containing the users you want to import. The first row should contain column headers (e.g. Email, First Name, Last Name).': 'Laden Sie eine CSV-Datei mit den zu importierenden Benutzern hoch. Die erste Zeile sollte Spaltenüberschriften enthalten (z.B. Email, First Name, Last Name).',
		'Upload a square image. It will be resized to 256×256 pixels.': 'Laden Sie ein quadratisches Bild hoch. Es wird auf 256×256 Pixel skaliert.',
		'Uploading…': 'Wird hochgeladen…',
		'Use TLS': 'TLS verwenden',
		'Use a backup code instead': 'Stattdessen Backup-Code verwenden',
		'Use a passkey': 'Passkey verwenden',
		'Use authenticator app instead': 'Stattdessen Authenticator-App verwenden',
		'Use passkey': 'Passkey verwenden',
		'Use password': 'Passwort verwenden',
		'User': 'Benutzer',
		'User Activated': 'Benutzer aktiviert',
		'User Dashboard': 'Benutzer-Dashboard',
		'User Deactivated': 'Benutzer deaktiviert',
		'User Deleted': 'Benutzer gelöscht',
		'User Login': 'Benutzeranmeldung',
		'User Registered': 'Benutzer registriert',
		'User Updated': 'Benutzer aktualisiert',
		'User Verified': 'Benutzer verifiziert',
		'User dashboard settings saved.': 'Benutzer-Dashboard-Einstellungen gespeichert.',
		'User updated successfully.': 'Benutzer erfolgreich aktualisiert.',
		'Username': 'Benutzername',
		'Username updated successfully.': 'Benutzername erfolgreich aktualisiert.',
		'Users': 'Benutzer',
		'Uses the WordPress REST API': 'Verwendet die WordPress REST API',
		'Verification Link Expiry': 'Ablauf des Verifizierungslinks',
		'Verification URLs': 'Verifizierungs-URLs',
		'Verification code sent to your email.': 'Verifizierungscode an Ihre E-Mail gesendet.',
		'Verification failed. The link may be invalid or expired.': 'Verifizierung fehlgeschlagen. Der Link ist möglicherweise ungültig oder abgelaufen.',
		'Verified': 'Verifiziert',
		'Verify': 'Verifizieren',
		'Verify Connection': 'Verbindung verifizieren',
		'Verify your identity': 'Bestätigen Sie Ihre Identität',
		'Verifying your email': 'Ihre E-Mail wird verifiziert',
		'Verifying...': 'Wird verifiziert...',
		'Version': 'Version',
		'View all audit logs': 'Alle Audit-Protokolle anzeigen',
		'View all notifications': 'Alle Benachrichtigungen anzeigen',
		'View and edit accounts': 'Konten anzeigen und bearbeiten',
		'View details': 'Details anzeigen',
		'View transactions & balance': 'Transaktionen & Guthaben anzeigen',
		'View your notifications': 'Ihre Benachrichtigungen anzeigen',
		'View, search, and manage user accounts': 'Benutzerkonten anzeigen, suchen und verwalten',
		'Visible': 'Sichtbar',
		'Visible When Registered': 'Sichtbar wenn registriert',
		'Warning': 'Warnung',
		'Wave': 'Welle',
		'Wave Interval (sec)': 'Wellenintervall (Sek.)',
		'Wave Size': 'Wellengröße',
		'We sent a 6-digit code to': 'Wir haben einen 6-stelligen Code gesendet an',
		'We sent a verification link to': 'Wir haben einen Verifizierungslink gesendet an',
		'We sent a verification link to your email address.': 'Wir haben einen Verifizierungslink an Ihre E-Mail-Adresse gesendet.',
		'We\'ve sent you a verification link.': 'Wir haben Ihnen einen Verifizierungslink gesendet.',
		'Website': 'Webseite',
		'Website Name': 'Webseitenname',
		'Website URL': 'Webseiten-URL',
		'What this role grants access to...': 'Worauf diese Rolle Zugriff gewährt...',
		'When disabled, the feed section is hidden from the user dashboard.': 'Wenn deaktiviert, wird der Feed-Bereich im Benutzer-Dashboard ausgeblendet.',
		'When disabled, the identity service rejects new registrations.': 'Wenn deaktiviert, lehnt der Identitätsdienst neue Registrierungen ab.',
		'When enabled, multiple accounts may share the same email address.': 'Wenn aktiviert, können mehrere Konten dieselbe E-Mail-Adresse verwenden.',
		'When enabled, you won\'t receive promotional emails.': 'Wenn aktiviert, erhalten Sie keine Werbe-E-Mails.',
		'Whitelisted IPs': 'Freigegebene IPs',
		'WordPress REST API detected successfully.': 'WordPress REST API erfolgreich erkannt.',
		'Yes, I\'m sure': 'Ja, ich bin sicher',
		'Yes, confirm': 'Ja, bestätigen',
		'You are not registered with any applications yet.': 'Sie sind noch bei keiner Anwendung registriert.',
		'You have no notifications right now.': 'Sie haben derzeit keine Benachrichtigungen.',
		'Your Account': 'Ihr Konto',
		'Your account is protected with TOTP authenticator.': 'Ihr Konto ist mit TOTP-Authenticator geschützt.',
		'Your assigned roles for this application': 'Ihre zugewiesenen Rollen für diese Anwendung',
		'Your email has been verified! You can now sign in.': 'Ihre E-Mail wurde verifiziert! Sie können sich jetzt anmelden.',
		'Your gateway to the Abstract platform. Manage your identity, applications, and security — all in one place.': 'Ihr Zugang zur Abstract-Plattform. Verwalten Sie Ihre Identität, Anwendungen und Sicherheit — alles an einem Ort.',
		'Your password has been reset successfully.': 'Ihr Passwort wurde erfolgreich zurückgesetzt.',
		'Your request to access': 'Ihre Zugriffsanfrage für',
		"You've previously granted access to": 'Sie haben zuvor Zugriff gewährt an',
		'allow all.': 'alle erlauben.',
		'by': 'von',
		'cancel this newsletter': 'diesen Newsletter abbrechen',
		'delete this application': 'diese Anwendung löschen',
		'delete this icon': 'dieses Icon löschen',
		'delete this logo': 'dieses Logo löschen',
		'delete this newsletter': 'diesen Newsletter löschen',
		'delete this role': 'diese Rolle löschen',
		'delete this template': 'diese Vorlage löschen',
		'dismiss': 'verwerfen',
		'e.g. January Newsletter': 'z.B. Januar-Newsletter',
		'e.g. a1b2c3d4': 'z.B. a1b2c3d4',
		'e.g. admin, editor, viewer': 'z.B. admin, editor, viewer',
		'has been submitted. An administrator will review and approve your access.': 'wurde eingereicht. Ein Administrator wird Ihren Zugriff prüfen und genehmigen.',
		'inserting into:': 'wird eingefügt in:',
		'is an': 'ist ein',
		'is requesting access to your account. By continuing, you allow this application to verify your identity': 'fordert Zugriff auf Ihr Konto an. Durch Fortfahren erlauben Sie dieser Anwendung, Ihre Identität zu verifizieren',
		'just now': 'gerade eben',
		'key': 'Schlüssel',
		'of': 'von',
		'or': 'oder',
		'or Apple': 'oder Apple',
		'or Microsoft': 'oder Microsoft',
		'or Google': 'oder Google',
		'product.': 'Produkt.',
		'region': 'Region',
		'regions': 'Regionen',
		'remove this icon': 'dieses Icon entfernen',
		'remove your avatar': 'Ihren Avatar entfernen',
		'revoke all sessions': 'alle Sitzungen widerrufen',
		'session': 'Sitzung',
		'sessions': 'Sitzungen',
		'to auto-resolve the WordPress REST API endpoint.': 'um den WordPress REST API-Endpoint automatisch aufzulösen.',
		'to complete sign-in.': 'um die Anmeldung abzuschließen.',
		'to fetch recent posts.': 'um aktuelle Beiträge abzurufen.',
		'tokens': 'Token',
		'user@example.com': 'user@example.com',
		'username': 'Benutzername',
		'you@example.com': 'you@example.com',
		'— Not mapped —': '— Nicht zugeordnet —',
		'••••••••': '••••••••',
		'A shared analytics dashboard. Changes apply for every administrator once saved.': 'Ein gemeinsames Analyse-Dashboard. Änderungen gelten nach dem Speichern für alle Administratoren.',
		'Add a page from a template': 'Seite aus einer Vorlage hinzufügen',
		'Add a widget to get started.': 'Fügen Sie ein Widget hinzu, um zu beginnen.',
		'Add blank page': 'Leere Seite hinzufügen',
		'Add filter': 'Filter hinzufügen',
		'Add page from a template': 'Seite aus Vorlage hinzufügen',
		'Add widget': 'Widget hinzufügen',
		'Annotations': 'Anmerkungen',
		'Area': 'Fläche',
		'Bar': 'Balken',
		'Bucket': 'Zeitfenster',
		'Chart': 'Diagramm',
		'Chart type': 'Diagrammtyp',
		'Click Edit to build your dashboard.': 'Klicken Sie auf Bearbeiten, um Ihr Dashboard aufzubauen.',
		'Cohort': 'Kohorte',
		'Cohort retention': 'Kohortenbindung',
		'Cohort retention groups accounts by signup month and shows the share active each month after. The range sets the lookback window.': 'Die Kohortenbindung gruppiert Konten nach Registrierungsmonat und zeigt den in jedem Folgemonat aktiven Anteil. Der Bereich legt den Rückblickzeitraum fest.',
		'Comma-separated': 'Kommagetrennt',
		'Comma-separated values': 'Kommagetrennte Werte',
		'Could not load the dashboard.': 'Das Dashboard konnte nicht geladen werden.',
		'Could not load the metric catalogue.': 'Der Metrikkatalog konnte nicht geladen werden.',
		'Dashboard filters': 'Dashboard-Filter',
		'Data collection': 'Datenerfassung',
		'Data collection settings': 'Einstellungen zur Datenerfassung',
		'Defaults to the metric name': 'Standardmäßig der Metrikname',
		'Delete tab': 'Reiter löschen',
		'Donut': 'Ring',
		'Drag cards to rearrange. Changes apply for everyone once saved.': 'Karten ziehen, um sie neu anzuordnen. Änderungen gelten nach dem Speichern für alle.',
		'Draws a horizontal target line. 0 = none.': 'Zeichnet eine waagerechte Ziellinie. 0 = keine.',
		'Each template adds a page pre-filled with curated widgets. Edit or remove anything afterwards.': 'Jede Vorlage fügt eine Seite mit kuratierten Widgets hinzu. Danach lässt sich alles bearbeiten oder entfernen.',
		'Edit widget': 'Widget bearbeiten',
		'Event retention (days)': 'Aufbewahrung der Ereignisse (Tage)',
		'Events older than this are deleted hourly. Use 0 to keep them forever.': 'Ältere Ereignisse werden stündlich gelöscht. 0 bedeutet dauerhaft aufbewahren.',
		'Every tab and widget is removed. This cannot be undone once saved.': 'Alle Reiter und Widgets werden entfernt. Nach dem Speichern ist dies nicht rückgängig zu machen.',
		'Export CSV': 'CSV exportieren',
		'Export PNG': 'PNG exportieren',
		'From template': 'Aus Vorlage',
		'Funnel': 'Trichter',
		'Gauge': 'Messanzeige',
		'Goal line': 'Ziellinie',
		'Granularity': 'Granularität',
		'Group': 'Gruppe',
		'Group by': 'Gruppieren nach',
		'Height': 'Höhe',
		'Line': 'Linie',
		'Loading dashboard…': 'Dashboard wird geladen …',
		'Loading metrics…': 'Metriken werden geladen …',
		'Max groups': 'Maximale Gruppen',
		'Metric': 'Metrik',
		'Metrics': 'Metriken',
		'Multi-metric chart': 'Diagramm mit mehreren Metriken',
		'No data.': 'Keine Daten.',
		'No events have been recorded yet.': 'Es wurden noch keine Ereignisse aufgezeichnet.',
		'No filterable fields on this page yet. Add a widget first.': 'Auf dieser Seite gibt es noch keine filterbaren Felder. Fügen Sie zuerst ein Widget hinzu.',
		'No filters.': 'Keine Filter.',
		'No filters. Every widget shows all data in its range.': 'Keine Filter. Jedes Widget zeigt alle Daten seines Zeitraums.',
		'No filters. The query runs across all data in range.': 'Keine Filter. Die Abfrage läuft über alle Daten im Zeitraum.',
		'No metrics match your search.': 'Keine Metriken entsprechen Ihrer Suche.',
		'No thresholds — the value uses the default colour.': 'Keine Schwellenwerte – der Wert nutzt die Standardfarbe.',
		'No widgets yet.': 'Noch keine Widgets.',
		'One per line, as YYYY-MM-DD: label.': 'Eine pro Zeile, als JJJJ-MM-TT: Bezeichnung.',
		'Pick a metric and a visualization, or start from a template.': 'Wählen Sie eine Metrik und eine Darstellung, oder beginnen Sie mit einer Vorlage.',
		'Pick the funnel stages, widest first.': 'Wählen Sie die Trichterstufen, die breiteste zuerst.',
		'Pick the movement components in order.': 'Wählen Sie die Bewegungskomponenten der Reihe nach.',
		'Pick two or more metrics to overlay as separate series.': 'Wählen Sie zwei oder mehr Metriken, die als eigene Reihen überlagert werden.',
		'Pie': 'Kreis',
		'Pie, donut, radar and polar charts sum each group into one slice — pick a Group by below.': 'Kreis-, Ring-, Radar- und Polardiagramme fassen jede Gruppe zu einem Segment zusammen – wählen Sie unten eine Gruppierung.',
		'Polar area': 'Polarfläche',
		'Radar': 'Radar',
		'Range (days)': 'Zeitraum (Tage)',
		'Record an event for every request': 'Für jede Anfrage ein Ereignis aufzeichnen',
		'Remove filter': 'Filter entfernen',
		'Remove threshold': 'Schwellenwert entfernen',
		'Remove widget': 'Widget entfernen',
		'Reset the dashboard?': 'Dashboard zurücksetzen?',
		'Row limit': 'Zeilenlimit',
		'Run a query to see results.': 'Führen Sie eine Abfrage aus, um Ergebnisse zu sehen.',
		'Run query': 'Abfrage ausführen',
		'Section': 'Abschnitt',
		'Section header': 'Abschnittsüberschrift',
		'Section heading': 'Abschnittstitel',
		'Select metrics to see the dimensions they can be split by.': 'Wählen Sie Metriken, um zu sehen, nach welchen Dimensionen sie aufgeteilt werden können.',
		'Show change vs. previous period': 'Änderung gegenüber dem Vorzeitraum anzeigen',
		'Show trend sparkline': 'Trendlinie anzeigen',
		'Single value': 'Einzelwert',
		'Stages (in order)': 'Stufen (in Reihenfolge)',
		'Table (top N)': 'Tabelle (Top N)',
		'Target (100%)': 'Ziel (100 %)',
		'That query returned no data.': 'Diese Abfrage lieferte keine Daten.',
		'The selected metrics are snapshots and ignore the time range.': 'Die gewählten Metriken sind Momentaufnahmen und ignorieren den Zeitraum.',
		'These narrow every widget on this page. A filter is applied only to widgets whose metric offers that field — the rest are left unfiltered.': 'Diese schränken jedes Widget dieser Seite ein. Ein Filter wird nur auf Widgets angewendet, deren Metrik dieses Feld anbietet – die übrigen bleiben ungefiltert.',
		'Thresholds': 'Schwellenwerte',
		'Time range': 'Zeitraum',
		'Trip when value is': 'Auslösen, wenn der Wert',
		'Turning this off stops new events being written. Metrics computed from accounts, sessions and applications keep working.': 'Wird dies deaktiviert, werden keine neuen Ereignisse geschrieben. Metriken aus Konten, Sitzungen und Anwendungen funktionieren weiter.',
		'Value': 'Wert',
		'Visualization': 'Darstellung',
		'Waterfall': 'Wasserfall',
		'Widget': 'Widget',
		'Width': 'Breite',
		'at or above': 'mindestens erreicht',
		'at or below': 'höchstens erreicht',
		'Build custom analytics across accounts, authentication, applications and reliability. Pick one or more metrics, filter and split the data, then chart it over a date range.': 'Erstellen Sie eigene Auswertungen über Konten, Anmeldung, Anwendungen und Zuverlässigkeit. Wählen Sie eine oder mehrere Metriken, filtern und gruppieren Sie die Daten und stellen Sie sie über einen Zeitraum dar.',
		'Only the top groups by total value are returned, so a high-cardinality dimension stays fast.': 'Es werden nur die größten Gruppen nach Gesamtwert zurückgegeben, damit eine Dimension mit vielen Werten schnell bleibt.',
		'snapshot': 'Momentaufnahme',
		'green': 'grün',
		'yellow': 'gelb',
		'red': 'rot',
		'New tab': 'Neuer Reiter',
		'Dashboard saved.': 'Dashboard gespeichert.',
		'Data collection settings saved.': 'Einstellungen zur Datenerfassung gespeichert.',
		'Configuration imported. Review and save to apply.': 'Konfiguration importiert. Prüfen und speichern, um sie anzuwenden.',
		'Could not import that file: {{error}}': 'Diese Datei konnte nicht importiert werden: {{error}}',
		'Select at least one metric.': 'Wählen Sie mindestens eine Metrik.',
		'vs. previous': 'ggü. vorher',
		'{{count}} filters': '{{count}} Filter',
		'{{count}} widgets': '{{count}} Widgets',
		'{{percent}}% from previous': '{{percent}} % gegenüber vorher',
		'Oldest retained event: {{date}}': 'Ältestes aufbewahrtes Ereignis: {{date}}',
		'Search metrics…': 'Metriken suchen …',
		'Usage & activity': 'Nutzung & Aktivität',
		'Platform': 'Plattform',
		'Reliability': 'Zuverlässigkeit',
		'none': 'keine',
		'hour': 'Stunde',
		'day': 'Tag',
		'week': 'Woche',
		'month': 'Monat',
		'Per widget': 'Je Widget',
		'7 days': '7 Tage',
		'30 days': '30 Tage',
		'90 days': '90 Tage',
		'180 days': '180 Tage',
		'1 year': '1 Jahr',
		'Off': 'Aus',
		'equals': 'ist gleich',
		'not equals': 'ist ungleich',
		'contains': 'enthält',
		'is one of': 'ist eines von',
		'greater than': 'größer als',
		'greater or equal': 'größer oder gleich',
		'less than': 'kleiner als',
		'less or equal': 'kleiner oder gleich',
		'is empty': 'ist leer',
		'is not empty': 'ist nicht leer',
	},
	ja: {
		'Images': '画像',
		'Not rated': '未評価',
		'Upload progress': 'アップロードの進行状況',
		'Uploading… {{percent}}%': 'アップロード中… {{percent}}%',
		'Linked tickets': '関連チケット',
		'Follow-up of': 'フォローアップ元',
		'Continued in': '継続先',
		'Ticket attachments': 'チケットの添付ファイル',
		'Routing': '振り分け',
		'Edit routing': '振り分けを編集',
		'Edit routing for {{name}}': '{{name}} の振り分けを編集',
		'Edit routing for {{category}} on {{product}}': '{{product}} の {{category}} の振り分けを編集',
		'Show routing for {{name}}': '{{name}} の振り分けを表示',
		'Hide routing for {{name}}': '{{name}} の振り分けを非表示',
		'Product rule only': '製品ルールのみ',
		'No support-enabled product takes this category.': 'このカテゴリを使用するサポート有効な製品はありません。',
		'Notified': '通知対象',
		'Auto-assigned': '自動割り当て対象',
		'Routing for {{product}}': '{{product}} の振り分け',
		'Routing for {{category}} on {{product}}': '{{product}} の {{category}} の振り分け',
		'Applies to every ticket on {{product}}. Category rules add to it; for assignment, a category rule with auto-assign takes precedence.': '{{product}} のすべてのチケットに適用されます。カテゴリルールはこれに追加されます。割り当てについては、自動割り当てのあるカテゴリルールが優先されます。',
		'Applies to {{category}} tickets on {{product}}, in addition to the product rule.': '{{product}} の {{category}} チケットに、製品ルールに加えて適用されます。',
		'Notify: gets an email and a notification for each new ticket.': '通知：新しいチケットごとにメールと通知を受け取ります。',
		'Auto-assign: new tickets go to the least busy of these agents.': '自動割り当て：新しいチケットは、これらの担当者のうち最も手の空いている人に割り当てられます。',
		'Notify {{name}}': '{{name}} に通知',
		'Auto-assign to {{name}}': '{{name}} に自動割り当て',
		'Auto-assign': '自動割り当て',
		'Routing saved.': '振り分けを保存しました。',
		'Failed to save routing': '振り分けを保存できませんでした',
		'Assigned to {{name}} automatically': '{{name}} に自動で割り当て',
		'Owner': 'オーナー',
		'People': 'メンバー',
		'Remove {{name}} from this ticket?': '{{name}} をこのチケットから外しますか？',
		'A ticket can have at most {{count}} people besides its owner.': 'チケットにはオーナー以外に最大 {{count}} 人まで追加できます。',
		'Add someone by email': 'メールアドレスで追加',
		'People you add need an Abstract ID account. They can read the ticket, reply to it and get its emails.': '追加する人には Abstract ID アカウントが必要です。チケットの閲覧、返信、メールの受信ができます。',
		'Leave this ticket? You will no longer be able to see it.': 'このチケットから退出しますか？退出後は閲覧できなくなります。',
		'Leave ticket': 'チケットから退出',
		'{{email}} was added to the ticket.': '{{email}} をチケットに追加しました。',
		'Failed to add the person': '追加できませんでした',
		'{{name}} was removed from the ticket.': '{{name}} をチケットから外しました。',
		'Failed to remove the person': '外すことができませんでした',
		'Deleted the attachment {{filename}}': '添付ファイル {{filename}} を削除しました',
		'Delete {{name}}? The file is erased for good and cannot be restored.': '{{name}} を削除しますか？ファイルは完全に消去され、復元できません。',
		'{{name}} was deleted.': '{{name}} を削除しました。',
		'Failed to delete the attachment': '添付ファイルを削除できませんでした',
		'Delete {{name}}': '{{name}} を削除',
		'You left the ticket.': 'チケットから退出しました。',
		'Failed to leave the ticket': 'チケットから退出できませんでした',
		'{{owner}} added you to this ticket.': '{{owner}} があなたをこのチケットに追加しました。',
		'Shared by {{name}}': '{{name}} が共有',
		'The ticket owner\'s support is no longer active, so replies are closed.': 'チケットのオーナーのサポートが有効ではなくなったため、返信は締め切られました。',
		'Added {{name}} to the ticket': '{{name}} をチケットに追加しました',
		'Removed {{name}} from the ticket': '{{name}} をチケットから外しました',
		'Left the ticket': 'チケットから退出しました',
		'Support is currently turned off': 'サポートは現在停止中です',
		'Tickets cannot be opened or answered right now. Please check back later.': '現在チケットの作成や返信はできません。後ほどもう一度お試しください。',
		'Support is turned on.': 'サポートを有効にしました。',
		'Support is turned off.': 'サポートを停止しました。',
		'Support desk': 'サポートデスク',
		'On. Customers whose license includes support can open tickets, and agents answer them from the Support Desk.': 'オン。サポートを含むライセンスをお持ちのお客様はチケットを作成でき、担当者がサポートデスクで回答します。',
		'Off. Support is hidden from customers and agents and the automatic sweeps are paused. Tickets and settings are kept.': 'オフ。サポートはお客様と担当者に表示されず、自動処理は一時停止します。チケットと設定は保持されます。',
		'Support desk enabled': 'サポートデスクを有効化',
		'Notify': '通知先',
		'Team address only': 'チームアドレスのみ',
		'There are no support agents yet. Assign the support role first.': 'サポート担当者がまだいません。先にサポートロールを割り当ててください。',
		'Agents': '担当者',
		'Editor mode': 'エディターモード',
		'Write': '作成',
		'Markdown supported': 'Markdown 対応',
		'Nothing to preview yet.': 'プレビューする内容がまだありません。',
		'Preview {{name}}': '{{name}} をプレビュー',
		'The full image could not be loaded.': 'フルサイズの画像を読み込めませんでした。',
		'or drop them here': 'またはここにドロップ',
		'No access to support?': 'サポートをご利用いただけない場合',
		'Consider purchasing a license to get instant access to our in-house engineering team. Otherwise, you can get help from the Abstract community and on the Abstract Discord.': 'ライセンスをご購入いただくと、社内エンジニアリングチームにすぐにご相談いただけます。または、Abstract コミュニティや Abstract Discord でサポートを受けることもできます。',
		'Abstract Community': 'Abstract コミュニティ',
		'Abstract Discord': 'Abstract Discord',
		'Community URL': 'コミュニティ URL',
		'Discord invite': 'Discord 招待リンク',
		'Offered to users without access to support. Leave blank to offer none.': 'サポートをご利用いただけないユーザーに表示されます。空欄の場合は表示しません。',
		'A question or a minor inconvenience.': '質問、または軽微な不便。',
		'A resolved ticket untouched this long is closed. 0 turns this off.': '解決済みのチケットがこの期間操作されない場合はクローズされます。0 で無効になります。',
		'A short summary of the problem': '問題の簡単な概要',
		'A ticket waiting on the customer this long is resolved. 0 turns this off.': '顧客の返答をこの期間待っているチケットは解決済みになります。0 で無効になります。',
		'Activity': 'アクティビティ',
		'Add category': 'カテゴリを追加',
		'Add note': 'メモを追加',
		'Agent': '担当者',
		'Agents and automation': '担当者と自動化',
		'All open': 'すべての未解決',
		'All products': 'すべての製品',
		'Another product already uses this prefix.': 'この接頭辞は別の製品で既に使用されています。',
		'Any priority': 'すべての優先度',
		'Any product': 'すべての製品',
		'Any status': 'すべてのステータス',
		'Anyone': '全員',
		'Anything you would like to add? (optional)': '追加したいことはありますか？（任意）',
		'Apply': '適用',
		'Ask for logs': 'ログを依頼',
		'Assign to me': '自分に割り当て',
		'Assign to…': '割り当て先…',
		'Assigned to {{name}}': '{{name}} に割り当て',
		'Assignee': '担当者',
		'Attach files': 'ファイルを添付',
		'Attachments': '添付ファイル',
		'Auto-close after (days)': '自動クローズまでの日数',
		'Auto-resolve after (days)': '自動解決までの日数',
		'Awaiting agent': '担当者の対応待ち',
		'Awaiting customer': '顧客の返答待ち',
		'Back to support': 'サポートに戻る',
		'Back to the desk': 'サポートデスクに戻る',
		'Breaching': 'SLA 違反',
		'Bulk actions': '一括操作',
		'Templates': 'テンプレート',
		'Template saved.': 'テンプレートを保存しました。',
		'Categories': 'カテゴリ',
		'Categories are optional. They help customers say what a ticket is about.': 'カテゴリは任意です。チケットの内容を顧客が伝えやすくなります。',
		'Category cleared': 'カテゴリを解除',
		'Category deleted.': 'カテゴリを削除しました。',
		'Category saved.': 'カテゴリを保存しました。',
		'Category set to {{name}}': 'カテゴリを {{name}} に設定',
		'Choose a product': '製品を選択',
		'Choose a product.': '製品を選択してください。',
		'Clear selection': '選択を解除',
		'Close this ticket? You can open a follow-up later if you need to.': 'このチケットをクローズしますか？必要に応じて後でフォローアップを作成できます。',
		'Close ticket': 'チケットをクローズ',
		'Closed': 'クローズ',
		'Closed automatically': '自動的にクローズ',
		'Comment': 'コメント',
		'Conversation': '会話',
		'Could not check your license': 'ライセンスを確認できませんでした',
		'Create ticket': 'チケットを作成',
		'Customers file tickets against a product while their license for it includes support. Agents answer them from the Support Desk.': '顧客は、ライセンスにサポートが含まれている間、製品に対してチケットを作成できます。担当者はサポートデスクから回答します。',
		'Delete the template “{{name}}”?': 'テンプレート「{{name}}」を削除しますか？',
		'Delete the category “{{name}}”?': 'カテゴリ「{{name}}」を削除しますか？',
		'Describe the problem.': '問題を説明してください。',
		'Dissatisfied': '不満',
		'Edit template': 'テンプレートを編集',
		'Edit {{name}}': '{{name}} を編集',
		'Enable support for a product under Settings → Admin → Support.': '設定 → 管理 → サポートで製品のサポートを有効にしてください。',
		'Enter a whole number of days.': '日数を整数で入力してください。',
		'Enter the requester’s email address.': '依頼者のメールアドレスを入力してください。',
		'Every ticket filed against a support-enabled product.': 'サポートが有効な製品に対して作成されたすべてのチケット。',
		'Failed to delete the template': 'テンプレートを削除できませんでした',
		'Failed to delete the category': 'カテゴリを削除できませんでした',
		'Failed to download the attachment': '添付ファイルをダウンロードできませんでした',
		'Failed to load support': 'サポートを読み込めませんでした',
		'Failed to load support settings': 'サポート設定を読み込めませんでした',
		'Failed to load the ticket': 'チケットを読み込めませんでした',
		'Failed to load tickets': 'チケットを読み込めませんでした',
		'No tickets yet': 'チケットはまだありません',
		'Failed to open the ticket': 'チケットを作成できませんでした',
		'Failed to save support for this product': 'この製品のサポート設定を保存できませんでした',
		'Failed to save support settings': 'サポート設定を保存できませんでした',
		'Failed to save the template': 'テンプレートを保存できませんでした',
		'Failed to save the category': 'カテゴリを保存できませんでした',
		'Failed to send the message': 'メッセージを送信できませんでした',
		'Failed to send the reply': '返信を送信できませんでした',
		'Failed to submit the rating': '評価を送信できませんでした',
		'Failed to update the ticket': 'チケットを更新できませんでした',
		'Failed to update the tickets': 'チケットを更新できませんでした',
		'Filed by {{name}}': '{{name}} が作成',
		'Files to attach': '添付するファイル',
		'First response': '初回応答',
		'First response (hours)': '初回応答（時間）',
		'First response target for {{priority}}': '{{priority}} の初回応答目標',
		'Follows up on {{key}}': '{{key}} のフォローアップ',
		'For requests that reached the team another way — by phone, chat or email.': '電話、チャット、メールなど別の経路でチームに届いた依頼用です。',
		'Get help with the Abstract products you hold a license for.': 'ライセンスをお持ちの Abstract 製品についてサポートを受けられます。',
		'Give the ticket a subject.': 'チケットに件名を付けてください。',
		'High': '高',
		'Holders of this role are agents. Administrators always are.': 'このロールの保持者は担当者になります。管理者は常に担当者です。',
		'How did we do?': '対応はいかがでしたか？',
		'Insert template…': 'テンプレートを挿入…',
		'Insert placeholder:': 'プレースホルダーを挿入:',
		'Internal note': '内部メモ',
		'Last activity': '最終アクティビティ',
		'Last heard': '最終連絡',
		'Low': '低',
		'Met': '達成',
		'Mine': '自分の担当',
		'Missed': '未達',
		'Neutral': '普通',
		'New': '新規',
		'New template': '新しいテンプレート',
		'New ticket': '新しいチケット',
		'New ticket on behalf of a customer': '顧客に代わって新しいチケットを作成',
		'No templates yet': 'テンプレートはまだありません',
		'No categories': 'カテゴリなし',
		'No category': 'カテゴリなし',
		'No product has support enabled': 'サポートが有効な製品はありません',
		'No product offers you support right now': '現在サポートを受けられる製品はありません',
		'No support role — administrators only': 'サポートロールなし — 管理者のみ',
		'No target': '目標なし',
		'No ticket matches this view and these filters.': 'このビューとフィルターに一致するチケットはありません。',
		'Nobody': 'なし',
		'None of the Abstract products offer support through Abstract ID yet.': 'Abstract ID を通じてサポートを提供している Abstract 製品はまだありません。',
		'Normal': '通常',
		'Not yet assigned': '未割り当て',
		'Note added.': 'メモを追加しました。',
		'Nothing in this view': 'このビューには何もありません',
		'Off': 'オフ',
		'Offered for new tickets': '新しいチケットで選択可能',
		'On': 'オン',
		'Only the person who opened this ticket can reply to it.': 'このチケットに返信できるのは作成者のみです。',
		'Your support entitlement could not be confirmed right now. Please try again shortly.': '現在サポート資格を確認できません。しばらくしてから再度お試しください。',
		'Open': '未解決',
		'Open (any)': '未解決（すべて）',
		'Open a follow-up': 'フォローアップを作成',
		'Opened': '作成',
		'Operating system': 'オペレーティングシステム',
		'Overdue by {{time}}': '{{time}} 超過',
		'Paused · {{time}} left': '一時停止 · 残り {{time}}',
		'Prefix': '接頭辞',
		'Priority': '優先度',
		'Priority changed from {{from}} to {{to}}': '優先度を {{from}} から {{to}} に変更',
		'Priority…': '優先度…',
		'Product': '製品',
		'Product version': '製品バージョン',
		'Production is down and there is no workaround.': '本番環境が停止しており、回避策がありません。',
		'Products': '製品',
		'Rated {{rating}} out of 5': '5 段階中 {{rating}} の評価',
		'Rating': '評価',
		'Receives SLA breach alerts for tickets nobody is assigned to.': '担当者のいないチケットの SLA 違反通知を受け取ります。',
		'Remove {{name}}': '{{name}} を削除',
		'Reopen ticket': 'チケットを再オープン',
		'Replies the team reuses. Placeholders are filled in from the ticket when a reply is inserted.': 'チームが再利用する返信です。挿入時にプレースホルダーがチケットの内容で置き換えられます。',
		'Reply': '返信',
		'Reply sent.': '返信を送信しました。',
		'Requester': '依頼者',
		'Requester email': '依頼者のメールアドレス',
		'Resolution': '解決',
		'Resolution (hours)': '解決（時間）',
		'Resolution target for {{priority}}': '{{priority}} の解決目標',
		'Resolved': '解決済み',
		'Resolved automatically after no reply': '返信がないため自動的に解決',
		'SLA': 'SLA',
		'SLA targets must be positive numbers of hours, or blank for none.': 'SLA 目標は正の時間数で入力するか、空欄で目標なしにしてください。',
		'Satisfaction': '満足度',
		'Satisfied': '満足',
		'Save settings': '設定を保存',
		'Save the answers the team gives most often, and insert them from any ticket.': 'チームがよく使う回答を保存し、どのチケットからでも挿入できます。',
		'Search key, subject or requester…': 'キー、件名、依頼者で検索…',
		'Search tickets…': 'チケットを検索…',
		'Select all': 'すべて選択',
		'Select {{key}}': '{{key}} を選択',
		'Service level': 'サービスレベル',
		'Service levels': 'サービスレベル',
		'Set assignee': '担当者を設定',
		'Set priority': '優先度を設定',
		'Set status': 'ステータスを設定',
		'Showing {{from}} to {{to}} of {{total}}': '{{total}} 件中 {{from}}〜{{to}} 件を表示',
		'Shown as a hint when a customer picks it.': '顧客が選択したときにヒントとして表示されます。',
		'Something is not working as expected.': '何かが期待どおりに動作しません。',
		'Status after sending': '送信後のステータス',
		'Status changed to {{to}}': 'ステータスを {{to}} に変更',
		'Status: automatic': 'ステータス: 自動',
		'Status: {{status}}': 'ステータス: {{status}}',
		'Status…': 'ステータス…',
		'Submit rating': '評価を送信',
		'Submit ticket': 'チケットを送信',
		'Support': 'サポート',
		'Support Desk': 'サポートデスク',
		'Support Desk — {{count}} unassigned': 'サポートデスク — 未割り当て {{count}} 件',
		'Support available': 'サポート利用可能',
		'Support comes with an active license. The support page explains the situation for each product.': 'サポートは有効なライセンスに含まれます。サポートページで製品ごとの状況を確認できます。',
		'Support for {{name}}': '{{name}} のサポート',
		'Support is not available for this product yet.': 'この製品のサポートはまだ利用できません。',
		'Support is not available yet': 'サポートはまだ利用できません',
		'Support needs licensing turned on for the product, and a ticket prefix — the LOD in LOD-1042.': 'サポートには製品のライセンス管理の有効化とチケット接頭辞（LOD-1042 の LOD）が必要です。',
		'Support not available': 'サポート利用不可',
		'Support role': 'サポートロール',
		'Support saved for {{name}}.': '{{name}} のサポート設定を保存しました。',
		'Support settings saved.': 'サポート設定を保存しました。',
		'Targets in hours of wall-clock time from when the ticket was opened. The resolution clock pauses while a ticket waits on the customer. Leave blank for no target.': 'チケット作成時点からの経過時間（実時間）による目標です。顧客の返答待ちの間は解決の計測が停止します。空欄は目標なしです。',
		'Team email': 'チームのメールアドレス',
		'Tell us what is going wrong. The more detail, the faster we can help.': '何が問題なのかを教えてください。詳しいほど早く対応できます。',
		'Thank you for your feedback.': 'フィードバックありがとうございます。',
		'The customer must already have an account.': '顧客は既にアカウントを持っている必要があります。',
		'The license server for this product did not answer. Please try again shortly.': 'この製品のライセンスサーバーが応答しませんでした。しばらくしてから再度お試しください。',
		'The prefix must be 2–10 uppercase letters or digits.': '接頭辞は 2〜10 文字の大文字英字または数字である必要があります。',
		'The product the ticket is filed against': 'チケットの対象製品',
		'The requester\'s first name': '依頼者の名',
		'The requester\'s full name': '依頼者の氏名',
		'The ticket reference, e.g. LOD-1042': 'チケット番号（例: LOD-1042）',
		'This ticket is closed.': 'このチケットはクローズされています。',
		'This ticket is closed. If the problem is back, open a follow-up and we will pick it up from here.': 'このチケットはクローズされています。問題が再発した場合はフォローアップを作成してください。ここから対応を引き継ぎます。',
		'Ticket': 'チケット',
		'Ticket closed.': 'チケットをクローズしました。',
		'Ticket opened': 'チケットが作成されました',
		'Ticket prefix for {{name}}': '{{name}} のチケット接頭辞',
		'Ticket reopened.': 'チケットを再オープンしました。',
		'Ticket updated': 'チケットが更新されました',
		'Ticket updated.': 'チケットを更新しました。',
		'Ticket {{key}} opened.': 'チケット {{key}} を作成しました。',
		'Tickets': 'チケット',
		'Title': 'タイトル',
		'Turn on licensing for this product first.': '先にこの製品のライセンス管理を有効にしてください。',
		'Unassigned': '未割り当て',
		'Updated {{count}} ticket(s).': '{{count}} 件のチケットを更新しました。',
		'Urgent': '緊急',
		'Very dissatisfied': '非常に不満',
		'Very satisfied': '非常に満足',
		'Views': 'ビュー',
		'Waiting for support': 'サポートの対応待ち',
		'Waiting for you': 'お客様の返答待ち',
		'What did you do, what did you expect, and what happened instead? Markdown is supported.': '何をして、何を期待し、実際には何が起きましたか？ Markdown に対応しています。',
		'When something is not working, open a ticket and the support team will get back to you.': '問題があればチケットを作成してください。サポートチームからご連絡します。',
		'Write a note only the support team can see…': 'サポートチームだけが見られるメモを書く…',
		'Write your reply…': '返信を入力…',
		'You do not hold a license for this product.': 'この製品のライセンスをお持ちではありません。',
		'Your license for this product does not include support.': 'この製品のライセンスにはサポートが含まれていません。',
		'Your license for this product has expired.': 'この製品のライセンスは期限切れです。',
		'Your name': 'あなたの名前',
		'Your tickets': 'あなたのチケット',
		'Your work is significantly impaired.': '作業に大きな支障があります。',
		'{{count}} selected': '{{count}} 件選択',
		'{{name}} filed this ticket using a seat of your license. You can follow it, but only they can reply.': '{{name}} があなたのライセンスのシートでこのチケットを作成しました。閲覧はできますが、返信できるのは作成者のみです。',
		'{{time}} left': '残り {{time}}',
		'Columns': '列',
		'Reset columns': '列をリセット',
		'2FA': '二要素認証',
		'Newsletter': 'ニュースレター',
		'Enabled': '有効',
		'Disabled': '無効',
		'Opted out': '配信停止',
		'Subscribed': '購読中',
		'Local': 'ローカル',
		'Review your active sessions to sign out elsewhere.': '他のデバイスからサインアウトするには、アクティブセッションを確認してください。',
		'Sign out on this device. Your other devices stay signed in.': 'このデバイスからサインアウトします。他のデバイスはサインインしたままです。',
		'All {{count}} of your licenses for this product have expired.': 'この製品のライセンス {{count}} 件はすべて期限切れです。',
		'No active licenses': '有効なライセンスがありません',
		'Show {{count}} expired': '期限切れ {{count}} 件を表示',
		'Add all': 'すべて追加',
		'Add one at a time': '1 件ずつ追加',
		'Add several at once': 'まとめて追加',
		'Added {{count}}.': '{{count}} 件を追加しました。',
		'Added {{count}}. Skipped: {{skipped}}.': '{{count}} 件を追加しました。スキップ: {{skipped}}。',
		'Email addresses': 'メールアドレス',
		'Everyone on that list already has seats on this license.': 'リストの全員にすでにこのライセンスのシートが割り当てられています。',
		'None of those look like email addresses.': 'どれもメールアドレスとして認識できません。',
		'Paste at least one email address.': 'メールアドレスを 1 件以上貼り付けてください。',
		'Separate addresses with commas, spaces or new lines. People who already have seats are skipped.': 'アドレスはカンマ、スペース、改行で区切ってください。すでにシートを持つ人はスキップされます。',
		'colleague@example.com, another@example.com': 'colleague@example.com, another@example.com',
		'seats each': 'シート／人',
		'{{count}} already assigned': '{{count}} 件は割り当て済み',
		'{{count}} not a valid address': '{{count}} 件は無効なアドレス',
		'{{needed}} seat(s) needed for {{people}} people, but only {{available}} left.': '{{people}} 人には {{needed}} 件のシートが必要ですが、残りは {{available}} 件です。',
		'Group {{number}}': 'グループ {{number}}',
		'Link {{number}}': 'リンク {{number}}',
		'Remove group': 'グループを削除',
		'Remove link': 'リンクを削除',
		'Add group': 'グループを追加',
		'Download Groups': 'ダウンロードグループ',
		'Heading for builds the backend files under no group. Blank uses “Other”.': 'バックエンドがどのグループにも分類しないビルドの見出し。空欄の場合は「その他」になります。',
		'Name for ungrouped builds': 'グループ未設定のビルドの名称',
		'Names the groups the licensing backend files builds under. Order here is the order they appear; an unmapped group still shows, under its raw identifier.': 'ライセンスバックエンドがビルドを分類するグループに名前を付けます。ここでの並び順が表示順になります。未設定のグループも識別子のまま表示されます。',
		'Other': 'その他',
		'Get a License URL': 'ライセンス取得 URL',
		'Get a license': 'ライセンスを取得',
		'Get a license for {{name}}': '{{name}} のライセンスを取得',
		'Offered to users who hold no license for this product. Blank makes no offer.': 'この製品のライセンスを持たないユーザーに案内されます。空欄の場合は案内しません。',
		'Add link': 'リンクを追加',
		'Display Name': '表示名',
		'Documentation': 'ドキュメント',
		'Documentation Links': 'ドキュメントリンク',
		'Shown below the user\'s licenses for this product, and linked from its card on the dashboard.': 'この製品のライセンスの下に表示され、ダッシュボードのカードからもリンクされます。',
		'What customers call this product. Used across the license pages; blank uses the application name.': '顧客がこの製品を呼ぶ名称。ライセンス関連ページ全体で使用され、空欄の場合はアプリケーション名が使われます。',
		'{{count}} expired': '{{count}} 件が期限切れ',
		'Download {{name}}': '{{name}} をダウンロード',
		'Builds appear here once they are linked to an entitlement on one of your active licenses.': 'ビルドは、有効なライセンスのエンタイトルメントに関連付けられるとここに表示されます。',
		'It offers {{count}} download(s) for your account.': 'あなたのアカウントでは {{count}} 件のダウンロードが利用できます。',
		'Link builds to the entitlements your licenses grant to make them downloadable.': 'ダウンロード可能にするには、ライセンスが付与するエンタイトルメントにビルドを関連付けてください。',
		'No downloads available': '利用できるダウンロードはありません',
		'Download': 'ダウンロード',
		'Downloads': 'ダウンロード',
		'Failed to load downloads': 'ダウンロードを読み込めませんでした',
		'Failed to start the download': 'ダウンロードを開始できませんでした',
		'Latest': '最新',
		'Add': '追加',
		'Add a seat': 'シートを 1 つ追加',
		'Assign at least one seat.': '少なくとも 1 シートを割り当ててください。',
		'Assign seats to a colleague': '同僚にシートを割り当てる',
		'Discard changes': '変更を破棄',
		'Email address': 'メールアドレス',
		'Enter a valid email address.': '有効なメールアドレスを入力してください。',
		'Every seat on this license is yours to use. Assign a block below to share it.': 'このライセンスのすべてのシートはご自身で利用できます。共有するには、下でまとまったシートを割り当ててください。',
		'Give blocks of seats to colleagues. They activate their own machines against the seats you assign; removing a block takes the seats back.': '同僚にシートのまとまりを割り当てます。割り当てられた相手は自分のマシンをそのシートでアクティベートします。まとまりを削除するとシートは戻ります。',
		'No seats left to assign. Reduce a block above first.': '割り当て可能なシートがありません。まず上のまとまりを減らしてください。',
		'Not yet saved': '未保存',
		'Only {{count}} seat(s) left to assign.': '割り当て可能なシートは残り {{count}} 件です。',
		'Remove a seat': 'シートを 1 つ減らす',
		'Remove assignment': '割り当てを削除',
		'Seat budget': 'シートの配分',
		'That person already has seats on this license.': 'その相手にはすでにこのライセンスのシートが割り当てられています。',
		'{{assigned}} of {{total}} assigned': '{{total}} 件中 {{assigned}} 件を割り当て済み',
		'{{count}} seat(s) left for your own machines.': '自分のマシン用に {{count}} 件のシートが残っています。',
		'{{count}} seat(s) over the license total.': 'ライセンス総数を {{count}} 件超えています。',
		'{{used}} of {{seats}} in use': '{{seats}} 件中 {{used}} 件を使用中',
		'It holds {{count}} license(s) for your account.': 'あなたのアカウントには {{count}} 件のライセンスがあります。',
		'The backend answered, but refused to list your licenses. Check that it shares the same JWT_KEY as Abstract ID.': 'バックエンドは応答しましたが、ライセンスの一覧取得を拒否しました。Abstract ID と同じ JWT_KEY を共有しているか確認してください。',
		'This application is inactive, so its licenses are hidden from users regardless of the settings below.': 'このアプリケーションは無効です。以下の設定にかかわらず、ライセンスはユーザーに表示されません。',
		'A backend URL is required to enable licensing.': 'ライセンス管理を有効にするにはバックエンド URL が必要です。',
		'Adapter': 'アダプター',
		'Backend reachable': 'バックエンドに接続できました',
		'Failed to save licensing configuration': 'ライセンス設定を保存できませんでした',
		'Failed to test the licensing backend': 'ライセンスバックエンドをテストできませんでした',
		'Licensing Backends': 'ライセンスバックエンド',
		'Licensing saved for {{name}}.': '{{name}} のライセンス設定を保存しました。',
		'No licensing backends': 'ライセンスバックエンドがありません',
		'No sublicense entitlement is configured on the backend, so seats can never be re-assigned.': 'バックエンドにサブライセンスのエンタイトルメントが設定されていないため、シートを再割り当てすることはできません。',
		'Products whose licenses users can see from their Abstract ID account. Abstract ID stores no license data — it reads each backend live, as the signed-in user.': 'ユーザーが Abstract ID アカウントからライセンスを確認できる製品。Abstract ID はライセンスデータを保存せず、サインイン中のユーザーとして各バックエンドを直接読み取ります。',
		'Show all applications': 'すべてのアプリケーションを表示',
		'Test connection': '接続をテスト',
		'This backend serves a different application.': 'このバックエンドは別のアプリケーションを担当しています。',
		'Turn on "Show all applications" to point a product at its license server.': '製品をライセンスサーバーに接続するには「すべてのアプリケーションを表示」をオンにしてください。',
		'Unsaved': '未保存',
		'Users would see an empty license list. Check the URL points at this product’s license server.': 'ユーザーにはライセンス一覧が空で表示されます。URL がこの製品のライセンスサーバーを指しているか確認してください。',
		'{{configured}} of {{total}} applications have a licensing backend.': '{{total}} 件中 {{configured}} 件のアプリケーションにライセンスバックエンドが設定されています。',
		'License Activation Revoked': 'ライセンスのアクティベーションを解除',
		'Support Ticket Created': 'サポートチケット作成',
		'Support Ticket Updated': 'サポートチケット更新',
		'Support Settings Changed': 'サポート設定変更',
		'License Seats Updated': 'ライセンスシートを更新',
		'API base including the version prefix, e.g. https://license.example.com/api/v1': 'バージョン接頭辞を含む API ベース（例: https://license.example.com/api/v1）',
		'Activated': 'アクティベート日',
		'All seats on this license are yours to use.': 'このライセンスのすべてのシートはご自身で利用できます。',
		'Allow seat re-assignment': 'シートの再割り当てを許可',
		'Assign seats': 'シートを割り当てる',
		'Assigned seat': '割り当てられたシート',
		'Assigned seats ({{assigned}}) exceed the license total ({{total}}).': '割り当て済みシート数（{{assigned}}）がライセンス総数（{{total}}）を超えています。',
		'Back to licenses': 'ライセンス一覧に戻る',
		'Backend URL': 'バックエンド URL',
		'Discard': '破棄',
		'Entitlements': 'エンタイトルメント',
		'Every assignment needs an email address.': 'すべての割り当てにメールアドレスが必要です。',
		'Expired': '期限切れ',
		'Expires': '有効期限',
		'Failed to load activations': 'アクティベーションを読み込めませんでした',
		'Failed to load license': 'ライセンスを読み込めませんでした',
		'Failed to load licenses': 'ライセンスを読み込めませんでした',
		'Failed to release seats': 'シートを解放できませんでした',
		'Failed to save seat assignments': 'シート割り当てを保存できませんでした',
		'Give blocks of seats to colleagues. They activate their own machines against the seats you assign; removing an assignment takes the seats back.': '同僚にシートのまとまりを割り当てます。割り当てられた相手は自分のマシンをそのシートでアクティベートします。割り当てを削除するとシートは戻ります。',
		'Lets users see this product\'s licenses and activations from their Abstract ID account. Abstract ID stores no license data — it reads the backend live, as the signed-in user.': 'この製品のライセンスとアクティベーションを Abstract ID アカウントから確認できるようにします。Abstract ID はライセンスデータを保存せず、サインイン中のユーザーとしてバックエンドを直接読み取ります。',
		'License': 'ライセンス',
		'Licenses': 'ライセンス',
		'Licenses issued to you across Abstract products, and the machines using them.': 'Abstract 製品全体で発行されたあなたのライセンスと、それを使用しているマシン。',
		'Builds available to you for each Abstract product you are licensed for.': 'ライセンスをお持ちの Abstract 製品ごとに利用できるビルドです。',
		'Guides and references for each Abstract product.': '各 Abstract 製品のガイドとリファレンス。',
		'No documentation': 'ドキュメントなし',
		'This product publishes no documentation yet.': 'この製品のドキュメントはまだ公開されていません。',
		'Licensing': 'ライセンス管理',
		'Licensing Backend': 'ライセンスバックエンド',
		'Machine': 'マシン',
		'Machines': 'マシン',
		'Machines currently using a seat of this license.': '現在このライセンスのシートを使用しているマシン。',
		'My Licenses': 'マイライセンス',
		'No licensed products': 'ライセンス対象の製品はありません',
		'No licenses': 'ライセンスがありません',
		'No machine has activated this license yet.': 'このライセンスをアクティベートしたマシンはまだありません。',
		'No machines': 'マシンがありません',
		'No seats assigned': '割り当て済みシートはありません',
		'None of the products you have access to manage licenses through Abstract ID.': '利用中の製品のうち、Abstract ID でライセンスを管理しているものはありません。',
		'Release {{count}} seat(s)': '{{count}} 件のシートを解放',
		'Released': '解放済み',
		'Released {{count}} seat(s).': '{{count}} 件のシートを解放しました。',
		'Renews': '更新日',
		'Save assignments': '割り当てを保存',
		'Seat assignments': 'シート割り当て',
		'Seat assignments saved.': 'シート割り当てを保存しました。',
		'Seats': 'シート',
		'Select': '選択',
		'Select {{machine}}': '{{machine}} を選択',
		'The backend still decides per license whether its owner may delegate seats; this only hides the controls for the whole product.': 'シートを委譲できるかどうかは引き続きバックエンドがライセンスごとに判断します。これは製品全体で操作を非表示にするだけです。',
		'Valid': '有効期間',
		'You have no licenses for this product yet.': 'この製品のライセンスはまだありません。',
		'Your Licenses': 'あなたのライセンス',
		'colleague@example.com': 'colleague@example.com',
		'{{assigned}} of {{total}} seats assigned': '{{total}} 件中 {{assigned}} 件のシートを割り当て済み',
		'{{count}} active': '{{count}} 件が有効',
		'{{count}} free': '残り {{count}} 件',
		'{{count}} license(s)': '{{count}} 件のライセンス',
		'Collapse sidebar': 'サイドバーを折りたたむ',
		'Expand sidebar': 'サイドバーを展開',
		'Something went wrong': '問題が発生しました',
		'Switch to dark mode': 'ダークモードに切り替え',
		'Switch to light mode': 'ライトモードに切り替え',
		'Allow pop-ups for this site to sign in with Microsoft.': 'Microsoft でサインインするには、このサイトのポップアップを許可してください。',
		'and access the following': '以下にアクセスします',
		'and access your profile information': 'プロフィール情報にアクセスします',
		'2FA Disabled': '2FA 無効',
		'2FA Enabled': '2FA 有効',
		'2FA Not Set': '2FA 未設定',
		'2FA QR Code': '2FA QRコード',
		'2FA is enabled': '2FA が有効です',
		'2FA is not enabled': '2FA が無効です',
		'6-digit code': '6桁のコード',
		'A short bio or description...': '自己紹介を入力...',
		'About': '自己紹介',
		'Access Granted': 'アクセス許可済み',
		'Access Key ID': 'Access Key ID',
		'Account': 'アカウント',
		'Account Status': 'アカウントステータス',
		'Action': 'アクション',
		'Action Types': 'アクションタイプ',
		'Action URL (optional)': 'アクション URL（任意）',
		'Actions': 'アクション',
		'Activation Email': 'アクティベーションメール',
		'Active': 'アクティブ',
		'Active Sessions': 'アクティブセッション',
		'Add Link': 'リンクを追加',
		'Add a passkey to sign in without a password.': 'パスキーを追加して、パスワードなしでサインインできます。',
		'Add an extra layer of security using a TOTP authenticator app.': 'TOTP 認証アプリを使用して、セキュリティを強化します。',
		'Add external links that appear in the application sidebar for all users. Upload an icon image (128×128 PNG) and set the order to control placement alongside registered applications.': 'すべてのユーザーのサイドバーに表示される外部リンクを追加します。アイコン画像（128×128 PNG）をアップロードし、順序を設定して配置を制御します。',
		'Add passkey': 'パスキーを追加',
		'Added': '追加済み',
		'Admin': '管理者',
		'Admin Notes': '管理者メモ',
		'Administration': '管理',
		'Administrator': '管理者',
		'Administrators': '管理者',
		'Admins': '管理者',
		'All Actions': 'すべてのアクション',
		'All Roles': 'すべてのロール',
		'All Statuses': 'すべてのステータス',
		'All Users (active + imported)': '全ユーザー（アクティブ + インポート済み）',
		'All apps': 'すべてのアプリ',
		'All auth types': 'すべての認証タイプ',
		'All caught up!': 'すべて確認済みです！',
		'All rights reserved.': 'All rights reserved.',
		'All sessions revoked.': 'すべてのセッションを無効にしました。',
		'All statuses': 'すべてのステータス',
		'All users (active + imported)': '全ユーザー（アクティブ + インポート済み）',
		'Allow Duplicate Emails': 'メールアドレスの重複を許可',
		'Allowed redirect domains for authorization. One URL per line.': '認可に許可されたリダイレクトドメイン。1行に1つの URL を入力してください。',
		'Already exist': '既に存在',
		'Already exist (skipped):': '既に存在（スキップ）:',
		'Already have an account?': 'アカウントをお持ちですか？',
		'Always Visible': '常に表示',
		'Amount': '金額',
		'Amt': '金額',
		'Analytics': 'アナリティクス',
		'Apple Key ID': 'Apple キー ID',
		'Apple Private Key (.p8)': 'Apple 秘密鍵 (.p8)',
		'Apple Services ID': 'Apple Services ID',
		'Apple sign-in failed. Please try again.': 'Apple サインインに失敗しました。もう一度お試しください。',
		'Apple sign-up failed. Please try again.': 'Apple サインアップに失敗しました。もう一度お試しください。',
		'Apple Team ID': 'Apple チーム ID',
		'Application': 'アプリケーション',
		'Application (client) ID': 'アプリケーション (クライアント) ID',
		'Application Created': 'アプリケーション作成',
		'Application Deleted': 'アプリケーション削除',
		'Application Name': 'アプリケーション名',
		'Application Updated': 'アプリケーション更新',
		'Application Usage': 'アプリケーション使用状況',
		'Application name is required.': 'アプリケーション名は必須です。',
		'Application not found or is no longer active.': 'アプリケーションが見つからないか、無効になっています。',
		'Application updated successfully.': 'アプリケーションを更新しました。',
		'Applications': 'アプリケーション',
		'Applications:': 'アプリケーション:',
		'Apply Crop': 'トリミングを適用',
		'Apps you’re registered with': '登録済みのアプリ',
		'Are you sure?': 'よろしいですか？',
		'Assign CSV columns to user fields. <strong>Email</strong> is required.': 'CSV 列をユーザーフィールドに割り当てます。<strong>メールアドレス</strong>は必須です。',
		'At least 8 characters': '8文字以上',
		'Audience': '対象者',
		'Audience:': '対象者:',
		'Audit Entries': '監査エントリ',
		'Audit Logs': '監査ログ',
		'Audit Trail': '監査証跡',
		'Auth Provider': '認証プロバイダ',
		'Authentication': '認証',
		'Authorization Successful': '認可が完了しました',
		'Authorization URLs': '認可 URL',
		'Authorization failed. Please try again.': '認可に失敗しました。もう一度お試しください。',
		'Authorize': '認可する',
		'Authorized': '認可済み',
		'Auto-Approve': '自動承認',
		'Auto-Approve Users': 'ユーザーを自動承認',
		'Auto-approve': '自動承認',
		'Available Tokens': '利用可能なトークン',
		'Available placeholders:': '利用可能なプレースホルダー:',
		'Avatar removed.': 'アバターを削除しました。',
		'Avatar uploaded.': 'アバターをアップロードしました。',
		'Avg. interval per email': 'メール1通あたりの平均間隔',
		'Awaiting Approval': '承認待ち',
		'Already Authorized': '認証済み',
		'Back': '戻る',
		'Back to Applications': 'アプリケーション一覧に戻る',
		'Back to Newsletters': 'ニュースレター一覧に戻る',
		'Back to Users': 'ユーザー一覧に戻る',
		'Back to inline preview': 'インラインプレビューに戻る',
		'Back to sign in': 'サインインに戻る',
		'Backup Codes': 'バックアップコード',
		'Backup code': 'バックアップコード',
		'Bal': '残高',
		'Balance': '残高',
		'Base URL for accessing files publicly. If empty, uses the default path.': 'ファイルの公開アクセス用ベース URL。空の場合はデフォルトパスを使用します。',
		'Basic Information': '基本情報',
		'Batch Configuration & Timing': 'バッチ設定とタイミング',
		'Bio or description...': '自己紹介...',
		'Blacklisted IPs': 'ブラックリスト IP',
		'Body:': '本文:',
		'Bonus': 'ボーナス',
		'Bounced Recipients Excluded': 'バウンスされた受信者を除外',
		'Bounced users excluded': 'バウンスされたユーザーを除外',
		'Branding text and links shown on the login and registration pages.': 'ログイン・登録ページに表示されるブランディングテキストとリンク。',
		'Brief description (optional)': '簡単な説明（任意）',
		'Brief description of the application...': 'アプリケーションの簡単な説明...',
		'Brief description...': '簡単な説明...',
		'Bucket Name': 'バケット名',
		'CIDR notation, comma-separated.': 'CIDR 表記、カンマ区切り。',
		'Cache TTL (seconds)': 'キャッシュ TTL（秒）',
		'Campaign Details': 'キャンペーン詳細',
		'Campaign Name': 'キャンペーン名',
		'Cancel': 'キャンセル',
		'Cancelled': 'キャンセル済み',
		'Category': 'カテゴリ',
		'Category IDs': 'カテゴリ ID',
		'Change Password': 'パスワードを変更',
		'Changing...': '変更中...',
		'Check your email': 'メールを確認してください',
		'Checking for existing users…': '既存ユーザーを確認中…',
		'Choose a new password.': '新しいパスワードを設定してください。',
		'City, Country': '市区町村、国',
		'Clear': 'クリア',
		'Click Rate': 'クリック率',
		'Click the link in the email to verify your account. If you don\'t see it, check your spam folder.': 'メール内のリンクをクリックしてアカウントを認証してください。見つからない場合は迷惑メールフォルダをご確認ください。',
		'Clicks': 'クリック数',
		'Client Secret': 'クライアント シークレット',
		'Close': '閉じる',
		'Close Preview': 'プレビューを閉じる',
		'Comma-separated IPs or CIDRs': 'カンマ区切りの IP または CIDR',
		'Comma-separated WordPress category IDs. Leave empty to show all categories.': 'カンマ区切りの WordPress カテゴリ ID。空にするとすべてのカテゴリを表示します。',
		'Comma-separated. Evaluated after whitelist.': 'カンマ区切り。ホワイトリストの後に評価されます。',
		'Common ports: 587 (STARTTLS), 465 (TLS), 25 (plain).': '一般的なポート: 587 (STARTTLS), 465 (TLS), 25 (平文)。',
		'Company': '会社',
		'Company name': '会社名',
		'Completing sign-in…': 'サインインを完了しています…',
		'Configure a Services ID and signing key to show the "Sign in with Apple" button on the login page.': 'ログインページに「Apple でサインイン」ボタンを表示するには、Services ID と署名キーを設定してください。',
		'Configure an Entra ID app registration to show the "Sign in with Microsoft" button on the login page.': 'ログインページに「Microsoft でサインイン」ボタンを表示するには、Entra ID のアプリ登録を設定してください。',
		'Configure Google OAuth 2.0 to show the "Sign in with Google" button on the login page.': 'Google OAuth 2.0 を設定して、ログインページに「Google でサインイン」ボタンを表示します。',
		'Configure an S3-compatible storage backend for file uploads (AWS S3, MinIO, DigitalOcean Spaces, etc.).': 'ファイルアップロード用の S3 互換ストレージバックエンドを設定します（AWS S3、MinIO、DigitalOcean Spaces など）。',
		'Confirm': '確認',
		'Confirm Disable': '無効化を確認',
		'Confirm Import': 'インポートを確認',
		'Confirm Password': 'パスワードを確認',
		'Confirm new password': '新しいパスワードを確認',
		'Confirm password': 'パスワードを確認',
		'Contact Details': '連絡先情報',
		'Content': 'コンテンツ',
		'Continue': '続行',
		'Continue to': '続行:',
		'Continue to Dashboard': 'ダッシュボードへ進む',
		'Continue with Apple': 'Apple で続行',
		'Continue with Google': 'Google で続行',
		'Continue with Microsoft': 'Microsoft で続行',
		'Copied to clipboard': 'クリップボードにコピーしました',
		'Copy the token below and paste it into': '以下のトークンをコピーして貼り付けてください',
		'Copy to Clipboard': 'クリップボードにコピー',
		'Could not detect a WordPress REST API at this URL.': 'この URL で WordPress REST API を検出できませんでした。',
		'Count': '件数',
		'Create Application': 'アプリケーションを作成',
		'Create Newsletter': 'ニュースレターを作成',
		'Create Password': 'パスワードを作成',
		'Create Role': 'ロールを作成',
		'Create Template': 'テンプレートを作成',
		'Create User': 'ユーザーを作成',
		'Create a Password': 'パスワードを作成',
		'Create account': 'アカウントを作成',
		'Create an account': 'アカウントを作成',
		'Create credentials at': '認証情報を作成:',
		'Create, manage and send newsletter campaigns.': 'ニュースレターキャンペーンの作成、管理、送信を行います。',
		'Created': '作成日時',
		'Creating...': '作成中...',
		'Credentials & Preview': '認証情報とプレビュー',
		'Credit': 'クレジット',
		'Crop Profile Picture': 'プロフィール画像をトリミング',
		'Current': '現在',
		'Current Balance': '現在の残高',
		'Current Password': '現在のパスワード',
		'Current:': '現在:',
		'Custom Sidebar Links': 'カスタムサイドバーリンク',
		'Dark': 'ダーク',
		'Dark Mode': 'ダークモード',
		'Dashboard': 'ダッシュボード',
		'Database': 'データベース',
		'Date': '日付',
		'Debit': 'デビット',
		'Default Email Master Template': 'デフォルトメールマスターテンプレート',
		'Define access roles': 'アクセスロールを定義',
		'Define access roles and assign them to users or applications.': 'アクセスロールを定義し、ユーザーまたはアプリケーションに割り当てます。',
		'Delete': '削除',
		'Delivery': '配信',
		'Deny': '拒否',
		'Description': '説明',
		'Description (optional)': '説明（任意）',
		'Details': '詳細',
		'Detect': '検出',
		'Detecting...': '検出中...',
		'Devices and browsers where you\'re currently signed in.': '現在サインインしているデバイスとブラウザ。',
		'Didn\'t receive the email?': 'メールが届きませんでしたか？',
		'Directory (tenant) ID': 'ディレクトリ (テナント) ID',
		'Disable 2FA': '2FA を無効にする',
		'Dismiss': '閉じる',
		'Display a WordPress news feed on the non-admin user dashboard.': '管理者以外のユーザーダッシュボードに WordPress ニュースフィードを表示します。',
		'Display name for the website link on auth pages.': '認証ページのウェブサイトリンクに表示される名前。',
		'Display name next to the sender address.': '送信者アドレスの横に表示する名前。',
		'Doe': 'Doe',
		'Done': '完了',
		'Draft': '下書き',
		'Edit': '編集',
		'Edit Application': 'アプリケーションを編集',
		'Edit Newsletter': 'ニュースレターを編集',
		'Edit Role': 'ロールを編集',
		'Edit Template': 'テンプレートを編集',
		'Edit User': 'ユーザーを編集',
		'Edit your account details': 'アカウント情報を編集',
		'Eligible users': '対象ユーザー',
		'Email': 'メールアドレス',
		'Email OTP Requested': 'メール OTP リクエスト',
		'Email Template Preview': 'メールテンプレートプレビュー',
		'Email Templates': 'メールテンプレート',
		'Email Unverified': 'メール未認証',
		'Email Verified': 'メール認証済み',
		'Email address and verification status': 'メールアドレスと認証ステータス',
		'Email address updated successfully.': 'メールアドレスを更新しました。',
		'Email is required.': 'メールアドレスは必須です。',
		'Email subject line...': 'メールの件名...',
		'Emails Sent': '送信済みメール',
		'Emails Sent This Year': '今年の送信メール数',
		'Emails This Month': '今月のメール数',
		'Emails This Week': '今週のメール数',
		'Emails per batch': 'バッチあたりのメール数',
		'Enable 2FA': '2FA を有効にする',
		'Enable News Feed': 'ニュースフィードを有効にする',
		'Enable for port 465. For 587 with STARTTLS leave this off.': 'ポート 465 の場合に有効にします。587 で STARTTLS を使用する場合はオフのままにしてください。',
		'Endpoint URL': 'エンドポイント URL',
		'Enter a TOTP code or backup code to disable two-factor authentication.': '二要素認証を無効にするには、TOTP コードまたはバックアップコードを入力してください。',
		'Enter a domain or URL — click': 'ドメインまたは URL を入力し、クリック',
		'Enter it below.': '以下に入力してください。',
		'Enter one of your backup codes. Each code can only be used once.': 'バックアップコードを入力してください。各コードは1回のみ使用できます。',
		'Enter reset code': 'リセットコードを入力',
		'Enter the 6-digit code from your authenticator to complete setup:': '設定を完了するには、認証アプリの6桁のコードを入力してください:',
		'Enter the 6-digit code from your email:': 'メールに記載された6桁のコードを入力してください:',
		'Enter the 6-digit code sent to': '送信された6桁のコードを入力してください:',
		'Enter the code from your authenticator app.': '認証アプリのコードを入力してください。',
		'Enter the code sent to your email.': 'メールに送信されたコードを入力してください。',
		'Enter the email address to send a test message to.': 'テストメールの送信先メールアドレスを入力してください。',
		'Enter your email and we\'ll send you a reset code.': 'メールアドレスを入力してください。リセットコードをお送りします。',
		'Enter your email to get started.': 'メールアドレスを入力して始めましょう。',
		'Environment': '環境',
		'Error': 'エラー',
		'Estimated duration': '推定所要時間',
		'Failed': '失敗',
		'Failed to cancel newsletter': 'ニュースレターのキャンセルに失敗しました',
		'Failed to change password': 'パスワードの変更に失敗しました',
		'Failed to create application': 'アプリケーションの作成に失敗しました',
		'Failed to create user': 'ユーザーの作成に失敗しました',
		'Failed to delete application': 'アプリケーションの削除に失敗しました',
		'Failed to delete avatar': 'アバターの削除に失敗しました',
		'Failed to delete icon': 'アイコンの削除に失敗しました',
		'Failed to delete logo': 'ロゴの削除に失敗しました',
		'Failed to delete newsletter': 'ニュースレターの削除に失敗しました',
		'Failed to delete notification': '通知の削除に失敗しました',
		'Failed to delete passkey': 'パスキーの削除に失敗しました',
		'Failed to delete role': 'ロールの削除に失敗しました',
		'Failed to delete template': 'テンプレートの削除に失敗しました',
		'Failed to disable 2FA': '2FA の無効化に失敗しました',
		'Failed to load admin statistics': '管理者統計の読み込みに失敗しました',
		'Failed to load analytics': 'アナリティクスの読み込みに失敗しました',
		'Failed to load application': 'アプリケーションの読み込みに失敗しました',
		'Failed to load applications': 'アプリケーション一覧の読み込みに失敗しました',
		'Failed to load audit logs': '監査ログの読み込みに失敗しました',
		'Failed to load data': 'データの読み込みに失敗しました',
		'Failed to load image.': '画像の読み込みに失敗しました。',
		'Failed to load newsletters': 'ニュースレター一覧の読み込みに失敗しました',
		'Failed to load notifications': '通知の読み込みに失敗しました',
		'Failed to load passkeys': 'パスキー一覧の読み込みに失敗しました',
		'Failed to load preview': 'プレビューの読み込みに失敗しました',
		'Failed to load preview.': 'プレビューの読み込みに失敗しました。',
		'Failed to load profile': 'プロフィールの読み込みに失敗しました',
		'Failed to load profile.': 'プロフィールの読み込みに失敗しました。',
		'Failed to load roles': 'ロール一覧の読み込みに失敗しました',
		'Failed to load server preview': 'サーバープレビューの読み込みに失敗しました',
		'Failed to load sessions': 'セッション一覧の読み込みに失敗しました',
		'Failed to load settings': '設定の読み込みに失敗しました',
		'Failed to load staging data.': 'ステージングデータの読み込みに失敗しました。',
		'Failed to load templates': 'テンプレート一覧の読み込みに失敗しました',
		'Failed to load transactions': '取引履歴の読み込みに失敗しました',
		'Failed to load user': 'ユーザー情報の読み込みに失敗しました',
		'Failed to mark all as read': 'すべて既読にできませんでした',
		'Failed to mark as read': '既読にできませんでした',
		'Failed to pause newsletter': 'ニュースレターの一時停止に失敗しました',
		'Failed to record transaction': '取引の記録に失敗しました',
		'Failed to register passkey': 'パスキーの登録に失敗しました',
		'Failed to rename passkey': 'パスキーの名前変更に失敗しました',
		'Failed to resend.': '再送信に失敗しました。',
		'Failed to reset password. Please try again.': 'パスワードのリセットに失敗しました。もう一度お試しください。',
		'Failed to resume newsletter': 'ニュースレターの再開に失敗しました',
		'Failed to revoke session': 'セッションの無効化に失敗しました',
		'Failed to revoke sessions': 'セッションの無効化に失敗しました',
		'Failed to revoke sessions.': 'セッションの無効化に失敗しました。',
		'Failed to save SMTP settings': 'SMTP 設定の保存に失敗しました',
		'Failed to save newsletter': 'ニュースレターの保存に失敗しました',
		'Failed to save profile': 'プロフィールの保存に失敗しました',
		'Failed to save role': 'ロールの保存に失敗しました',
		'Failed to save security settings': 'セキュリティ設定の保存に失敗しました',
		'Failed to save settings': '設定の保存に失敗しました',
		'Failed to save template': 'テンプレートの保存に失敗しました',
		'Failed to send code. Please try again.': 'コードの送信に失敗しました。もう一度お試しください。',
		'Failed to send newsletter.': 'ニュースレターの送信に失敗しました。',
		'Failed to send notification': '通知の送信に失敗しました',
		'Failed to send reset email. Please try again.': 'リセットメールの送信に失敗しました。もう一度お試しください。',
		'Failed to send test email': 'テストメールの送信に失敗しました',
		'Failed to send test email.': 'テストメールの送信に失敗しました。',
		'Failed to send verification code': '認証コードの送信に失敗しました',
		'Failed to start 2FA setup': '2FA セットアップの開始に失敗しました',
		'Failed to update application': 'アプリケーションの更新に失敗しました',
		'Failed to update user': 'ユーザーの更新に失敗しました',
		'Failed to upload avatar': 'アバターのアップロードに失敗しました',
		'Failed to upload icon': 'アイコンのアップロードに失敗しました',
		'Failed to upload logo': 'ロゴのアップロードに失敗しました',
		'Feed URL': 'フィード URL',
		'Filtered by Application': 'アプリケーションでフィルタ',
		'Filtered by application': 'アプリケーションでフィルタ',
		'Filters': 'フィルタ',
		'First Name': '名',
		'First name': '名',
		'First name is required.': '名は必須です。',
		'Follow Abstract on Twitter': 'Abstract を Twitter でフォロー',
		'Forgot Password': 'パスワードをお忘れの場合',
		'Forgot password?': 'パスワードをお忘れですか？',
		'Found in the top-right of the Apple Developer portal.': 'Apple Developer ポータルの右上に表示されます。',
		'Framework': 'フレームワーク',
		'From Email': '送信元メールアドレス',
		'From Name': '送信者名',
		'General': '一般',
		'General Settings': '一般設定',
		'Get started in seconds — it\'s free.': '数秒で始められます — 無料です。',
		'Give your passkey a name to identify it later (e.g. "MacBook Touch ID").': 'パスキーに識別用の名前を付けてください（例: "MacBook Touch ID"）。',
		'Global': 'グローバル',
		'Global only': 'グローバルのみ',
		'Go to Dashboard': 'ダッシュボードへ',
		'Go to sign in': 'サインインへ',
		'Good afternoon': 'こんにちは',
		'Good evening': 'こんばんは',
		'Good morning': 'おはようございます',
		'Google Client ID': 'Google Client ID',
		'Google Client Secret': 'Google Client Secret',
		'Google Sign-In': 'Google サインイン',
		'Google sign-in failed. Please try again.': 'Google サインインに失敗しました。もう一度お試しください。',
		'Google sign-up failed. Please try again.': 'Google サインアップに失敗しました。もう一度お試しください。',
		'HTML Content': 'HTML コンテンツ',
		'Has password': 'パスワード設定済み',
		'Hello Jane!...': 'Hello Jane!...',
		'Hide password': 'パスワードを隠す',
		'How long to cache feed results server-side. Default: 900 (15 minutes).': 'フィード結果をサーバー側でキャッシュする時間。デフォルト: 900（15分）。',
		'I\'ve saved my codes': 'コードを保存しました',
		'ID': 'ID',
		'Identifier of the .p8 key enabled for Sign in with Apple.': 'Apple でサインインが有効化された .p8 キーの識別子です。',
		'IP Access Control': 'IP アクセス制御',
		'IP Address': 'IP アドレス',
		'IP Restrictions': 'IP 制限',
		'Icon (Font Awesome class)': 'アイコン（Font Awesome クラス）',
		'Icon Image': 'アイコン画像',
		'Icon removed.': 'アイコンを削除しました。',
		'Icon uploaded.': 'アイコンをアップロードしました。',
		'Identity, simplified.': 'シンプルなアイデンティティ管理。',
		'Import': 'インポート',
		'Import Users': 'ユーザーをインポート',
		'Import failed': 'インポートに失敗しました',
		'Imported': 'インポート済み',
		'Imported users will be created as dormant accounts (authProvider = \'imported\'). They can receive newsletters and log in via email OTP without needing to register separately.': 'インポートされたユーザーは休眠アカウント（authProvider = \'imported\'）として作成されます。ニュースレターを受信でき、別途登録せずにメール OTP でログインできます。',
		'Importing…': 'インポート中…',
		'Inactive': '無効',
		'Increase security by creating a password for your account.': 'パスワードを作成してアカウントのセキュリティを強化しましょう。',
		'Info': '情報',
		'Inline newsletter preview': 'インラインニュースレタープレビュー',
		'Insert token:': 'トークンを挿入:',
		'Internal notes (only visible to admins)...': '内部メモ（管理者のみ表示）...',
		'Interval between batches': 'バッチ間の間隔',
		'Invalid': '無効',
		'Invalid (skipped):': '無効（スキップ）:',
		'Invalid application ID.': '無効なアプリケーション ID です。',
		'Invalid code. Please try again.': '無効なコードです。もう一度お試しください。',
		'Invalid newsletter ID.': '無効なニュースレター ID です。',
		'Invalid or expired code': '無効または期限切れのコードです',
		'Invalid or expired code.': '無効または期限切れのコードです。',
		'Invalid user ID.': '無効なユーザー ID です。',
		'John': 'John',
		'Join Abstract on Discord': 'Abstract の Discord に参加',
		'Joined': '登録日',
		'Label': 'ラベル',
		'Language': '言語',
		'Large heading on the auth page branding panel.': '認証ページのブランディングパネルに表示される大見出し。',
		'Last Login': '最終ログイン',
		'Last Name': '姓',
		'Last login:': '最終ログイン:',
		'Last name': '姓',
		'Last name is required.': '姓は必須です。',
		'Last used': '最終使用',
		'Latest News': '最新ニュース',
		'Leave all fields empty to use local disk storage.': 'ローカルディスクストレージを使用するには、すべてのフィールドを空にしてください。',
		'Leave as "None" for a global role that applies across all applications.': 'すべてのアプリケーションに適用されるグローバルロールの場合は「なし」のままにしてください。',
		'Leave empty for unlimited.': '無制限にするには空にしてください。',
		'Leave empty to accept any Microsoft account. Set a directory ID to restrict sign-in to one organisation.': '空にするとすべての Microsoft アカウントを受け入れます。ディレクトリ ID を設定すると、サインインを 1 つの組織に限定できます。',
		'Leave empty to auto-generate the plain-text part from the HTML body.': '空欄のままにすると、HTML 本文からプレーンテキスト部分が自動生成されます。',
		'Leave empty to disable Google Sign-In.': 'Google サインインを無効にするには空にしてください。',
		'Leave empty to disable Sign in with Apple.': 'Apple でサインインを無効にするには空にしてください。',
		'Leave empty to disable Sign in with Microsoft.': 'Microsoft でサインインを無効にするには空にしてください。',
		'Light': 'ライト',
		'Link icon': 'リンクアイコン',
		'Linked from login/register pages and emails.': 'ログイン/登録ページおよびメールからリンクされます。',
		'Linked on login and registration pages.': 'ログインおよび登録ページにリンクされます。',
		'Live Preview': 'ライブプレビュー',
		'Loading audit logs…': '監査ログを読み込み中…',
		'Loading notifications...': '通知を読み込み中...',
		'Loading notifications…': '通知を読み込み中…',
		'Loading roles...': 'ロールを読み込み中...',
		'Loading…': '読み込み中…',
		'Location': '所在地',
		'Login Heading': 'ログイン見出し',
		'Login Subheading': 'ログインサブ見出し',
		'Login failed. Please try again.': 'ログインに失敗しました。もう一度お試しください。',
		'Logins (24h)': 'ログイン数（24時間）',
		'Logo Image': 'ロゴ画像',
		'Logo removed.': 'ロゴを削除しました。',
		'Logo uploaded.': 'ロゴをアップロードしました。',
		'Manage Users': 'ユーザー管理',
		'Manage active sessions': 'アクティブセッションを管理',
		'Manage passkey credentials': 'パスキー認証情報を管理',
		'Manage user accounts and permissions': 'ユーザーアカウントと権限を管理',
		'Map Columns': '列のマッピング',
		'Mark all as read': 'すべて既読にする',
		'Mark as read': '既読にする',
		'Master Template': 'マスターテンプレート',
		'Master Template:': 'マスターテンプレート:',
		'Max Forgot-Password Requests': 'パスワードリセットリクエストの最大数',
		'Max Reset-Password Attempts': 'パスワードリセット試行の最大数',
		'Media': 'メディア',
		'Message (optional)': 'メッセージ（任意）',
		'Microsoft sign-in failed. Please try again.': 'Microsoft サインインに失敗しました。もう一度お試しください。',
		'Microsoft sign-up failed. Please try again.': 'Microsoft サインアップに失敗しました。もう一度お試しください。',
		'Migration Contact Email': '移行連絡先メールアドレス',
		'Must be 3–30 characters (letters, numbers, underscores).': '3〜30文字（英数字、アンダースコア）で入力してください。',
		'Must be at least 8 characters.': '8文字以上で入力してください。',
		'Must match a Return URL registered on the Services ID exactly.': 'Services ID に登録されたリターン URL と完全に一致する必要があります。',
		'My Application': 'マイアプリケーション',
		'My Applications': 'マイアプリケーション',
		'My Apps': 'マイアプリ',
		'My Passkey': 'マイパスキー',
		'My Profile': 'マイプロフィール',
		'Name': '名前',
		'Name your passkey': 'パスキーに名前を付ける',
		'Name, username, and avatar': '名前、ユーザー名、アバター',
		'Never': 'なし',
		'Never used': '未使用',
		'New Application': '新規アプリケーション',
		'New Newsletter': '新規ニュースレター',
		'New Password': '新しいパスワード',
		'New Role': '新規ロール',
		'New Template': '新規テンプレート',
		'New email address': '新しいメールアドレス',
		'New password': '新しいパスワード',
		'New password is required.': '新しいパスワードは必須です。',
		'New passwords do not match.': '新しいパスワードが一致しません。',
		'New username': '新しいユーザー名',
		'New users': '新規ユーザー',
		'New users to import:': 'インポートする新規ユーザー:',
		'News Feed': 'ニュースフィード',
		'Newsletter Cancelled': 'ニュースレターキャンセル',
		'Newsletter Created': 'ニュースレター作成',
		'Newsletter Deleted': 'ニュースレター削除',
		'Newsletter Paused': 'ニュースレター一時停止',
		'Newsletter Preview': 'ニュースレタープレビュー',
		'Newsletter Resumed': 'ニュースレター再開',
		'Newsletter Sent': 'ニュースレター送信',
		'Newsletter Started': 'ニュースレター開始',
		'Newsletter Updated': 'ニュースレター更新',
		'Newsletter cancelled.': 'ニュースレターをキャンセルしました。',
		'Newsletter created.': 'ニュースレターを作成しました。',
		'Newsletter default': 'ニュースレターデフォルト',
		'Newsletter deleted.': 'ニュースレターを削除しました。',
		'Newsletter dispatch started.': 'ニュースレターの配信を開始しました。',
		'Newsletter paused.': 'ニュースレターを一時停止しました。',
		'Newsletter preview': 'ニュースレタープレビュー',
		'Newsletter resumed.': 'ニュースレターを再開しました。',
		'Newsletter updated.': 'ニュースレターを更新しました。',
		'Newsletters': 'ニュースレター',
		'Next': '次へ',
		'No Backend Response': 'バックエンドからの応答がありません',
		'No Recipients': '受信者なし',
		'No active sessions.': 'アクティブなセッションはありません。',
		'No application registrations yet.': 'アプリケーション登録はまだありません。',
		'No applications configured.': 'アプリケーションが設定されていません。',
		'No applications found.': 'アプリケーションが見つかりません。',
		'No applications match your filters': 'フィルタに一致するアプリケーションはありません',
		'No applications registered yet': 'アプリケーションはまだ登録されていません',
		'No applications registered.': 'アプリケーションは登録されていません。',
		'No audit logs found.': '監査ログが見つかりません。',
		'No email templates yet': 'メールテンプレートはまだありません',
		'No master template': 'マスターテンプレートなし',
		'No new users to import. All valid email addresses already exist in the system.': 'インポートする新規ユーザーはいません。すべての有効なメールアドレスは既にシステムに存在しています。',
		'No newsletters found.': 'ニュースレターが見つかりません。',
		'No notifications yet.': '通知はまだありません。',
		'No passkeys registered yet.': 'パスキーはまだ登録されていません。',
		'No password — signs in via email OTP': 'パスワード未設定 — メール OTP でサインイン',
		'No recipients match the audience criteria. Adjust the audience settings before sending.': '対象条件に一致する受信者がいません。送信前に対象設定を調整してください。',
		'No roles defined yet': 'ロールはまだ定義されていません',
		'No roles defined yet.': 'ロールはまだ定義されていません。',
		'No roles match your filters': 'フィルタに一致するロールはありません',
		'No settings found.': '設定が見つかりません。',
		'No settings found. Save defaults to create the settings row.': '設定が見つかりません。デフォルト設定を保存して設定行を作成してください。',
		'No subject yet': '件名未設定',
		'No templates match your filters': 'フィルタに一致するテンプレートはありません',
		'No transactions yet.': '取引はまだありません。',
		'No users found': 'ユーザーが見つかりません',
		'No users match your filters': 'フィルタに一致するユーザーはいません',
		'No, cancel': 'いいえ、キャンセル',
		'Non-Registered Redirect URL': '未登録リダイレクト URL',
		'None': 'なし',
		'None (Global)': 'なし（グローバル）',
		'Not configured': '未設定',
		'Nothing here yet': 'まだ何もありません',
		'Notifications': '通知',
		'OAuth': 'OAuth',
		'Open Rate': '開封率',
		'Open your authenticator app and enter the 6-digit code.': '認証アプリを開いて、6桁のコードを入力してください。',
		'Opens': '開封数',
		'Opt out of newsletters': 'ニュースレターの配信を停止',
		'Opted-out users excluded': '配信停止ユーザーを除外',
		'Optionally register imported users to one or more applications. This step is optional — you can skip it to import users without application registrations.': 'インポートしたユーザーを1つ以上のアプリケーションに登録できます。このステップは任意です — スキップしてアプリケーション登録なしでインポートすることもできます。',
		'Or enter manually:': 'または手動で入力:',
		'Order': '順序',
		'Overview': '概要',
		'Page Not Found': 'ページが見つかりません',
		'Paragraph text below the heading.': '見出しの下に表示される段落テキスト。',
		'Passkey deleted.': 'パスキーを削除しました。',
		'Passkey registered successfully!': 'パスキーを登録しました！',
		'Passkey renamed.': 'パスキーの名前を変更しました。',
		'Passkey sign-in failed. Please try again.': 'パスキーでのサインインに失敗しました。もう一度お試しください。',
		'Passkeys': 'パスキー',
		'Password': 'パスワード',
		'Password Changed': 'パスワード変更',
		'Password Reset Completed': 'パスワードリセット完了',
		'Password Reset Requested': 'パスワードリセットリクエスト',
		'Password changed successfully.': 'パスワードを変更しました。',
		'Password created successfully.': 'パスワードを作成しました。',
		'Password is required.': 'パスワードは必須です。',
		'Password must be at least 6 characters.': 'パスワードは6文字以上で入力してください。',
		'Password must be at least 8 characters.': 'パスワードは8文字以上で入力してください。',
		'Passwordless': 'パスワードレス',
		'Passwords do not match.': 'パスワードが一致しません。',
		'Paste the full contents of the .p8 file downloaded from Apple.': 'Apple からダウンロードした .p8 ファイルの内容をすべて貼り付けてください。',
		'Pause': '一時停止',
		'Paused': '一時停止中',
		'Pending': '保留中',
		'Performed By': '実行者',
		'Personal Information': '個人情報',
		'Plain text version...': 'プレーンテキスト版...',
		'Plain-Text Fallback (optional)': 'プレーンテキストフォールバック（任意）',
		'Platform configuration': 'プラットフォーム設定',
		'Please enter a backup code.': 'バックアップコードを入力してください。',
		'Please enter a new password.': '新しいパスワードを入力してください。',
		'Please enter a valid code to disable 2FA.': '2FA を無効にするには、有効なコードを入力してください。',
		'Please enter a valid email address.': '有効なメールアドレスを入力してください。',
		'Please enter a valid, available username.': '有効かつ利用可能なユーザー名を入力してください。',
		'Please enter the 6-digit verification code.': '6桁の認証コードを入力してください。',
		'Please enter your current password.': '現在のパスワードを入力してください。',
		'Please wait while we verify your account.': 'アカウントを認証しています。しばらくお待ちください。',
		'Policies': 'ポリシー',
		'Preferences': '設定',
		'Prev': '前へ',
		'Preview': 'プレビュー',
		'Preview (first 5 rows)': 'プレビュー（先頭5行）',
		'Preview Consent': '同意画面のプレビュー',
		'Preview Token Flow': 'トークンフローのプレビュー',
		'Previous': '前へ',
		'Private Key': 'プライベートキー',
		'Profile': 'プロフィール',
		'Profile Picture': 'プロフィール画像',
		'Profile updated successfully.': 'プロフィールを更新しました。',
		'Public Content': '公開コンテンツ',
		'Public URL (optional)': '公開 URL（任意）',
		'Purchase': '購入',
		'Quick Actions': 'クイックアクション',
		'Rate Limiting': 'レート制限',
		'Re-enter your new password': '新しいパスワードを再入力',
		'Re-enter your password': 'パスワードを再入力',
		'Reason': '理由',
		'Recent Activity': '最近のアクティビティ',
		'Recent Notifications': '最近の通知',
		'Recipient Breakdown': '受信者の内訳',
		'Recipient Email': '受信者メールアドレス',
		'Recipients': '受信者',
		'Record': '記録',
		'Record Transaction': '取引を記録',
		'Redirect URI': 'リダイレクト URI',
		'Refresh': '更新',
		'Refresh Stats': '統計を更新',
		'Refund': '返金',
		'Region': 'リージョン',
		'Register again': '再登録',
		'Register and manage applications that use this identity provider.': 'この ID プロバイダを使用するアプリケーションを登録・管理します。',
		'Register and manage apps': 'アプリの登録と管理',
		'Register this exact URL as a Web redirect URI on the app. It must end in /auth/microsoft/callback.': 'この URL をそのままアプリの Web リダイレクト URI として登録してください。末尾は /auth/microsoft/callback である必要があります。',
		'Register to Applications': 'アプリケーションに登録',
		'Registration failed. Please try again.': '登録に失敗しました。もう一度お試しください。',
		'Reload all administration statistics': 'すべての管理統計を再読み込み',
		'Remove': '削除',
		'Remove Icon': 'アイコンを削除',
		'Replace Icon': 'アイコンを差し替え',
		'Required for server-side token verification.': 'サーバー側のトークン検証に必要です。',
		'Resend code': 'コードを再送信',
		'Reset Password': 'パスワードをリセット',
		'Reset code is invalid or expired.': 'リセットコードが無効または期限切れです。',
		'Reset password': 'パスワードをリセット',
		'Resized to 128×128': '128×128 にリサイズ',
		'Resized to 512×512': '512×512 にリサイズ',
		'Resume': '再開',
		'Retry': '再試行',
		'Return URL': 'リターン URL',
		'Review': '確認',
		'Review Data': 'データを確認',
		'Review system activity and security events': 'システムアクティビティとセキュリティイベントを確認',
		'Review the details below before sending this newsletter.': 'ニュースレターを送信する前に、以下の詳細をご確認ください。',
		'Review the validation results below before importing.': 'インポートする前に、以下の検証結果をご確認ください。',
		'Revoke': '無効にする',
		'Revoke All Sessions': 'すべてのセッションを無効にする',
		'Revoke all others': '他のセッションをすべて無効にする',
		'Revoking…': '無効化中…',
		'Role': 'ロール',
		'Role Changed': 'ロール変更',
		'Role Created': 'ロール作成',
		'Role Deleted': 'ロール削除',
		'Role Name': 'ロール名',
		'Role Updated': 'ロール更新',
		'Role name is required.': 'ロール名は必須です。',
		'Roles': 'ロール',
		'Row': '行',
		'S3 Storage': 'S3 ストレージ',
		'S3-compatible endpoint (e.g. https://s3.amazonaws.com or your MinIO URL).': 'S3 互換エンドポイント（例: https://s3.amazonaws.com またはお使いの MinIO URL）。',
		'Sign in with Apple': 'Apple でサインイン',
		'Sign in with Microsoft': 'Microsoft でサインイン',
		'Sign up with Apple': 'Apple でサインアップ',
		'Sign up with Microsoft': 'Microsoft でサインアップ',
		'Signing you out…': 'サインアウトしています…',
		'SMTP': 'SMTP',
		'SMTP Configuration': 'SMTP 設定',
		'SMTP Host': 'SMTP ホスト',
		'SMTP Port': 'SMTP ポート',
		'SMTP Status': 'SMTP ステータス',
		'SMTP connection verified successfully.': 'SMTP 接続の検証に成功しました。',
		'SMTP settings saved successfully.': 'SMTP 設定を保存しました。',
		'SMTP verification failed': 'SMTP 検証に失敗しました',
		'Save': '保存',
		'Save Changes': '変更を保存',
		'Save Profile': 'プロフィールを保存',
		'Save SMTP': 'SMTP を保存',
		'Save Security Settings': 'セキュリティ設定を保存',
		'Save Settings': '設定を保存',
		'Save these codes in a safe place. Each can be used once if you lose your authenticator. They will not be shown again.': 'これらのコードを安全な場所に保存してください。認証アプリを紛失した場合、各コードは1回のみ使用できます。再表示されません。',
		'Saving...': '保存中...',
		'Scan with your authenticator app:': '認証アプリでスキャンしてください:',
		'Scheduled': 'スケジュール済み',
		'Scoped to Application': 'アプリケーションスコープ',
		'Search': '検索',
		'Search applications...': 'アプリケーションを検索...',
		'Search by name or email...': '名前またはメールで検索...',
		'Search logs...': 'ログを検索...',
		'Search name or subject…': '名前または件名で検索…',
		'Search roles...': 'ロールを検索...',
		'Search templates...': 'テンプレートを検索...',
		'Seconds before expiry during which a refresh is allowed. Default 4320 (72 min).': '有効期限前にリフレッシュが許可される秒数。デフォルト 4320（72分）。',
		'Secret Access Key': 'Secret Access Key',
		'Secret is configured': 'シークレットが設定済みです',
		'Secure authentication, role management, and user administration — all in one place.': '安全な認証、ロール管理、ユーザー管理をひとつの場所で。',
		'Security': 'セキュリティ',
		'Security & Access Control': 'セキュリティとアクセス制御',
		'Security settings saved successfully.': 'セキュリティ設定を保存しました。',
		'Select…': '選択…',
		'Send': '送信',
		'Send Notification': '通知を送信',
		'Send Test Email': 'テストメールを送信',
		'Send reset code': 'リセットコードを送信',
		'Send test email': 'テストメールを送信',
		'Sender Identity': '送信者情報',
		'Sending': '送信中',
		'Sending...': '送信中...',
		'Sent': '送信済み',
		'Sent At': '送信日時',
		'Server': 'サーバー',
		'Server Preview': 'サーバープレビュー',
		'Server-rendered newsletter preview': 'サーバーレンダリングされたニュースレタープレビュー',
		'Service Active': 'サービス有効',
		'Session Locations': 'セッションの位置情報',
		'Session revoked.': 'セッションを無効にしました。',
		'Sessions': 'セッション',
		'Settings': '設定',
		'Settings Changed': '設定変更',
		'Settings saved successfully.': '設定を保存しました。',
		'Show password': 'パスワードを表示',
		'Showing': '表示中',
		'Shown during account migration / data transfer.': 'アカウント移行/データ転送時に表示されます。',
		'Sidebar link icon removed.': 'サイドバーリンクのアイコンを削除しました。',
		'Sidebar link icon uploaded.': 'サイドバーリンクのアイコンをアップロードしました。',
		'Sign Out': 'サインアウト',
		'Sign in': 'サインイン',
		'Sign in or Register': 'サインインまたは登録',
		'Sign in securely with fingerprint, face recognition, or security keys.': '指紋認証、顔認証、またはセキュリティキーで安全にサインインします。',
		'Sign in to': 'サインイン:',
		'Sign in with Google': 'Google でサインイン',
		'Sign in with a passkey': 'パスキーでサインイン',
		'Sign in with email code instead': 'メールコードでサインイン',
		'Sign in with password': 'パスワードでサインイン',
		'Sign up with Google': 'Google でサインアップ',
		'Signups This Week': '今週の登録数',
		'Signups This Year': '今年の登録数',
		'Skip': 'スキップ',
		'Social Account Linked': 'ソーシャルアカウント連携',
		'Stack trace': 'スタックトレース',
		'Start typing HTML content to see a preview': 'HTML コンテンツを入力するとプレビューが表示されます',
		'Status': 'ステータス',
		'Status & Features': 'ステータスと機能',
		'Status:': 'ステータス:',
		'Stay up to date with your account activity': 'アカウントのアクティビティを確認しましょう',
		'Subject': '件名',
		'Subject Line': '件名',
		'Subject:': '件名:',
		'Success': '成功',
		'Synced': '同期済み',
		'System': 'システム',
		'System Errors': 'システムエラー',
		'System Information': 'システム情報',
		'Target': 'ターゲット',
		'Template': 'テンプレート',
		'Template Name': 'テンプレート名',
		'Template Preview': 'テンプレートプレビュー',
		'Template created.': 'テンプレートを作成しました。',
		'Template deleted.': 'テンプレートを削除しました。',
		'Template name and subject are required.': 'テンプレート名と件名は必須です。',
		'Template updated.': 'テンプレートを更新しました。',
		'Terms of Service': '利用規約',
		'Terms of Service URL': '利用規約 URL',
		'Test email sent to your address.': 'テストメールを送信しました。',
		'Text Content (fallback)': 'テキストコンテンツ（フォールバック）',
		'The application you were trying to sign in to was not found or is no longer active.': 'サインインしようとしたアプリケーションが見つからないか、無効になっています。',
		'The master template used by newsletters when no specific template is selected.': 'テンプレートが指定されていない場合にニュースレターで使用されるマスターテンプレート。',
		'The page you\'re looking for doesn\'t exist or has been moved.': 'お探しのページは存在しないか、移動されました。',
		'The secret value, not its ID. Secrets expire — note the expiry date.': 'シークレットの ID ではなく値を入力してください。シークレットには有効期限があります。',
		'The sender address in the email From header.': 'メールの From ヘッダーに使用される送信者アドレス。',
		'The verification link may have expired. Please try registering again.': '認証リンクの有効期限が切れている可能性があります。再度登録をお試しください。',
		'Theme': 'テーマ',
		'This is a preview of the consent page. No authorization will be performed.': 'これは同意ページのプレビューです。実際の認可は行われません。',
		'This is a preview of the token staging page. In the real flow, the user\'s JWT would appear below.': 'これはトークンステージングページのプレビューです。実際のフローでは、ユーザーの JWT が以下に表示されます。',
		'This is a preview. In the real flow, the user would be redirected back to': 'これはプレビューです。実際のフローでは、ユーザーは以下にリダイレクトされます:',
		'This is a preview. No real token was generated.': 'これはプレビューです。実際のトークンは生成されていません。',
		'This page is part of the Microsoft sign-in flow and can be closed.': 'このページは Microsoft サインインの一部です。閉じてかまいません。',
		'Time': '時間',
		'Title (required)': 'タイトル（必須）',
		'Toggle dark mode': 'ダークモードを切り替え',
		'Token & Session': 'トークンとセッション',
		'Token Flow': 'トークンフロー',
		'Token Flow Preview': 'トークンフロープレビュー',
		'Token Refresh Window (seconds)': 'トークンリフレッシュウィンドウ（秒）',
		'Token copied to clipboard': 'トークンをクリップボードにコピーしました',
		'Tokens': 'トークン',
		'Tokens are replaced per-recipient at send time. The preview shows sample data.': 'トークンは送信時に受信者ごとに置換されます。プレビューにはサンプルデータが表示されます。',
		'Top Clicked URLs': 'クリック数の多い URL',
		'Total Recipients': '受信者総数',
		'Total Users': '総ユーザー数',
		'Total batches': '総バッチ数',
		'Total rows': '総行数',
		'Two-Factor Authentication': '二要素認証',
		'Two-factor authentication': '二要素認証',
		'Two-factor authentication enabled successfully!': '二要素認証を有効にしました！',
		'Two-factor authentication has been disabled.': '二要素認証を無効にしました。',
		'Type': 'タイプ',
		'URL': 'URL',
		'UUID': 'UUID',
		'Unknown device': '不明なデバイス',
		'Unlimited': '無制限',
		'Unnamed': '名称未設定',
		'Unnamed User': '名前未設定のユーザー',
		'Unsubscribes': '配信停止',
		'Unverified': '未認証',
		'Updated': '更新日時',
		'Upload': 'アップロード',
		'Upload CSV File': 'CSV ファイルをアップロード',
		'Upload Icon': 'アイコンをアップロード',
		'Upload Logo': 'ロゴをアップロード',
		'Upload a CSV file containing the users you want to import. The first row should contain column headers (e.g. Email, First Name, Last Name).': 'インポートするユーザーを含む CSV ファイルをアップロードしてください。1行目には列ヘッダー（例: Email, First Name, Last Name）を含めてください。',
		'Upload a square image. It will be resized to 256×256 pixels.': '正方形の画像をアップロードしてください。256×256 ピクセルにリサイズされます。',
		'Uploading…': 'アップロード中…',
		'Use TLS': 'TLS を使用',
		'Use a backup code instead': '代わりにバックアップコードを使用',
		'Use a passkey': 'パスキーを使用',
		'Use authenticator app instead': '代わりに認証アプリを使用',
		'Use passkey': 'パスキーを使用',
		'Use password': 'パスワードを使用',
		'User': 'ユーザー',
		'User Activated': 'ユーザー有効化',
		'User Dashboard': 'ユーザーダッシュボード',
		'User Deactivated': 'ユーザー無効化',
		'User Deleted': 'ユーザー削除',
		'User Login': 'ユーザーログイン',
		'User Registered': 'ユーザー登録',
		'User Updated': 'ユーザー更新',
		'User Verified': 'ユーザー認証',
		'User dashboard settings saved.': 'ユーザーダッシュボード設定を保存しました。',
		'User updated successfully.': 'ユーザーを更新しました。',
		'Username': 'ユーザー名',
		'Username updated successfully.': 'ユーザー名を更新しました。',
		'Users': 'ユーザー',
		'Uses the WordPress REST API': 'WordPress REST API を使用します',
		'Verification Link Expiry': '認証リンクの有効期限',
		'Verification URLs': '認証 URL',
		'Verification code sent to your email.': '認証コードをメールに送信しました。',
		'Verification failed. The link may be invalid or expired.': '認証に失敗しました。リンクが無効または期限切れの可能性があります。',
		'Verified': '認証済み',
		'Verify': '認証',
		'Verify Connection': '接続を検証',
		'Verify your identity': '本人確認',
		'Verifying your email': 'メールアドレスを認証中',
		'Verifying...': '認証中...',
		'Version': 'バージョン',
		'View all audit logs': 'すべての監査ログを表示',
		'View all notifications': 'すべての通知を表示',
		'View and edit accounts': 'アカウントの表示と編集',
		'View details': '詳細を表示',
		'View transactions & balance': '取引と残高を表示',
		'View your notifications': '通知を表示',
		'View, search, and manage user accounts': 'ユーザーアカウントの表示、検索、管理',
		'Visible': '表示',
		'Visible When Registered': '登録時に表示',
		'Warning': '警告',
		'Wave': 'ウェーブ',
		'Wave Interval (sec)': 'ウェーブ間隔（秒）',
		'Wave Size': 'ウェーブサイズ',
		'We sent a 6-digit code to': '6桁のコードを送信しました:',
		'We sent a verification link to': '認証リンクを送信しました:',
		'We sent a verification link to your email address.': '認証リンクをメールアドレスに送信しました。',
		'We\'ve sent you a verification link.': '認証リンクを送信しました。',
		'Website': 'ウェブサイト',
		'Website Name': 'ウェブサイト名',
		'Website URL': 'ウェブサイト URL',
		'What this role grants access to...': 'このロールがアクセスを許可する対象...',
		'When disabled, the feed section is hidden from the user dashboard.': '無効にすると、フィードセクションがユーザーダッシュボードから非表示になります。',
		'When disabled, the identity service rejects new registrations.': '無効にすると、ID サービスは新規登録を拒否します。',
		'When enabled, multiple accounts may share the same email address.': '有効にすると、複数のアカウントが同じメールアドレスを共有できます。',
		'When enabled, you won\'t receive promotional emails.': '有効にすると、プロモーションメールを受信しなくなります。',
		'Whitelisted IPs': 'ホワイトリスト IP',
		'WordPress REST API detected successfully.': 'WordPress REST API を検出しました。',
		'Yes, I\'m sure': 'はい、確認しました',
		'Yes, confirm': 'はい、確認します',
		'You are not registered with any applications yet.': 'まだアプリケーションに登録されていません。',
		'You have no notifications right now.': '現在、通知はありません。',
		'Your Account': 'あなたのアカウント',
		'Your account is protected with TOTP authenticator.': 'アカウントは TOTP 認証アプリで保護されています。',
		'Your assigned roles for this application': 'このアプリケーションでの割り当てロール',
		'Your email has been verified! You can now sign in.': 'メールアドレスが認証されました！サインインできます。',
		'Your gateway to the Abstract platform. Manage your identity, applications, and security — all in one place.': 'Abstract プラットフォームへのゲートウェイ。アイデンティティ、アプリケーション、セキュリティをひとつの場所で管理できます。',
		'Your password has been reset successfully.': 'パスワードをリセットしました。',
		'Your request to access': 'アクセスリクエスト:',
		"You've previously granted access to": '以前にアクセスを許可しました:',
		'allow all.': 'すべて許可。',
		'by': '実行者',
		'cancel this newsletter': 'このニュースレターをキャンセル',
		'delete this application': 'このアプリケーションを削除',
		'delete this icon': 'このアイコンを削除',
		'delete this logo': 'このロゴを削除',
		'delete this newsletter': 'このニュースレターを削除',
		'delete this role': 'このロールを削除',
		'delete this template': 'このテンプレートを削除',
		'dismiss': '閉じる',
		'e.g. January Newsletter': '例: 1月のニュースレター',
		'e.g. a1b2c3d4': '例: a1b2c3d4',
		'e.g. admin, editor, viewer': '例: admin, editor, viewer',
		'has been submitted. An administrator will review and approve your access.': 'が送信されました。管理者がアクセスを確認・承認します。',
		'inserting into:': '挿入先:',
		'is an': 'は',
		'is requesting access to your account. By continuing, you allow this application to verify your identity': 'があなたのアカウントへのアクセスを要求しています。続行すると、このアプリケーションがあなたの本人確認を行うことを許可します',
		'just now': 'たった今',
		'key': 'キー',
		'of': '/',
		'or': 'または',
		'or Apple': 'または Apple',
		'or Microsoft': 'または Microsoft',
		'or Google': 'または Google',
		'product.': '製品。',
		'region': 'リージョン',
		'regions': 'リージョン',
		'remove this icon': 'このアイコンを削除',
		'remove your avatar': 'アバターを削除',
		'revoke all sessions': 'すべてのセッションを無効にする',
		'session': 'セッション',
		'sessions': 'セッション',
		'to auto-resolve the WordPress REST API endpoint.': 'で WordPress REST API エンドポイントを自動検出します。',
		'to complete sign-in.': 'でサインインを完了します。',
		'to fetch recent posts.': 'で最新の投稿を取得します。',
		'tokens': 'トークン',
		'user@example.com': 'user@example.com',
		'username': 'username',
		'you@example.com': 'you@example.com',
		'— Not mapped —': '— 未割り当て —',
		'••••••••': '••••••••'
	},
	ko: {
		'Images': '이미지',
		'Not rated': '평가 없음',
		'Upload progress': '업로드 진행률',
		'Uploading… {{percent}}%': '업로드 중… {{percent}}%',
		'Linked tickets': '연결된 티켓',
		'Follow-up of': '후속 티켓 원본',
		'Continued in': '후속 티켓',
		'Ticket attachments': '티켓 첨부 파일',
		'Routing': '라우팅',
		'Edit routing': '라우팅 편집',
		'Edit routing for {{name}}': '{{name}} 라우팅 편집',
		'Edit routing for {{category}} on {{product}}': '{{product}}의 {{category}} 라우팅 편집',
		'Show routing for {{name}}': '{{name}} 라우팅 표시',
		'Hide routing for {{name}}': '{{name}} 라우팅 숨기기',
		'Product rule only': '제품 규칙만',
		'No support-enabled product takes this category.': '이 카테고리를 사용하는 지원 활성 제품이 없습니다.',
		'Notified': '알림 받음',
		'Auto-assigned': '자동 할당 대상',
		'Routing for {{product}}': '{{product}} 라우팅',
		'Routing for {{category}} on {{product}}': '{{product}}의 {{category}} 라우팅',
		'Applies to every ticket on {{product}}. Category rules add to it; for assignment, a category rule with auto-assign takes precedence.': '{{product}}의 모든 티켓에 적용됩니다. 카테고리 규칙은 여기에 추가되며, 할당의 경우 자동 할당이 있는 카테고리 규칙이 우선합니다.',
		'Applies to {{category}} tickets on {{product}}, in addition to the product rule.': '제품 규칙과 함께 {{product}}의 {{category}} 티켓에 적용됩니다.',
		'Notify: gets an email and a notification for each new ticket.': '알림: 새 티켓마다 이메일과 알림을 받습니다.',
		'Auto-assign: new tickets go to the least busy of these agents.': '자동 할당: 새 티켓은 이 상담원 중 가장 여유 있는 사람에게 할당됩니다.',
		'Notify {{name}}': '{{name}}에게 알림',
		'Auto-assign to {{name}}': '{{name}}에게 자동 할당',
		'Auto-assign': '자동 할당',
		'Routing saved.': '라우팅을 저장했습니다.',
		'Failed to save routing': '라우팅을 저장하지 못했습니다',
		'Assigned to {{name}} automatically': '{{name}}에게 자동으로 할당됨',
		'Owner': '소유자',
		'People': '참여자',
		'Remove {{name}} from this ticket?': '{{name}}님을 이 티켓에서 제외할까요?',
		'A ticket can have at most {{count}} people besides its owner.': '티켓에는 소유자 외에 최대 {{count}}명까지 추가할 수 있습니다.',
		'Add someone by email': '이메일로 사람 추가',
		'People you add need an Abstract ID account. They can read the ticket, reply to it and get its emails.': '추가하는 사람에게는 Abstract ID 계정이 필요합니다. 티켓을 읽고 답장할 수 있으며 관련 이메일을 받습니다.',
		'Leave this ticket? You will no longer be able to see it.': '이 티켓에서 나갈까요? 더 이상 티켓을 볼 수 없게 됩니다.',
		'Leave ticket': '티켓 나가기',
		'{{email}} was added to the ticket.': '{{email}}을(를) 티켓에 추가했습니다.',
		'Failed to add the person': '사람을 추가하지 못했습니다',
		'{{name}} was removed from the ticket.': '{{name}}님을 티켓에서 제외했습니다.',
		'Failed to remove the person': '사람을 제외하지 못했습니다',
		'Deleted the attachment {{filename}}': '첨부 파일 {{filename}}을(를) 삭제했습니다',
		'Delete {{name}}? The file is erased for good and cannot be restored.': '{{name}}을(를) 삭제할까요? 파일이 영구적으로 지워지며 복원할 수 없습니다.',
		'{{name}} was deleted.': '{{name}}을(를) 삭제했습니다.',
		'Failed to delete the attachment': '첨부 파일을 삭제하지 못했습니다',
		'Delete {{name}}': '{{name}} 삭제',
		'You left the ticket.': '티켓에서 나갔습니다.',
		'Failed to leave the ticket': '티켓에서 나가지 못했습니다',
		'{{owner}} added you to this ticket.': '{{owner}}님이 회원님을 이 티켓에 추가했습니다.',
		'Shared by {{name}}': '{{name}}님이 공유함',
		'The ticket owner\'s support is no longer active, so replies are closed.': '티켓 소유자의 지원이 더 이상 유효하지 않아 답장이 마감되었습니다.',
		'Added {{name}} to the ticket': '{{name}}님을 티켓에 추가함',
		'Removed {{name}} from the ticket': '{{name}}님을 티켓에서 제외함',
		'Left the ticket': '티켓에서 나감',
		'Support is currently turned off': '지원이 현재 꺼져 있습니다',
		'Tickets cannot be opened or answered right now. Please check back later.': '지금은 티켓을 열거나 답변할 수 없습니다. 나중에 다시 확인해 주세요.',
		'Support is turned on.': '지원이 켜졌습니다.',
		'Support is turned off.': '지원이 꺼졌습니다.',
		'Support desk': '지원 데스크',
		'On. Customers whose license includes support can open tickets, and agents answer them from the Support Desk.': '켜짐. 지원이 포함된 라이선스를 보유한 고객은 티켓을 열 수 있고, 상담원이 지원 데스크에서 답변합니다.',
		'Off. Support is hidden from customers and agents and the automatic sweeps are paused. Tickets and settings are kept.': '꺼짐. 지원이 고객과 상담원에게 숨겨지고 자동 처리가 일시 중지됩니다. 티켓과 설정은 유지됩니다.',
		'Support desk enabled': '지원 데스크 사용',
		'Notify': '알림',
		'Team address only': '팀 주소만',
		'There are no support agents yet. Assign the support role first.': '아직 지원 상담원이 없습니다. 먼저 지원 역할을 지정하세요.',
		'Agents': '상담원',
		'Editor mode': '편집기 모드',
		'Write': '작성',
		'Markdown supported': 'Markdown 지원',
		'Nothing to preview yet.': '아직 미리 볼 내용이 없습니다.',
		'Preview {{name}}': '{{name}} 미리보기',
		'The full image could not be loaded.': '원본 이미지를 불러오지 못했습니다.',
		'or drop them here': '또는 여기에 끌어다 놓기',
		'No access to support?': '지원을 이용할 수 없으신가요?',
		'Consider purchasing a license to get instant access to our in-house engineering team. Otherwise, you can get help from the Abstract community and on the Abstract Discord.': '라이선스를 구매하시면 사내 엔지니어링 팀에 바로 문의하실 수 있습니다. 또는 Abstract 커뮤니티와 Abstract Discord에서 도움을 받으실 수 있습니다.',
		'Abstract Community': 'Abstract 커뮤니티',
		'Abstract Discord': 'Abstract Discord',
		'Community URL': '커뮤니티 URL',
		'Discord invite': 'Discord 초대 링크',
		'Offered to users without access to support. Leave blank to offer none.': '지원을 이용할 수 없는 사용자에게 표시됩니다. 비워 두면 표시하지 않습니다.',
		'A question or a minor inconvenience.': '질문 또는 사소한 불편.',
		'A resolved ticket untouched this long is closed. 0 turns this off.': '해결된 티켓이 이 기간 동안 변경되지 않으면 종료됩니다. 0이면 사용하지 않습니다.',
		'A short summary of the problem': '문제에 대한 간단한 요약',
		'A ticket waiting on the customer this long is resolved. 0 turns this off.': '고객 응답을 이 기간 동안 기다린 티켓은 해결됩니다. 0이면 사용하지 않습니다.',
		'Activity': '활동',
		'Add category': '카테고리 추가',
		'Add note': '메모 추가',
		'Agent': '상담원',
		'Agents and automation': '상담원 및 자동화',
		'All open': '모든 미해결',
		'All products': '모든 제품',
		'Another product already uses this prefix.': '다른 제품이 이미 이 접두사를 사용합니다.',
		'Any priority': '모든 우선순위',
		'Any product': '모든 제품',
		'Any status': '모든 상태',
		'Anyone': '모두',
		'Anything you would like to add? (optional)': '추가로 하실 말씀이 있나요? (선택 사항)',
		'Apply': '적용',
		'Ask for logs': '로그 요청',
		'Assign to me': '나에게 할당',
		'Assign to…': '할당 대상…',
		'Assigned to {{name}}': '{{name}}에게 할당됨',
		'Assignee': '담당자',
		'Attach files': '파일 첨부',
		'Attachments': '첨부 파일',
		'Auto-close after (days)': '자동 종료까지(일)',
		'Auto-resolve after (days)': '자동 해결까지(일)',
		'Awaiting agent': '상담원 대기 중',
		'Awaiting customer': '고객 대기 중',
		'Back to support': '지원으로 돌아가기',
		'Back to the desk': '지원 데스크로 돌아가기',
		'Breaching': 'SLA 위반',
		'Bulk actions': '일괄 작업',
		'Templates': '템플릿',
		'Template saved.': '템플릿을 저장했습니다.',
		'Categories': '카테고리',
		'Categories are optional. They help customers say what a ticket is about.': '카테고리는 선택 사항입니다. 고객이 티켓의 주제를 설명하는 데 도움이 됩니다.',
		'Category cleared': '카테고리 해제됨',
		'Category deleted.': '카테고리를 삭제했습니다.',
		'Category saved.': '카테고리를 저장했습니다.',
		'Category set to {{name}}': '카테고리를 {{name}}(으)로 설정',
		'Choose a product': '제품 선택',
		'Choose a product.': '제품을 선택하세요.',
		'Clear selection': '선택 해제',
		'Close this ticket? You can open a follow-up later if you need to.': '이 티켓을 종료할까요? 필요하면 나중에 후속 티켓을 열 수 있습니다.',
		'Close ticket': '티켓 종료',
		'Closed': '종료됨',
		'Closed automatically': '자동으로 종료됨',
		'Comment': '의견',
		'Conversation': '대화',
		'Could not check your license': '라이선스를 확인할 수 없습니다',
		'Create ticket': '티켓 생성',
		'Customers file tickets against a product while their license for it includes support. Agents answer them from the Support Desk.': '고객은 라이선스에 지원이 포함된 동안 제품에 대한 티켓을 제출할 수 있습니다. 상담원은 지원 데스크에서 답변합니다.',
		'Delete the template “{{name}}”?': '템플릿 “{{name}}”을(를) 삭제할까요?',
		'Delete the category “{{name}}”?': '카테고리 “{{name}}”을(를) 삭제할까요?',
		'Describe the problem.': '문제를 설명하세요.',
		'Dissatisfied': '불만족',
		'Edit template': '템플릿 편집',
		'Edit {{name}}': '{{name}} 편집',
		'Enable support for a product under Settings → Admin → Support.': '설정 → 관리 → 지원에서 제품의 지원을 활성화하세요.',
		'Enter a whole number of days.': '일 수를 정수로 입력하세요.',
		'Enter the requester’s email address.': '요청자의 이메일 주소를 입력하세요.',
		'Every ticket filed against a support-enabled product.': '지원이 활성화된 제품에 제출된 모든 티켓.',
		'Failed to delete the template': '템플릿을 삭제하지 못했습니다',
		'Failed to delete the category': '카테고리를 삭제하지 못했습니다',
		'Failed to download the attachment': '첨부 파일을 다운로드하지 못했습니다',
		'Failed to load support': '지원 정보를 불러오지 못했습니다',
		'Failed to load support settings': '지원 설정을 불러오지 못했습니다',
		'Failed to load the ticket': '티켓을 불러오지 못했습니다',
		'Failed to load tickets': '티켓을 불러오지 못했습니다',
		'No tickets yet': '아직 티켓이 없습니다',
		'Failed to open the ticket': '티켓을 열지 못했습니다',
		'Failed to save support for this product': '이 제품의 지원 설정을 저장하지 못했습니다',
		'Failed to save support settings': '지원 설정을 저장하지 못했습니다',
		'Failed to save the template': '템플릿을 저장하지 못했습니다',
		'Failed to save the category': '카테고리를 저장하지 못했습니다',
		'Failed to send the message': '메시지를 보내지 못했습니다',
		'Failed to send the reply': '답장을 보내지 못했습니다',
		'Failed to submit the rating': '평가를 제출하지 못했습니다',
		'Failed to update the ticket': '티켓을 업데이트하지 못했습니다',
		'Failed to update the tickets': '티켓을 업데이트하지 못했습니다',
		'Filed by {{name}}': '{{name}} 님이 제출',
		'Files to attach': '첨부할 파일',
		'First response': '첫 응답',
		'First response (hours)': '첫 응답(시간)',
		'First response target for {{priority}}': '{{priority}} 첫 응답 목표',
		'Follows up on {{key}}': '{{key}}의 후속 티켓',
		'For requests that reached the team another way — by phone, chat or email.': '전화, 채팅, 이메일 등 다른 경로로 팀에 전달된 요청용입니다.',
		'Get help with the Abstract products you hold a license for.': '라이선스를 보유한 Abstract 제품에 대한 도움을 받으세요.',
		'Give the ticket a subject.': '티켓 제목을 입력하세요.',
		'High': '높음',
		'Holders of this role are agents. Administrators always are.': '이 역할을 가진 사용자는 상담원입니다. 관리자는 항상 상담원입니다.',
		'How did we do?': '저희 지원은 어떠셨나요?',
		'Insert template…': '템플릿 삽입…',
		'Insert placeholder:': '자리표시자 삽입:',
		'Internal note': '내부 메모',
		'Last activity': '마지막 활동',
		'Last heard': '마지막 연락',
		'Low': '낮음',
		'Met': '충족',
		'Mine': '내 담당',
		'Missed': '미달',
		'Neutral': '보통',
		'New': '신규',
		'New template': '새 템플릿',
		'New ticket': '새 티켓',
		'New ticket on behalf of a customer': '고객을 대신한 새 티켓',
		'No templates yet': '아직 템플릿이 없습니다',
		'No categories': '카테고리 없음',
		'No category': '카테고리 없음',
		'No product has support enabled': '지원이 활성화된 제품이 없습니다',
		'No product offers you support right now': '현재 지원을 받을 수 있는 제품이 없습니다',
		'No support role — administrators only': '지원 역할 없음 — 관리자만',
		'No target': '목표 없음',
		'No ticket matches this view and these filters.': '이 보기와 필터에 맞는 티켓이 없습니다.',
		'Nobody': '없음',
		'None of the Abstract products offer support through Abstract ID yet.': '아직 Abstract ID를 통해 지원을 제공하는 Abstract 제품이 없습니다.',
		'Normal': '보통',
		'Not yet assigned': '아직 할당되지 않음',
		'Note added.': '메모를 추가했습니다.',
		'Nothing in this view': '이 보기에 항목이 없습니다',
		'Off': '꺼짐',
		'Offered for new tickets': '새 티켓에 제공',
		'On': '켜짐',
		'Only the person who opened this ticket can reply to it.': '이 티켓을 연 사람만 답장할 수 있습니다.',
		'Your support entitlement could not be confirmed right now. Please try again shortly.': '지금은 지원 자격을 확인할 수 없습니다. 잠시 후 다시 시도해 주세요.',
		'Open': '미해결',
		'Open (any)': '미해결(전체)',
		'Open a follow-up': '후속 티켓 열기',
		'Opened': '생성',
		'Operating system': '운영 체제',
		'Overdue by {{time}}': '{{time}} 초과',
		'Paused · {{time}} left': '일시 중지 · {{time}} 남음',
		'Prefix': '접두사',
		'Priority': '우선순위',
		'Priority changed from {{from}} to {{to}}': '우선순위가 {{from}}에서 {{to}}(으)로 변경됨',
		'Priority…': '우선순위…',
		'Product': '제품',
		'Product version': '제품 버전',
		'Production is down and there is no workaround.': '프로덕션이 중단되었고 해결 방법이 없습니다.',
		'Products': '제품',
		'Rated {{rating}} out of 5': '5점 만점에 {{rating}}점',
		'Rating': '평가',
		'Receives SLA breach alerts for tickets nobody is assigned to.': '담당자가 없는 티켓의 SLA 위반 알림을 받습니다.',
		'Remove {{name}}': '{{name}} 제거',
		'Reopen ticket': '티켓 다시 열기',
		'Replies the team reuses. Placeholders are filled in from the ticket when a reply is inserted.': '팀이 재사용하는 답변입니다. 삽입할 때 자리표시자가 티켓 정보로 채워집니다.',
		'Reply': '답장',
		'Reply sent.': '답장을 보냈습니다.',
		'Requester': '요청자',
		'Requester email': '요청자 이메일',
		'Resolution': '해결',
		'Resolution (hours)': '해결(시간)',
		'Resolution target for {{priority}}': '{{priority}} 해결 목표',
		'Resolved': '해결됨',
		'Resolved automatically after no reply': '응답이 없어 자동으로 해결됨',
		'SLA': 'SLA',
		'SLA targets must be positive numbers of hours, or blank for none.': 'SLA 목표는 양수 시간이어야 하며, 목표가 없으면 비워 두세요.',
		'Satisfaction': '만족도',
		'Satisfied': '만족',
		'Save settings': '설정 저장',
		'Save the answers the team gives most often, and insert them from any ticket.': '팀이 자주 하는 답변을 저장하고 어떤 티켓에서든 삽입하세요.',
		'Search key, subject or requester…': '키, 제목 또는 요청자 검색…',
		'Search tickets…': '티켓 검색…',
		'Select all': '모두 선택',
		'Select {{key}}': '{{key}} 선택',
		'Service level': '서비스 수준',
		'Service levels': '서비스 수준',
		'Set assignee': '담당자 설정',
		'Set priority': '우선순위 설정',
		'Set status': '상태 설정',
		'Showing {{from}} to {{to}} of {{total}}': '{{total}}개 중 {{from}}~{{to}} 표시',
		'Shown as a hint when a customer picks it.': '고객이 선택할 때 힌트로 표시됩니다.',
		'Something is not working as expected.': '무언가가 예상대로 작동하지 않습니다.',
		'Status after sending': '보낸 후 상태',
		'Status changed to {{to}}': '상태가 {{to}}(으)로 변경됨',
		'Status: automatic': '상태: 자동',
		'Status: {{status}}': '상태: {{status}}',
		'Status…': '상태…',
		'Submit rating': '평가 제출',
		'Submit ticket': '티켓 제출',
		'Support': '지원',
		'Support Desk': '지원 데스크',
		'Support Desk — {{count}} unassigned': '지원 데스크 — 미할당 {{count}}건',
		'Support available': '지원 가능',
		'Support comes with an active license. The support page explains the situation for each product.': '지원은 활성 라이선스에 포함됩니다. 지원 페이지에서 제품별 상황을 확인할 수 있습니다.',
		'Support for {{name}}': '{{name}} 지원',
		'Support is not available for this product yet.': '이 제품은 아직 지원을 제공하지 않습니다.',
		'Support is not available yet': '지원을 아직 사용할 수 없습니다',
		'Support needs licensing turned on for the product, and a ticket prefix — the LOD in LOD-1042.': '지원을 사용하려면 제품의 라이선스 기능과 티켓 접두사(LOD-1042의 LOD)가 필요합니다.',
		'Support not available': '지원 불가',
		'Support role': '지원 역할',
		'Support saved for {{name}}.': '{{name}} 지원 설정을 저장했습니다.',
		'Support settings saved.': '지원 설정을 저장했습니다.',
		'Targets in hours of wall-clock time from when the ticket was opened. The resolution clock pauses while a ticket waits on the customer. Leave blank for no target.': '티켓이 열린 시점부터의 실제 경과 시간(시간 단위) 목표입니다. 고객 응답을 기다리는 동안 해결 시간은 일시 중지됩니다. 목표가 없으면 비워 두세요.',
		'Team email': '팀 이메일',
		'Tell us what is going wrong. The more detail, the faster we can help.': '무엇이 잘못되었는지 알려 주세요. 자세할수록 더 빨리 도와드릴 수 있습니다.',
		'Thank you for your feedback.': '의견을 보내 주셔서 감사합니다.',
		'The customer must already have an account.': '고객은 이미 계정이 있어야 합니다.',
		'The license server for this product did not answer. Please try again shortly.': '이 제품의 라이선스 서버가 응답하지 않았습니다. 잠시 후 다시 시도하세요.',
		'The prefix must be 2–10 uppercase letters or digits.': '접두사는 2~10자의 대문자 또는 숫자여야 합니다.',
		'The product the ticket is filed against': '티켓이 제출된 제품',
		'The requester\'s first name': '요청자의 이름',
		'The requester\'s full name': '요청자의 전체 이름',
		'The ticket reference, e.g. LOD-1042': '티켓 참조(예: LOD-1042)',
		'This ticket is closed.': '이 티켓은 종료되었습니다.',
		'This ticket is closed. If the problem is back, open a follow-up and we will pick it up from here.': '이 티켓은 종료되었습니다. 문제가 다시 발생하면 후속 티켓을 열어 주세요. 여기서부터 이어서 처리하겠습니다.',
		'Ticket': '티켓',
		'Ticket closed.': '티켓을 종료했습니다.',
		'Ticket opened': '티켓이 열렸습니다',
		'Ticket prefix for {{name}}': '{{name}} 티켓 접두사',
		'Ticket reopened.': '티켓을 다시 열었습니다.',
		'Ticket updated': '티켓이 업데이트됨',
		'Ticket updated.': '티켓을 업데이트했습니다.',
		'Ticket {{key}} opened.': '티켓 {{key}}을(를) 열었습니다.',
		'Tickets': '티켓',
		'Title': '제목',
		'Turn on licensing for this product first.': '먼저 이 제품의 라이선스 기능을 켜세요.',
		'Unassigned': '미할당',
		'Updated {{count}} ticket(s).': '티켓 {{count}}건을 업데이트했습니다.',
		'Urgent': '긴급',
		'Very dissatisfied': '매우 불만족',
		'Very satisfied': '매우 만족',
		'Views': '보기',
		'Waiting for support': '지원팀 응답 대기 중',
		'Waiting for you': '고객님의 응답 대기 중',
		'What did you do, what did you expect, and what happened instead? Markdown is supported.': '무엇을 했고, 무엇을 기대했으며, 실제로 어떤 일이 일어났나요? Markdown을 지원합니다.',
		'When something is not working, open a ticket and the support team will get back to you.': '문제가 있으면 티켓을 열어 주세요. 지원팀이 연락드리겠습니다.',
		'Write a note only the support team can see…': '지원팀만 볼 수 있는 메모 작성…',
		'Write your reply…': '답장 작성…',
		'You do not hold a license for this product.': '이 제품의 라이선스가 없습니다.',
		'Your license for this product does not include support.': '이 제품의 라이선스에는 지원이 포함되어 있지 않습니다.',
		'Your license for this product has expired.': '이 제품의 라이선스가 만료되었습니다.',
		'Your name': '내 이름',
		'Your tickets': '내 티켓',
		'Your work is significantly impaired.': '작업에 상당한 지장이 있습니다.',
		'{{count}} selected': '{{count}}개 선택됨',
		'{{name}} filed this ticket using a seat of your license. You can follow it, but only they can reply.': '{{name}} 님이 귀하의 라이선스 좌석으로 이 티켓을 제출했습니다. 확인은 가능하지만 답장은 제출자만 할 수 있습니다.',
		'{{time}} left': '{{time}} 남음',
		'Columns': '열',
		'Reset columns': '열 초기화',
		'2FA': '2단계 인증',
		'Newsletter': '뉴스레터',
		'Enabled': '사용',
		'Disabled': '사용 안 함',
		'Opted out': '수신 거부',
		'Subscribed': '구독 중',
		'Local': '로컬',
		'Review your active sessions to sign out elsewhere.': '다른 기기에서 로그아웃하려면 활성 세션을 확인하세요.',
		'Sign out on this device. Your other devices stay signed in.': '이 기기에서 로그아웃합니다. 다른 기기는 로그인 상태로 유지됩니다.',
		'All {{count}} of your licenses for this product have expired.': '이 제품의 라이선스 {{count}}개가 모두 만료되었습니다.',
		'No active licenses': '활성 라이선스 없음',
		'Show {{count}} expired': '만료된 {{count}}개 표시',
		'Add all': '모두 추가',
		'Add one at a time': '한 명씩 추가',
		'Add several at once': '여러 명 한 번에 추가',
		'Added {{count}}.': '{{count}}명을 추가했습니다.',
		'Added {{count}}. Skipped: {{skipped}}.': '{{count}}명을 추가했습니다. 건너뜀: {{skipped}}.',
		'Email addresses': '이메일 주소',
		'Everyone on that list already has seats on this license.': '목록의 모든 사람이 이미 이 라이선스의 좌석을 가지고 있습니다.',
		'None of those look like email addresses.': '이메일 주소로 인식되는 항목이 없습니다.',
		'Paste at least one email address.': '이메일 주소를 하나 이상 붙여넣으세요.',
		'Separate addresses with commas, spaces or new lines. People who already have seats are skipped.': '주소는 쉼표, 공백 또는 줄바꿈으로 구분하세요. 이미 좌석이 있는 사람은 건너뜁니다.',
		'colleague@example.com, another@example.com': 'colleague@example.com, another@example.com',
		'seats each': '1인당 좌석',
		'{{count}} already assigned': '{{count}}명은 이미 할당됨',
		'{{count}} not a valid address': '{{count}}개는 유효하지 않은 주소',
		'{{needed}} seat(s) needed for {{people}} people, but only {{available}} left.': '{{people}}명에게는 좌석 {{needed}}개가 필요하지만 {{available}}개만 남았습니다.',
		'Group {{number}}': '그룹 {{number}}',
		'Link {{number}}': '링크 {{number}}',
		'Remove group': '그룹 제거',
		'Remove link': '링크 제거',
		'Add group': '그룹 추가',
		'Download Groups': '다운로드 그룹',
		'Heading for builds the backend files under no group. Blank uses “Other”.': '백엔드가 어떤 그룹에도 넣지 않은 빌드의 제목입니다. 비워 두면 “기타”가 사용됩니다.',
		'Name for ungrouped builds': '그룹이 없는 빌드의 이름',
		'Names the groups the licensing backend files builds under. Order here is the order they appear; an unmapped group still shows, under its raw identifier.': '라이선스 백엔드가 빌드를 분류하는 그룹의 이름을 지정합니다. 여기의 순서가 표시 순서이며, 매핑하지 않은 그룹도 원래 식별자로 표시됩니다.',
		'Other': '기타',
		'Get a License URL': '라이선스 구매 URL',
		'Get a license': '라이선스 받기',
		'Get a license for {{name}}': '{{name}} 라이선스 받기',
		'Offered to users who hold no license for this product. Blank makes no offer.': '이 제품의 라이선스가 없는 사용자에게 안내됩니다. 비워 두면 안내하지 않습니다.',
		'Add link': '링크 추가',
		'Display Name': '표시 이름',
		'Documentation': '문서',
		'Documentation Links': '문서 링크',
		'Shown below the user\'s licenses for this product, and linked from its card on the dashboard.': '이 제품의 사용자 라이선스 아래에 표시되며, 대시보드 카드에서도 연결됩니다.',
		'What customers call this product. Used across the license pages; blank uses the application name.': '고객이 이 제품을 부르는 이름입니다. 라이선스 페이지 전반에 사용되며, 비워 두면 애플리케이션 이름을 사용합니다.',
		'{{count}} expired': '{{count}}개 만료',
		'Download {{name}}': '{{name}} 다운로드',
		'Builds appear here once they are linked to an entitlement on one of your active licenses.': '빌드는 활성 라이선스의 권한에 연결되면 여기에 표시됩니다.',
		'It offers {{count}} download(s) for your account.': '귀하의 계정에서 다운로드 {{count}}개를 이용할 수 있습니다.',
		'Link builds to the entitlements your licenses grant to make them downloadable.': '다운로드할 수 있도록 라이선스가 부여하는 권한에 빌드를 연결하세요.',
		'No downloads available': '사용 가능한 다운로드 없음',
		'Download': '다운로드',
		'Downloads': '다운로드',
		'Failed to load downloads': '다운로드를 불러오지 못했습니다',
		'Failed to start the download': '다운로드를 시작하지 못했습니다',
		'Latest': '최신',
		'Add': '추가',
		'Add a seat': '좌석 1개 추가',
		'Assign at least one seat.': '좌석을 최소 1개 이상 할당하세요.',
		'Assign seats to a colleague': '동료에게 좌석 할당',
		'Discard changes': '변경 취소',
		'Email address': '이메일 주소',
		'Enter a valid email address.': '유효한 이메일 주소를 입력하세요.',
		'Every seat on this license is yours to use. Assign a block below to share it.': '이 라이선스의 모든 좌석을 직접 사용할 수 있습니다. 공유하려면 아래에서 좌석 묶음을 할당하세요.',
		'Give blocks of seats to colleagues. They activate their own machines against the seats you assign; removing a block takes the seats back.': '동료에게 좌석 묶음을 할당합니다. 할당받은 사람은 자신의 컴퓨터를 해당 좌석으로 활성화하며, 묶음을 제거하면 좌석이 회수됩니다.',
		'No seats left to assign. Reduce a block above first.': '할당할 좌석이 없습니다. 먼저 위의 묶음을 줄이세요.',
		'Not yet saved': '아직 저장되지 않음',
		'Only {{count}} seat(s) left to assign.': '할당 가능한 좌석이 {{count}}개뿐입니다.',
		'Remove a seat': '좌석 1개 제거',
		'Remove assignment': '할당 제거',
		'Seat budget': '좌석 배분',
		'That person already has seats on this license.': '해당 사용자에게는 이미 이 라이선스의 좌석이 있습니다.',
		'{{assigned}} of {{total}} assigned': '{{total}}개 중 {{assigned}}개 할당됨',
		'{{count}} seat(s) left for your own machines.': '본인 컴퓨터용으로 좌석 {{count}}개가 남았습니다.',
		'{{count}} seat(s) over the license total.': '라이선스 총량을 {{count}}개 초과했습니다.',
		'{{used}} of {{seats}} in use': '{{seats}}개 중 {{used}}개 사용 중',
		'It holds {{count}} license(s) for your account.': '귀하의 계정에 라이선스 {{count}}개가 있습니다.',
		'The backend answered, but refused to list your licenses. Check that it shares the same JWT_KEY as Abstract ID.': '백엔드가 응답했지만 라이선스 목록 조회를 거부했습니다. Abstract ID와 동일한 JWT_KEY를 사용하는지 확인하세요.',
		'This application is inactive, so its licenses are hidden from users regardless of the settings below.': '이 애플리케이션은 비활성 상태여서 아래 설정과 관계없이 라이선스가 사용자에게 표시되지 않습니다.',
		'A backend URL is required to enable licensing.': '라이선스 관리를 활성화하려면 백엔드 URL이 필요합니다.',
		'Adapter': '어댑터',
		'Backend reachable': '백엔드 연결됨',
		'Failed to save licensing configuration': '라이선스 설정을 저장하지 못했습니다',
		'Failed to test the licensing backend': '라이선스 백엔드를 테스트하지 못했습니다',
		'Licensing Backends': '라이선스 백엔드',
		'Licensing saved for {{name}}.': '{{name}}의 라이선스 설정을 저장했습니다.',
		'No licensing backends': '라이선스 백엔드 없음',
		'No sublicense entitlement is configured on the backend, so seats can never be re-assigned.': '백엔드에 서브라이선스 권한이 설정되어 있지 않아 좌석을 재할당할 수 없습니다.',
		'Products whose licenses users can see from their Abstract ID account. Abstract ID stores no license data — it reads each backend live, as the signed-in user.': '사용자가 Abstract ID 계정에서 라이선스를 볼 수 있는 제품입니다. Abstract ID는 라이선스 데이터를 저장하지 않고, 로그인한 사용자로서 각 백엔드를 실시간으로 읽습니다.',
		'Show all applications': '모든 애플리케이션 표시',
		'Test connection': '연결 테스트',
		'This backend serves a different application.': '이 백엔드는 다른 애플리케이션을 담당합니다.',
		'Turn on "Show all applications" to point a product at its license server.': '제품을 라이선스 서버에 연결하려면 "모든 애플리케이션 표시"를 켜세요.',
		'Unsaved': '저장되지 않음',
		'Users would see an empty license list. Check the URL points at this product’s license server.': '사용자에게는 라이선스 목록이 비어 보입니다. URL이 이 제품의 라이선스 서버를 가리키는지 확인하세요.',
		'{{configured}} of {{total}} applications have a licensing backend.': '애플리케이션 {{total}}개 중 {{configured}}개에 라이선스 백엔드가 설정되어 있습니다.',
		'License Activation Revoked': '라이선스 활성화 해제',
		'Support Ticket Created': '지원 티켓 생성',
		'Support Ticket Updated': '지원 티켓 업데이트',
		'Support Settings Changed': '지원 설정 변경',
		'License Seats Updated': '라이선스 좌석 변경',
		'API base including the version prefix, e.g. https://license.example.com/api/v1': '버전 접두사를 포함한 API 기본 주소 (예: https://license.example.com/api/v1)',
		'Activated': '활성화됨',
		'All seats on this license are yours to use.': '이 라이선스의 모든 좌석을 직접 사용할 수 있습니다.',
		'Allow seat re-assignment': '좌석 재할당 허용',
		'Assign seats': '좌석 할당',
		'Assigned seat': '할당된 좌석',
		'Assigned seats ({{assigned}}) exceed the license total ({{total}}).': '할당된 좌석 수({{assigned}})가 라이선스 총량({{total}})을 초과합니다.',
		'Back to licenses': '라이선스 목록으로',
		'Backend URL': '백엔드 URL',
		'Discard': '취소',
		'Entitlements': '권한',
		'Every assignment needs an email address.': '모든 할당에는 이메일 주소가 필요합니다.',
		'Expired': '만료됨',
		'Expires': '만료일',
		'Failed to load activations': '활성화 정보를 불러오지 못했습니다',
		'Failed to load license': '라이선스를 불러오지 못했습니다',
		'Failed to load licenses': '라이선스를 불러오지 못했습니다',
		'Failed to release seats': '좌석을 해제하지 못했습니다',
		'Failed to save seat assignments': '좌석 할당을 저장하지 못했습니다',
		'Give blocks of seats to colleagues. They activate their own machines against the seats you assign; removing an assignment takes the seats back.': '동료에게 좌석 묶음을 할당합니다. 할당받은 사람은 자신의 컴퓨터를 해당 좌석으로 활성화하며, 할당을 제거하면 좌석이 회수됩니다.',
		'Lets users see this product\'s licenses and activations from their Abstract ID account. Abstract ID stores no license data — it reads the backend live, as the signed-in user.': '사용자가 Abstract ID 계정에서 이 제품의 라이선스와 활성화 내역을 볼 수 있게 합니다. Abstract ID는 라이선스 데이터를 저장하지 않으며, 로그인한 사용자로서 백엔드를 실시간으로 읽습니다.',
		'License': '라이선스',
		'Licenses': '라이선스',
		'Licenses issued to you across Abstract products, and the machines using them.': 'Abstract 제품 전반에 걸쳐 발급된 내 라이선스와 이를 사용하는 컴퓨터입니다.',
		'Builds available to you for each Abstract product you are licensed for.': '라이선스를 보유한 각 Abstract 제품에서 사용할 수 있는 빌드입니다.',
		'Guides and references for each Abstract product.': '각 Abstract 제품의 안내서와 참조 자료입니다.',
		'No documentation': '문서 없음',
		'This product publishes no documentation yet.': '이 제품은 아직 문서를 게시하지 않았습니다.',
		'Licensing': '라이선스 관리',
		'Licensing Backend': '라이선스 백엔드',
		'Machine': '컴퓨터',
		'Machines': '컴퓨터',
		'Machines currently using a seat of this license.': '현재 이 라이선스의 좌석을 사용 중인 컴퓨터입니다.',
		'My Licenses': '내 라이선스',
		'No licensed products': '라이선스 제품 없음',
		'No licenses': '라이선스 없음',
		'No machine has activated this license yet.': '아직 이 라이선스를 활성화한 컴퓨터가 없습니다.',
		'No machines': '컴퓨터 없음',
		'No seats assigned': '할당된 좌석 없음',
		'None of the products you have access to manage licenses through Abstract ID.': '사용 중인 제품 가운데 Abstract ID로 라이선스를 관리하는 제품이 없습니다.',
		'Release {{count}} seat(s)': '좌석 {{count}}개 해제',
		'Released': '해제됨',
		'Released {{count}} seat(s).': '좌석 {{count}}개를 해제했습니다.',
		'Renews': '갱신일',
		'Save assignments': '할당 저장',
		'Seat assignments': '좌석 할당',
		'Seat assignments saved.': '좌석 할당을 저장했습니다.',
		'Seats': '좌석',
		'Select': '선택',
		'Select {{machine}}': '{{machine}} 선택',
		'The backend still decides per license whether its owner may delegate seats; this only hides the controls for the whole product.': '좌석 위임 가능 여부는 여전히 백엔드가 라이선스별로 결정합니다. 이 설정은 제품 전체에서 해당 조작만 숨깁니다.',
		'Valid': '유효 기간',
		'You have no licenses for this product yet.': '아직 이 제품의 라이선스가 없습니다.',
		'Your Licenses': '내 라이선스',
		'colleague@example.com': 'colleague@example.com',
		'{{assigned}} of {{total}} seats assigned': '좌석 {{total}}개 중 {{assigned}}개 할당됨',
		'{{count}} active': '{{count}}개 활성',
		'{{count}} free': '{{count}}개 남음',
		'{{count}} license(s)': '라이선스 {{count}}개',
		'Collapse sidebar': '사이드바 접기',
		'Expand sidebar': '사이드바 펼치기',
		'Something went wrong': '문제가 발생했습니다',
		'Switch to dark mode': '다크 모드로 전환',
		'Switch to light mode': '라이트 모드로 전환',
		'Allow pop-ups for this site to sign in with Microsoft.': 'Microsoft로 로그인하려면 이 사이트의 팝업을 허용하세요.',
		'and access the following': '다음에 접근할 수 있습니다',
		'and access your profile information': '프로필 정보에 접근할 수 있습니다',
		'2FA Disabled': '2FA 비활성화됨',
		'2FA Enabled': '2FA 활성화됨',
		'2FA Not Set': '2FA 미설정',
		'2FA QR Code': '2FA QR 코드',
		'2FA is enabled': '2FA가 활성화되어 있습니다',
		'2FA is not enabled': '2FA가 활성화되어 있지 않습니다',
		'6-digit code': '6자리 코드',
		'A short bio or description...': '간단한 소개 또는 설명...',
		'About': '소개',
		'Access Granted': '접근 승인됨',
		'Access Key ID': 'Access Key ID',
		'Account': '계정',
		'Account Status': '계정 상태',
		'Action': '작업',
		'Action Types': '작업 유형',
		'Action URL (optional)': '작업 URL (선택사항)',
		'Actions': '작업',
		'Activation Email': '활성화 이메일',
		'Active': '활성',
		'Active Sessions': '활성 세션',
		'Add Link': '링크 추가',
		'Add a passkey to sign in without a password.': '비밀번호 없이 로그인할 수 있도록 패스키를 추가하세요.',
		'Add an extra layer of security using a TOTP authenticator app.': 'TOTP 인증 앱을 사용하여 보안을 한층 강화하세요.',
		'Add external links that appear in the application sidebar for all users. Upload an icon image (128×128 PNG) and set the order to control placement alongside registered applications.': '모든 사용자의 사이드바에 표시될 외부 링크를 추가하세요. 아이콘 이미지(128×128 PNG)를 업로드하고 순서를 설정하여 등록된 애플리케이션과 함께 배치를 제어할 수 있습니다.',
		'Add passkey': '패스키 추가',
		'Added': '추가됨',
		'Admin': '관리자',
		'Admin Notes': '관리자 메모',
		'Administration': '관리',
		'Administrator': '관리자',
		'Administrators': '관리자',
		'Admins': '관리자',
		'All Actions': '모든 작업',
		'All Roles': '모든 역할',
		'All Statuses': '모든 상태',
		'All Users (active + imported)': '전체 사용자 (활성 + 가져온 사용자)',
		'All apps': '모든 앱',
		'All auth types': '모든 인증 유형',
		'All caught up!': '모두 확인했습니다!',
		'All rights reserved.': 'All rights reserved.',
		'All sessions revoked.': '모든 세션이 해지되었습니다.',
		'All statuses': '모든 상태',
		'All users (active + imported)': '전체 사용자 (활성 + 가져온 사용자)',
		'Allow Duplicate Emails': '중복 이메일 허용',
		'Allowed redirect domains for authorization. One URL per line.': '인증에 허용되는 리디렉션 도메인입니다. 한 줄에 하나의 URL을 입력하세요.',
		'Already exist': '이미 존재함',
		'Already exist (skipped):': '이미 존재함 (건너뜀):',
		'Already have an account?': '이미 계정이 있으신가요?',
		'Always Visible': '항상 표시',
		'Amount': '금액',
		'Amt': '금액',
		'Analytics': '분석',
		'Apple Key ID': 'Apple 키 ID',
		'Apple Private Key (.p8)': 'Apple 개인 키 (.p8)',
		'Apple Services ID': 'Apple Services ID',
		'Apple sign-in failed. Please try again.': 'Apple 로그인에 실패했습니다. 다시 시도해 주세요.',
		'Apple sign-up failed. Please try again.': 'Apple 회원가입에 실패했습니다. 다시 시도해 주세요.',
		'Apple Team ID': 'Apple 팀 ID',
		'Application': '애플리케이션',
		'Application (client) ID': '애플리케이션(클라이언트) ID',
		'Application Created': '애플리케이션 생성됨',
		'Application Deleted': '애플리케이션 삭제됨',
		'Application Name': '애플리케이션 이름',
		'Application Updated': '애플리케이션 업데이트됨',
		'Application Usage': '애플리케이션 사용 현황',
		'Application name is required.': '애플리케이션 이름은 필수입니다.',
		'Application not found or is no longer active.': '애플리케이션을 찾을 수 없거나 더 이상 활성 상태가 아닙니다.',
		'Application updated successfully.': '애플리케이션이 성공적으로 업데이트되었습니다.',
		'Applications': '애플리케이션',
		'Applications:': '애플리케이션:',
		'Apply Crop': '자르기 적용',
		'Apps you’re registered with': '등록된 앱',
		'Are you sure?': '계속하시겠습니까?',
		'Assign CSV columns to user fields. <strong>Email</strong> is required.': 'CSV 열을 사용자 필드에 매핑하세요. <strong>Email</strong>은 필수입니다.',
		'At least 8 characters': '최소 8자 이상',
		'Audience': '수신 대상',
		'Audience:': '수신 대상:',
		'Audit Entries': '감사 항목',
		'Audit Logs': '감사 로그',
		'Audit Trail': '감사 내역',
		'Auth Provider': '인증 제공자',
		'Authentication': '인증',
		'Authorization Successful': '인증 성공',
		'Authorization URLs': '인증 URL',
		'Authorization failed. Please try again.': '인증에 실패했습니다. 다시 시도해 주세요.',
		'Authorize': '승인',
		'Authorized': '승인됨',
		'Auto-Approve': '자동 승인',
		'Auto-Approve Users': '사용자 자동 승인',
		'Auto-approve': '자동 승인',
		'Available Tokens': '사용 가능한 토큰',
		'Available placeholders:': '사용 가능한 플레이스홀더:',
		'Avatar removed.': '아바타가 삭제되었습니다.',
		'Avatar uploaded.': '아바타가 업로드되었습니다.',
		'Avg. interval per email': '이메일당 평균 간격',
		'Awaiting Approval': '승인 대기 중',
		'Already Authorized': '이미 승인됨',
		'Back': '뒤로',
		'Back to Applications': '애플리케이션 목록으로',
		'Back to Newsletters': '뉴스레터 목록으로',
		'Back to Users': '사용자 목록으로',
		'Back to inline preview': '인라인 미리보기로 돌아가기',
		'Back to sign in': '로그인으로 돌아가기',
		'Backup Codes': '백업 코드',
		'Backup code': '백업 코드',
		'Bal': '잔액',
		'Balance': '잔액',
		'Base URL for accessing files publicly. If empty, uses the default path.': '파일에 공개적으로 접근하기 위한 기본 URL입니다. 비워두면 기본 경로를 사용합니다.',
		'Basic Information': '기본 정보',
		'Batch Configuration & Timing': '배치 구성 및 타이밍',
		'Bio or description...': '소개 또는 설명...',
		'Blacklisted IPs': '차단된 IP',
		'Body:': '본문:',
		'Bonus': '보너스',
		'Bounced Recipients Excluded': '반송된 수신자 제외됨',
		'Bounced users excluded': '반송된 사용자 제외됨',
		'Branding text and links shown on the login and registration pages.': '로그인 및 회원가입 페이지에 표시되는 브랜딩 텍스트와 링크입니다.',
		'Brief description (optional)': '간단한 설명 (선택사항)',
		'Brief description of the application...': '애플리케이션에 대한 간단한 설명...',
		'Brief description...': '간단한 설명...',
		'Bucket Name': 'Bucket Name',
		'CIDR notation, comma-separated.': 'CIDR 표기법, 쉼표로 구분합니다.',
		'Cache TTL (seconds)': '캐시 TTL (초)',
		'Campaign Details': '캠페인 상세',
		'Campaign Name': '캠페인 이름',
		'Cancel': '취소',
		'Cancelled': '취소됨',
		'Category': '카테고리',
		'Category IDs': '카테고리 ID',
		'Change Password': '비밀번호 변경',
		'Changing...': '변경 중...',
		'Check your email': '이메일을 확인하세요',
		'Checking for existing users…': '기존 사용자 확인 중…',
		'Choose a new password.': '새 비밀번호를 선택하세요.',
		'City, Country': '도시, 국가',
		'Clear': '지우기',
		'Click Rate': '클릭률',
		'Click the link in the email to verify your account. If you don\'t see it, check your spam folder.': '이메일의 링크를 클릭하여 계정을 인증하세요. 메일이 보이지 않으면 스팸 폴더를 확인해 주세요.',
		'Clicks': '클릭',
		'Client Secret': '클라이언트 비밀',
		'Close': '닫기',
		'Close Preview': '미리보기 닫기',
		'Comma-separated IPs or CIDRs': '쉼표로 구분된 IP 또는 CIDR',
		'Comma-separated WordPress category IDs. Leave empty to show all categories.': '쉼표로 구분된 WordPress 카테고리 ID입니다. 비워두면 모든 카테고리가 표시됩니다.',
		'Comma-separated. Evaluated after whitelist.': '쉼표로 구분합니다. 허용 목록 이후에 평가됩니다.',
		'Common ports: 587 (STARTTLS), 465 (TLS), 25 (plain).': '일반 포트: 587 (STARTTLS), 465 (TLS), 25 (일반).',
		'Company': '회사',
		'Company name': '회사명',
		'Completing sign-in…': '로그인을 완료하는 중…',
		'Configure a Services ID and signing key to show the "Sign in with Apple" button on the login page.': '로그인 페이지에 "Apple로 로그인" 버튼을 표시하려면 Services ID와 서명 키를 설정하세요.',
		'Configure an Entra ID app registration to show the "Sign in with Microsoft" button on the login page.': '로그인 페이지에 "Microsoft로 로그인" 버튼을 표시하려면 Entra ID 앱 등록을 설정하세요.',
		'Configure Google OAuth 2.0 to show the "Sign in with Google" button on the login page.': '로그인 페이지에 "Google로 로그인" 버튼을 표시하려면 Google OAuth 2.0을 설정하세요.',
		'Configure an S3-compatible storage backend for file uploads (AWS S3, MinIO, DigitalOcean Spaces, etc.).': '파일 업로드를 위한 S3 호환 스토리지 백엔드를 설정하세요 (AWS S3, MinIO, DigitalOcean Spaces 등).',
		'Confirm': '확인',
		'Confirm Disable': '비활성화 확인',
		'Confirm Import': '가져오기 확인',
		'Confirm Password': '비밀번호 확인',
		'Confirm new password': '새 비밀번호 확인',
		'Confirm password': '비밀번호 확인',
		'Contact Details': '연락처 정보',
		'Content': '콘텐츠',
		'Continue': '계속',
		'Continue to': '계속하기:',
		'Continue to Dashboard': '대시보드로 이동',
		'Continue with Apple': 'Apple로 계속',
		'Continue with Google': 'Google로 계속',
		'Continue with Microsoft': 'Microsoft로 계속',
		'Copied to clipboard': '클립보드에 복사됨',
		'Copy the token below and paste it into': '아래 토큰을 복사하여 붙여넣으세요',
		'Copy to Clipboard': '클립보드에 복사',
		'Could not detect a WordPress REST API at this URL.': '이 URL에서 WordPress REST API를 감지할 수 없습니다.',
		'Count': '수량',
		'Create Application': '애플리케이션 생성',
		'Create Newsletter': '뉴스레터 생성',
		'Create Password': '비밀번호 생성',
		'Create Role': '역할 생성',
		'Create Template': '템플릿 생성',
		'Create User': '사용자 생성',
		'Create a Password': '비밀번호 만들기',
		'Create account': '계정 만들기',
		'Create an account': '계정 만들기',
		'Create credentials at': '다음에서 자격 증명을 생성하세요',
		'Create, manage and send newsletter campaigns.': '뉴스레터 캠페인을 생성, 관리 및 전송하세요.',
		'Created': '생성일',
		'Creating...': '생성 중...',
		'Credentials & Preview': '자격 증명 및 미리보기',
		'Credit': '크레딧',
		'Crop Profile Picture': '프로필 사진 자르기',
		'Current': '현재',
		'Current Balance': '현재 잔액',
		'Current Password': '현재 비밀번호',
		'Current:': '현재:',
		'Custom Sidebar Links': '사용자 정의 사이드바 링크',
		'Dark': '다크',
		'Dark Mode': '다크 모드',
		'Dashboard': '대시보드',
		'Database': '데이터베이스',
		'Date': '날짜',
		'Debit': '차감',
		'Default Email Master Template': '기본 이메일 마스터 템플릿',
		'Define access roles': '접근 역할 정의',
		'Define access roles and assign them to users or applications.': '접근 역할을 정의하고 사용자 또는 애플리케이션에 할당하세요.',
		'Delete': '삭제',
		'Delivery': '전송',
		'Deny': '거부',
		'Description': '설명',
		'Description (optional)': '설명 (선택사항)',
		'Details': '상세',
		'Detect': '감지',
		'Detecting...': '감지 중...',
		'Devices and browsers where you\'re currently signed in.': '현재 로그인되어 있는 기기 및 브라우저입니다.',
		'Didn\'t receive the email?': '이메일을 받지 못하셨나요?',
		'Directory (tenant) ID': '디렉터리(테넌트) ID',
		'Disable 2FA': '2FA 비활성화',
		'Dismiss': '닫기',
		'Display a WordPress news feed on the non-admin user dashboard.': '일반 사용자 대시보드에 WordPress 뉴스 피드를 표시합니다.',
		'Display name for the website link on auth pages.': '인증 페이지의 웹사이트 링크에 표시되는 이름입니다.',
		'Display name next to the sender address.': '발신자 주소 옆에 표시되는 이름입니다.',
		'Doe': 'Doe',
		'Done': '완료',
		'Draft': '임시 저장',
		'Edit': '편집',
		'Edit Application': '애플리케이션 편집',
		'Edit Newsletter': '뉴스레터 편집',
		'Edit Role': '역할 편집',
		'Edit Template': '템플릿 편집',
		'Edit User': '사용자 편집',
		'Edit your account details': '계정 정보 수정',
		'Eligible users': '대상 사용자',
		'Email': '이메일',
		'Email OTP Requested': '이메일 OTP 요청됨',
		'Email Template Preview': '이메일 템플릿 미리보기',
		'Email Templates': '이메일 템플릿',
		'Email Unverified': '이메일 미인증',
		'Email Verified': '이메일 인증됨',
		'Email address and verification status': '이메일 주소 및 인증 상태',
		'Email address updated successfully.': '이메일 주소가 성공적으로 업데이트되었습니다.',
		'Email is required.': '이메일은 필수입니다.',
		'Email subject line...': '이메일 제목...',
		'Emails Sent': '발송된 이메일',
		'Emails Sent This Year': '올해 발송된 이메일',
		'Emails This Month': '이번 달 이메일',
		'Emails This Week': '이번 주 이메일',
		'Emails per batch': '배치당 이메일 수',
		'Enable 2FA': '2FA 활성화',
		'Enable News Feed': '뉴스 피드 활성화',
		'Enable for port 465. For 587 with STARTTLS leave this off.': '포트 465에 사용합니다. 587 (STARTTLS)에서는 비활성화하세요.',
		'Endpoint URL': '엔드포인트 URL',
		'Enter a TOTP code or backup code to disable two-factor authentication.': '2단계 인증을 비활성화하려면 TOTP 코드 또는 백업 코드를 입력하세요.',
		'Enter a domain or URL — click': '도메인 또는 URL을 입력하고 클릭하세요',
		'Enter it below.': '아래에 입력하세요.',
		'Enter one of your backup codes. Each code can only be used once.': '백업 코드 중 하나를 입력하세요. 각 코드는 한 번만 사용할 수 있습니다.',
		'Enter reset code': '재설정 코드 입력',
		'Enter the 6-digit code from your authenticator to complete setup:': '설정을 완료하려면 인증 앱의 6자리 코드를 입력하세요:',
		'Enter the 6-digit code from your email:': '이메일로 받은 6자리 코드를 입력하세요:',
		'Enter the 6-digit code sent to': '다음 주소로 전송된 6자리 코드를 입력하세요:',
		'Enter the code from your authenticator app.': '인증 앱의 코드를 입력하세요.',
		'Enter the code sent to your email.': '이메일로 전송된 코드를 입력하세요.',
		'Enter the email address to send a test message to.': '테스트 메시지를 보낼 이메일 주소를 입력하세요.',
		'Enter your email and we\'ll send you a reset code.': '이메일을 입력하시면 재설정 코드를 보내드립니다.',
		'Enter your email to get started.': '시작하려면 이메일을 입력하세요.',
		'Environment': '환경',
		'Error': '오류',
		'Estimated duration': '예상 소요 시간',
		'Failed': '실패',
		'Failed to cancel newsletter': '뉴스레터 취소에 실패했습니다',
		'Failed to change password': '비밀번호 변경에 실패했습니다',
		'Failed to create application': '애플리케이션 생성에 실패했습니다',
		'Failed to create user': '사용자 생성에 실패했습니다',
		'Failed to delete application': '애플리케이션 삭제에 실패했습니다',
		'Failed to delete avatar': '아바타 삭제에 실패했습니다',
		'Failed to delete icon': '아이콘 삭제에 실패했습니다',
		'Failed to delete logo': '로고 삭제에 실패했습니다',
		'Failed to delete newsletter': '뉴스레터 삭제에 실패했습니다',
		'Failed to delete notification': '알림 삭제에 실패했습니다',
		'Failed to delete passkey': '패스키 삭제에 실패했습니다',
		'Failed to delete role': '역할 삭제에 실패했습니다',
		'Failed to delete template': '템플릿 삭제에 실패했습니다',
		'Failed to disable 2FA': '2FA 비활성화에 실패했습니다',
		'Failed to load admin statistics': '관리자 통계를 불러오지 못했습니다',
		'Failed to load analytics': '분석 데이터를 불러오지 못했습니다',
		'Failed to load application': '애플리케이션을 불러오지 못했습니다',
		'Failed to load applications': '애플리케이션 목록을 불러오지 못했습니다',
		'Failed to load audit logs': '감사 로그를 불러오지 못했습니다',
		'Failed to load data': '데이터를 불러오지 못했습니다',
		'Failed to load image.': '이미지를 불러오지 못했습니다.',
		'Failed to load newsletters': '뉴스레터 목록을 불러오지 못했습니다',
		'Failed to load notifications': '알림을 불러오지 못했습니다',
		'Failed to load passkeys': '패스키를 불러오지 못했습니다',
		'Failed to load preview': '미리보기를 불러오지 못했습니다',
		'Failed to load preview.': '미리보기를 불러오지 못했습니다.',
		'Failed to load profile': '프로필을 불러오지 못했습니다',
		'Failed to load profile.': '프로필을 불러오지 못했습니다.',
		'Failed to load roles': '역할 목록을 불러오지 못했습니다',
		'Failed to load server preview': '서버 미리보기를 불러오지 못했습니다',
		'Failed to load sessions': '세션을 불러오지 못했습니다',
		'Failed to load settings': '설정을 불러오지 못했습니다',
		'Failed to load staging data.': '스테이징 데이터를 불러오지 못했습니다.',
		'Failed to load templates': '템플릿 목록을 불러오지 못했습니다',
		'Failed to load transactions': '거래 내역을 불러오지 못했습니다',
		'Failed to load user': '사용자를 불러오지 못했습니다',
		'Failed to mark all as read': '전체 읽음 처리에 실패했습니다',
		'Failed to mark as read': '읽음 처리에 실패했습니다',
		'Failed to pause newsletter': '뉴스레터 일시 정지에 실패했습니다',
		'Failed to record transaction': '거래 기록에 실패했습니다',
		'Failed to register passkey': '패스키 등록에 실패했습니다',
		'Failed to rename passkey': '패스키 이름 변경에 실패했습니다',
		'Failed to resend.': '재전송에 실패했습니다.',
		'Failed to reset password. Please try again.': '비밀번호 재설정에 실패했습니다. 다시 시도해 주세요.',
		'Failed to resume newsletter': '뉴스레터 재개에 실패했습니다',
		'Failed to revoke session': '세션 해지에 실패했습니다',
		'Failed to revoke sessions': '세션 해지에 실패했습니다',
		'Failed to revoke sessions.': '세션 해지에 실패했습니다.',
		'Failed to save SMTP settings': 'SMTP 설정 저장에 실패했습니다',
		'Failed to save newsletter': '뉴스레터 저장에 실패했습니다',
		'Failed to save profile': '프로필 저장에 실패했습니다',
		'Failed to save role': '역할 저장에 실패했습니다',
		'Failed to save security settings': '보안 설정 저장에 실패했습니다',
		'Failed to save settings': '설정 저장에 실패했습니다',
		'Failed to save template': '템플릿 저장에 실패했습니다',
		'Failed to send code. Please try again.': '코드 전송에 실패했습니다. 다시 시도해 주세요.',
		'Failed to send newsletter.': '뉴스레터 전송에 실패했습니다.',
		'Failed to send notification': '알림 전송에 실패했습니다',
		'Failed to send reset email. Please try again.': '재설정 이메일 전송에 실패했습니다. 다시 시도해 주세요.',
		'Failed to send test email': '테스트 이메일 전송에 실패했습니다',
		'Failed to send test email.': '테스트 이메일 전송에 실패했습니다.',
		'Failed to send verification code': '인증 코드 전송에 실패했습니다',
		'Failed to start 2FA setup': '2FA 설정 시작에 실패했습니다',
		'Failed to update application': '애플리케이션 업데이트에 실패했습니다',
		'Failed to update user': '사용자 업데이트에 실패했습니다',
		'Failed to upload avatar': '아바타 업로드에 실패했습니다',
		'Failed to upload icon': '아이콘 업로드에 실패했습니다',
		'Failed to upload logo': '로고 업로드에 실패했습니다',
		'Feed URL': '피드 URL',
		'Filtered by Application': '애플리케이션별 필터',
		'Filtered by application': '애플리케이션별 필터',
		'Filters': '필터',
		'First Name': '이름',
		'First name': '이름',
		'First name is required.': '이름은 필수입니다.',
		'Follow Abstract on Twitter': 'Twitter에서 Abstract 팔로우',
		'Forgot Password': '비밀번호 찾기',
		'Forgot password?': '비밀번호를 잊으셨나요?',
		'Found in the top-right of the Apple Developer portal.': 'Apple Developer 포털 오른쪽 상단에서 확인할 수 있습니다.',
		'Framework': '프레임워크',
		'From Email': '발신자 이메일',
		'From Name': '발신자 이름',
		'General': '일반',
		'General Settings': '일반 설정',
		'Get started in seconds — it\'s free.': '몇 초 만에 시작하세요 — 무료입니다.',
		'Give your passkey a name to identify it later (e.g. "MacBook Touch ID").': '나중에 식별할 수 있도록 패스키에 이름을 지정하세요 (예: "MacBook Touch ID").',
		'Global': '전역',
		'Global only': '전역만',
		'Go to Dashboard': '대시보드로 이동',
		'Go to sign in': '로그인하기',
		'Good afternoon': '안녕하세요',
		'Good evening': '안녕하세요',
		'Good morning': '안녕하세요',
		'Google Client ID': 'Google Client ID',
		'Google Client Secret': 'Google Client Secret',
		'Google Sign-In': 'Google 로그인',
		'Google sign-in failed. Please try again.': 'Google 로그인에 실패했습니다. 다시 시도해 주세요.',
		'Google sign-up failed. Please try again.': 'Google 회원가입에 실패했습니다. 다시 시도해 주세요.',
		'HTML Content': 'HTML 콘텐츠',
		'Has password': '비밀번호 설정됨',
		'Hello Jane!...': 'Hello Jane!...',
		'Hide password': '비밀번호 숨기기',
		'How long to cache feed results server-side. Default: 900 (15 minutes).': '서버 측 피드 결과 캐시 시간입니다. 기본값: 900 (15분).',
		'I\'ve saved my codes': '코드를 저장했습니다',
		'ID': 'ID',
		'Identifier of the .p8 key enabled for Sign in with Apple.': 'Apple로 로그인이 활성화된 .p8 키의 식별자입니다.',
		'IP Access Control': 'IP 접근 제어',
		'IP Address': 'IP 주소',
		'IP Restrictions': 'IP 제한',
		'Icon (Font Awesome class)': '아이콘 (Font Awesome 클래스)',
		'Icon Image': '아이콘 이미지',
		'Icon removed.': '아이콘이 삭제되었습니다.',
		'Icon uploaded.': '아이콘이 업로드되었습니다.',
		'Identity, simplified.': '간편한 인증 관리.',
		'Import': '가져오기',
		'Import Users': '사용자 가져오기',
		'Import failed': '가져오기 실패',
		'Imported': '가져옴',
		'Imported users will be created as dormant accounts (authProvider = \'imported\'). They can receive newsletters and log in via email OTP without needing to register separately.': '가져온 사용자는 비활성 계정(authProvider = \'imported\')으로 생성됩니다. 별도의 가입 없이 뉴스레터를 수신하고 이메일 OTP로 로그인할 수 있습니다.',
		'Importing…': '가져오는 중…',
		'Inactive': '비활성',
		'Increase security by creating a password for your account.': '계정에 비밀번호를 생성하여 보안을 강화하세요.',
		'Info': '정보',
		'Inline newsletter preview': '인라인 뉴스레터 미리보기',
		'Insert token:': '토큰 삽입:',
		'Internal notes (only visible to admins)...': '내부 메모 (관리자에게만 표시)...',
		'Interval between batches': '배치 간 간격',
		'Invalid': '유효하지 않음',
		'Invalid (skipped):': '유효하지 않음 (건너뜀):',
		'Invalid application ID.': '유효하지 않은 애플리케이션 ID입니다.',
		'Invalid code. Please try again.': '유효하지 않은 코드입니다. 다시 시도해 주세요.',
		'Invalid newsletter ID.': '유효하지 않은 뉴스레터 ID입니다.',
		'Invalid or expired code': '유효하지 않거나 만료된 코드',
		'Invalid or expired code.': '유효하지 않거나 만료된 코드입니다.',
		'Invalid user ID.': '유효하지 않은 사용자 ID입니다.',
		'John': 'John',
		'Join Abstract on Discord': 'Discord에서 Abstract 참여',
		'Joined': '가입일',
		'Label': '레이블',
		'Language': '언어',
		'Large heading on the auth page branding panel.': '인증 페이지 브랜딩 패널의 큰 제목입니다.',
		'Last Login': '최근 로그인',
		'Last Name': '성',
		'Last login:': '최근 로그인:',
		'Last name': '성',
		'Last name is required.': '성은 필수입니다.',
		'Last used': '마지막 사용',
		'Latest News': '최신 뉴스',
		'Leave all fields empty to use local disk storage.': '로컬 디스크 저장소를 사용하려면 모든 필드를 비워두세요.',
		'Leave as "None" for a global role that applies across all applications.': '모든 애플리케이션에 적용되는 전역 역할로 설정하려면 "없음"으로 두세요.',
		'Leave empty for unlimited.': '무제한으로 설정하려면 비워두세요.',
		'Leave empty to accept any Microsoft account. Set a directory ID to restrict sign-in to one organisation.': '비워두면 모든 Microsoft 계정을 허용합니다. 디렉터리 ID를 지정하면 한 조직으로 로그인을 제한합니다.',
		'Leave empty to auto-generate the plain-text part from the HTML body.': '비워 두면 HTML 본문에서 일반 텍스트 부분이 자동으로 생성됩니다.',
		'Leave empty to disable Google Sign-In.': 'Google 로그인을 비활성화하려면 비워두세요.',
		'Leave empty to disable Sign in with Apple.': 'Apple로 로그인을 비활성화하려면 비워두세요.',
		'Leave empty to disable Sign in with Microsoft.': 'Microsoft로 로그인을 비활성화하려면 비워두세요.',
		'Light': '라이트',
		'Link icon': '링크 아이콘',
		'Linked from login/register pages and emails.': '로그인/회원가입 페이지 및 이메일에서 연결됩니다.',
		'Linked on login and registration pages.': '로그인 및 회원가입 페이지에 연결됩니다.',
		'Live Preview': '실시간 미리보기',
		'Loading audit logs…': '감사 로그 로딩 중…',
		'Loading notifications...': '알림 로딩 중...',
		'Loading notifications…': '알림 로딩 중…',
		'Loading roles...': '역할 로딩 중...',
		'Loading…': '로딩 중…',
		'Location': '위치',
		'Login Heading': '로그인 제목',
		'Login Subheading': '로그인 부제목',
		'Login failed. Please try again.': '로그인에 실패했습니다. 다시 시도해 주세요.',
		'Logins (24h)': '로그인 (24시간)',
		'Logo Image': '로고 이미지',
		'Logo removed.': '로고가 삭제되었습니다.',
		'Logo uploaded.': '로고가 업로드되었습니다.',
		'Manage Users': '사용자 관리',
		'Manage active sessions': '활성 세션 관리',
		'Manage passkey credentials': '패스키 자격 증명 관리',
		'Manage user accounts and permissions': '사용자 계정 및 권한 관리',
		'Map Columns': '열 매핑',
		'Mark all as read': '모두 읽음으로 표시',
		'Mark as read': '읽음으로 표시',
		'Master Template': '마스터 템플릿',
		'Master Template:': '마스터 템플릿:',
		'Max Forgot-Password Requests': '최대 비밀번호 찾기 요청 수',
		'Max Reset-Password Attempts': '최대 비밀번호 재설정 시도 수',
		'Media': '미디어',
		'Message (optional)': '메시지 (선택사항)',
		'Microsoft sign-in failed. Please try again.': 'Microsoft 로그인에 실패했습니다. 다시 시도해 주세요.',
		'Microsoft sign-up failed. Please try again.': 'Microsoft 회원가입에 실패했습니다. 다시 시도해 주세요.',
		'Migration Contact Email': '마이그레이션 연락처 이메일',
		'Must be 3–30 characters (letters, numbers, underscores).': '3~30자여야 합니다 (영문, 숫자, 밑줄).',
		'Must be at least 8 characters.': '최소 8자 이상이어야 합니다.',
		'Must match a Return URL registered on the Services ID exactly.': 'Services ID에 등록된 반환 URL과 정확히 일치해야 합니다.',
		'My Application': '내 애플리케이션',
		'My Applications': '내 애플리케이션',
		'My Apps': '내 앱',
		'My Passkey': '내 패스키',
		'My Profile': '내 프로필',
		'Name': '이름',
		'Name your passkey': '패스키 이름 지정',
		'Name, username, and avatar': '이름, 사용자명, 아바타',
		'Never': '없음',
		'Never used': '사용한 적 없음',
		'New Application': '새 애플리케이션',
		'New Newsletter': '새 뉴스레터',
		'New Password': '새 비밀번호',
		'New Role': '새 역할',
		'New Template': '새 템플릿',
		'New email address': '새 이메일 주소',
		'New password': '새 비밀번호',
		'New password is required.': '새 비밀번호는 필수입니다.',
		'New passwords do not match.': '새 비밀번호가 일치하지 않습니다.',
		'New username': '새 사용자명',
		'New users': '신규 사용자',
		'New users to import:': '가져올 신규 사용자:',
		'News Feed': '뉴스 피드',
		'Newsletter Cancelled': '뉴스레터 취소됨',
		'Newsletter Created': '뉴스레터 생성됨',
		'Newsletter Deleted': '뉴스레터 삭제됨',
		'Newsletter Paused': '뉴스레터 일시 정지됨',
		'Newsletter Preview': '뉴스레터 미리보기',
		'Newsletter Resumed': '뉴스레터 재개됨',
		'Newsletter Sent': '뉴스레터 전송됨',
		'Newsletter Started': '뉴스레터 시작됨',
		'Newsletter Updated': '뉴스레터 업데이트됨',
		'Newsletter cancelled.': '뉴스레터가 취소되었습니다.',
		'Newsletter created.': '뉴스레터가 생성되었습니다.',
		'Newsletter default': '뉴스레터 기본값',
		'Newsletter deleted.': '뉴스레터가 삭제되었습니다.',
		'Newsletter dispatch started.': '뉴스레터 발송이 시작되었습니다.',
		'Newsletter paused.': '뉴스레터가 일시 정지되었습니다.',
		'Newsletter preview': '뉴스레터 미리보기',
		'Newsletter resumed.': '뉴스레터가 재개되었습니다.',
		'Newsletter updated.': '뉴스레터가 업데이트되었습니다.',
		'Newsletters': '뉴스레터',
		'Next': '다음',
		'No Backend Response': '백엔드 응답 없음',
		'No Recipients': '수신자 없음',
		'No active sessions.': '활성 세션이 없습니다.',
		'No application registrations yet.': '등록된 애플리케이션이 없습니다.',
		'No applications configured.': '설정된 애플리케이션이 없습니다.',
		'No applications found.': '애플리케이션을 찾을 수 없습니다.',
		'No applications match your filters': '필터 조건에 맞는 애플리케이션이 없습니다',
		'No applications registered yet': '등록된 애플리케이션이 아직 없습니다',
		'No applications registered.': '등록된 애플리케이션이 없습니다.',
		'No audit logs found.': '감사 로그를 찾을 수 없습니다.',
		'No email templates yet': '이메일 템플릿이 아직 없습니다',
		'No master template': '마스터 템플릿 없음',
		'No new users to import. All valid email addresses already exist in the system.': '가져올 신규 사용자가 없습니다. 유효한 이메일 주소가 모두 시스템에 이미 존재합니다.',
		'No newsletters found.': '뉴스레터를 찾을 수 없습니다.',
		'No notifications yet.': '아직 알림이 없습니다.',
		'No passkeys registered yet.': '등록된 패스키가 아직 없습니다.',
		'No password — signs in via email OTP': '비밀번호 없음 — 이메일 OTP로 로그인',
		'No recipients match the audience criteria. Adjust the audience settings before sending.': '수신 대상 기준에 맞는 수신자가 없습니다. 발송 전에 수신 대상 설정을 조정하세요.',
		'No roles defined yet': '정의된 역할이 아직 없습니다',
		'No roles defined yet.': '정의된 역할이 아직 없습니다.',
		'No roles match your filters': '필터 조건에 맞는 역할이 없습니다',
		'No settings found.': '설정을 찾을 수 없습니다.',
		'No settings found. Save defaults to create the settings row.': '설정을 찾을 수 없습니다. 기본값을 저장하여 설정 행을 생성하세요.',
		'No subject yet': '아직 제목 없음',
		'No templates match your filters': '필터 조건에 맞는 템플릿이 없습니다',
		'No transactions yet.': '거래 내역이 아직 없습니다.',
		'No users found': '사용자를 찾을 수 없습니다',
		'No users match your filters': '필터 조건에 맞는 사용자가 없습니다',
		'No, cancel': '아니요, 취소',
		'Non-Registered Redirect URL': '미등록 리디렉션 URL',
		'None': '없음',
		'None (Global)': '없음 (전역)',
		'Not configured': '미설정',
		'Nothing here yet': '아직 내용이 없습니다',
		'Notifications': '알림',
		'OAuth': 'OAuth',
		'Open Rate': '오픈율',
		'Open your authenticator app and enter the 6-digit code.': '인증 앱을 열고 6자리 코드를 입력하세요.',
		'Opens': '열람',
		'Opt out of newsletters': '뉴스레터 수신 거부',
		'Opted-out users excluded': '수신 거부 사용자 제외됨',
		'Optionally register imported users to one or more applications. This step is optional — you can skip it to import users without application registrations.': '가져온 사용자를 하나 이상의 애플리케이션에 선택적으로 등록할 수 있습니다. 이 단계는 선택사항이며, 건너뛰어 애플리케이션 등록 없이 사용자를 가져올 수 있습니다.',
		'Or enter manually:': '또는 직접 입력:',
		'Order': '순서',
		'Overview': '개요',
		'Page Not Found': '페이지를 찾을 수 없습니다',
		'Paragraph text below the heading.': '제목 아래의 본문 텍스트입니다.',
		'Passkey deleted.': '패스키가 삭제되었습니다.',
		'Passkey registered successfully!': '패스키가 성공적으로 등록되었습니다!',
		'Passkey renamed.': '패스키 이름이 변경되었습니다.',
		'Passkey sign-in failed. Please try again.': '패스키 로그인에 실패했습니다. 다시 시도해 주세요.',
		'Passkeys': '패스키',
		'Password': '비밀번호',
		'Password Changed': '비밀번호 변경됨',
		'Password Reset Completed': '비밀번호 재설정 완료',
		'Password Reset Requested': '비밀번호 재설정 요청됨',
		'Password changed successfully.': '비밀번호가 성공적으로 변경되었습니다.',
		'Password created successfully.': '비밀번호가 성공적으로 생성되었습니다.',
		'Password is required.': '비밀번호는 필수입니다.',
		'Password must be at least 6 characters.': '비밀번호는 최소 6자 이상이어야 합니다.',
		'Password must be at least 8 characters.': '비밀번호는 최소 8자 이상이어야 합니다.',
		'Passwordless': '비밀번호 없음',
		'Passwords do not match.': '비밀번호가 일치하지 않습니다.',
		'Paste the full contents of the .p8 file downloaded from Apple.': 'Apple에서 다운로드한 .p8 파일의 전체 내용을 붙여넣으세요.',
		'Pause': '일시 정지',
		'Paused': '일시 정지됨',
		'Pending': '대기 중',
		'Performed By': '수행자',
		'Personal Information': '개인 정보',
		'Plain text version...': '일반 텍스트 버전...',
		'Plain-Text Fallback (optional)': '일반 텍스트 대체 (선택사항)',
		'Platform configuration': '플랫폼 설정',
		'Please enter a backup code.': '백업 코드를 입력해 주세요.',
		'Please enter a new password.': '새 비밀번호를 입력해 주세요.',
		'Please enter a valid code to disable 2FA.': '2FA를 비활성화하려면 유효한 코드를 입력해 주세요.',
		'Please enter a valid email address.': '유효한 이메일 주소를 입력해 주세요.',
		'Please enter a valid, available username.': '유효하고 사용 가능한 사용자명을 입력해 주세요.',
		'Please enter the 6-digit verification code.': '6자리 인증 코드를 입력해 주세요.',
		'Please enter your current password.': '현재 비밀번호를 입력해 주세요.',
		'Please wait while we verify your account.': '계정을 확인하는 동안 잠시 기다려 주세요.',
		'Policies': '정책',
		'Preferences': '환경설정',
		'Prev': '이전',
		'Preview': '미리보기',
		'Preview (first 5 rows)': '미리보기 (처음 5행)',
		'Preview Consent': '동의 미리보기',
		'Preview Token Flow': '토큰 플로우 미리보기',
		'Previous': '이전',
		'Private Key': '비공개 키',
		'Profile': '프로필',
		'Profile Picture': '프로필 사진',
		'Profile updated successfully.': '프로필이 성공적으로 업데이트되었습니다.',
		'Public Content': '공개 콘텐츠',
		'Public URL (optional)': '공개 URL (선택사항)',
		'Purchase': '구매',
		'Quick Actions': '빠른 작업',
		'Rate Limiting': '속도 제한',
		'Re-enter your new password': '새 비밀번호를 다시 입력하세요',
		'Re-enter your password': '비밀번호를 다시 입력하세요',
		'Reason': '사유',
		'Recent Activity': '최근 활동',
		'Recent Notifications': '최근 알림',
		'Recipient Breakdown': '수신자 현황',
		'Recipient Email': '수신자 이메일',
		'Recipients': '수신자',
		'Record': '기록',
		'Record Transaction': '거래 기록',
		'Redirect URI': '리디렉션 URI',
		'Refresh': '새로고침',
		'Refresh Stats': '통계 새로고침',
		'Refund': '환불',
		'Region': '리전',
		'Register again': '다시 가입하기',
		'Register and manage applications that use this identity provider.': '이 인증 제공자를 사용하는 애플리케이션을 등록하고 관리하세요.',
		'Register and manage apps': '앱 등록 및 관리',
		'Register this exact URL as a Web redirect URI on the app. It must end in /auth/microsoft/callback.': '이 URL을 그대로 앱의 웹 리디렉션 URI로 등록하세요. 반드시 /auth/microsoft/callback으로 끝나야 합니다.',
		'Register to Applications': '애플리케이션에 등록',
		'Registration failed. Please try again.': '가입에 실패했습니다. 다시 시도해 주세요.',
		'Reload all administration statistics': '모든 관리 통계 새로고침',
		'Remove': '제거',
		'Remove Icon': '아이콘 제거',
		'Replace Icon': '아이콘 교체',
		'Required for server-side token verification.': '서버 측 토큰 검증에 필요합니다.',
		'Resend code': '코드 재전송',
		'Reset Password': '비밀번호 재설정',
		'Reset code is invalid or expired.': '재설정 코드가 유효하지 않거나 만료되었습니다.',
		'Reset password': '비밀번호 재설정',
		'Resized to 128×128': '128×128로 크기 조정됨',
		'Resized to 512×512': '512×512로 크기 조정됨',
		'Resume': '재개',
		'Retry': '재시도',
		'Return URL': '반환 URL',
		'Review': '검토',
		'Review Data': '데이터 검토',
		'Review system activity and security events': '시스템 활동 및 보안 이벤트 검토',
		'Review the details below before sending this newsletter.': '이 뉴스레터를 발송하기 전에 아래 내용을 확인하세요.',
		'Review the validation results below before importing.': '가져오기 전에 아래 검증 결과를 확인하세요.',
		'Revoke': '해지',
		'Revoke All Sessions': '모든 세션 해지',
		'Revoke all others': '다른 세션 모두 해지',
		'Revoking…': '해지 중…',
		'Role': '역할',
		'Role Changed': '역할 변경됨',
		'Role Created': '역할 생성됨',
		'Role Deleted': '역할 삭제됨',
		'Role Name': '역할 이름',
		'Role Updated': '역할 업데이트됨',
		'Role name is required.': '역할 이름은 필수입니다.',
		'Roles': '역할',
		'Row': '행',
		'S3 Storage': 'S3 스토리지',
		'S3-compatible endpoint (e.g. https://s3.amazonaws.com or your MinIO URL).': 'S3 호환 엔드포인트 (예: https://s3.amazonaws.com 또는 MinIO URL).',
		'Sign in with Apple': 'Apple로 로그인',
		'Sign in with Microsoft': 'Microsoft로 로그인',
		'Sign up with Apple': 'Apple로 가입',
		'Sign up with Microsoft': 'Microsoft로 가입',
		'Signing you out…': '로그아웃하는 중…',
		'SMTP': 'SMTP',
		'SMTP Configuration': 'SMTP 설정',
		'SMTP Host': 'SMTP 호스트',
		'SMTP Port': 'SMTP 포트',
		'SMTP Status': 'SMTP 상태',
		'SMTP connection verified successfully.': 'SMTP 연결이 성공적으로 확인되었습니다.',
		'SMTP settings saved successfully.': 'SMTP 설정이 성공적으로 저장되었습니다.',
		'SMTP verification failed': 'SMTP 확인 실패',
		'Save': '저장',
		'Save Changes': '변경사항 저장',
		'Save Profile': '프로필 저장',
		'Save SMTP': 'SMTP 저장',
		'Save Security Settings': '보안 설정 저장',
		'Save Settings': '설정 저장',
		'Save these codes in a safe place. Each can be used once if you lose your authenticator. They will not be shown again.': '이 코드들을 안전한 곳에 보관하세요. 인증 앱을 분실한 경우 각 코드를 한 번씩 사용할 수 있습니다. 다시 표시되지 않습니다.',
		'Saving...': '저장 중...',
		'Scan with your authenticator app:': '인증 앱으로 스캔하세요:',
		'Scheduled': '예약됨',
		'Scoped to Application': '애플리케이션 범위',
		'Search': '검색',
		'Search applications...': '애플리케이션 검색...',
		'Search by name or email...': '이름 또는 이메일로 검색...',
		'Search logs...': '로그 검색...',
		'Search name or subject…': '이름 또는 제목 검색…',
		'Search roles...': '역할 검색...',
		'Search templates...': '템플릿 검색...',
		'Seconds before expiry during which a refresh is allowed. Default 4320 (72 min).': '만료 전 갱신이 허용되는 시간(초)입니다. 기본값 4320 (72분).',
		'Secret Access Key': 'Secret Access Key',
		'Secret is configured': '시크릿이 설정되어 있습니다',
		'Secure authentication, role management, and user administration — all in one place.': '안전한 인증, 역할 관리, 사용자 관리를 한 곳에서.',
		'Security': '보안',
		'Security & Access Control': '보안 및 접근 제어',
		'Security settings saved successfully.': '보안 설정이 성공적으로 저장되었습니다.',
		'Select…': '선택…',
		'Send': '전송',
		'Send Notification': '알림 전송',
		'Send Test Email': '테스트 이메일 전송',
		'Send reset code': '재설정 코드 전송',
		'Send test email': '테스트 이메일 전송',
		'Sender Identity': '발신자 정보',
		'Sending': '전송 중',
		'Sending...': '전송 중...',
		'Sent': '전송됨',
		'Sent At': '전송 시각',
		'Server': '서버',
		'Server Preview': '서버 미리보기',
		'Server-rendered newsletter preview': '서버 렌더링 뉴스레터 미리보기',
		'Service Active': '서비스 활성',
		'Session Locations': '세션 위치',
		'Session revoked.': '세션이 해지되었습니다.',
		'Sessions': '세션',
		'Settings': '설정',
		'Settings Changed': '설정 변경됨',
		'Settings saved successfully.': '설정이 성공적으로 저장되었습니다.',
		'Show password': '비밀번호 표시',
		'Showing': '표시 중',
		'Shown during account migration / data transfer.': '계정 마이그레이션 / 데이터 이전 시 표시됩니다.',
		'Sidebar link icon removed.': '사이드바 링크 아이콘이 삭제되었습니다.',
		'Sidebar link icon uploaded.': '사이드바 링크 아이콘이 업로드되었습니다.',
		'Sign Out': '로그아웃',
		'Sign in': '로그인',
		'Sign in or Register': '로그인 또는 회원가입',
		'Sign in securely with fingerprint, face recognition, or security keys.': '지문, 얼굴 인식 또는 보안 키로 안전하게 로그인하세요.',
		'Sign in to': '로그인',
		'Sign in with Google': 'Google로 로그인',
		'Sign in with a passkey': '패스키로 로그인',
		'Sign in with email code instead': '이메일 코드로 로그인',
		'Sign in with password': '비밀번호로 로그인',
		'Sign up with Google': 'Google로 가입',
		'Signups This Week': '이번 주 가입자',
		'Signups This Year': '올해 가입자',
		'Skip': '건너뛰기',
		'Social Account Linked': '소셜 계정 연결됨',
		'Stack trace': '스택 트레이스',
		'Start typing HTML content to see a preview': 'HTML 콘텐츠를 입력하면 미리보기가 표시됩니다',
		'Status': '상태',
		'Status & Features': '상태 및 기능',
		'Status:': '상태:',
		'Stay up to date with your account activity': '계정 활동을 최신 상태로 확인하세요',
		'Subject': '제목',
		'Subject Line': '제목',
		'Subject:': '제목:',
		'Success': '성공',
		'Synced': '동기화됨',
		'System': '시스템',
		'System Errors': '시스템 오류',
		'System Information': '시스템 정보',
		'Target': '대상',
		'Template': '템플릿',
		'Template Name': '템플릿 이름',
		'Template Preview': '템플릿 미리보기',
		'Template created.': '템플릿이 생성되었습니다.',
		'Template deleted.': '템플릿이 삭제되었습니다.',
		'Template name and subject are required.': '템플릿 이름과 제목은 필수입니다.',
		'Template updated.': '템플릿이 업데이트되었습니다.',
		'Terms of Service': '서비스 이용약관',
		'Terms of Service URL': '서비스 이용약관 URL',
		'Test email sent to your address.': '테스트 이메일이 전송되었습니다.',
		'Text Content (fallback)': '텍스트 콘텐츠 (대체)',
		'The application you were trying to sign in to was not found or is no longer active.': '로그인하려는 애플리케이션을 찾을 수 없거나 더 이상 활성 상태가 아닙니다.',
		'The master template used by newsletters when no specific template is selected.': '특정 템플릿이 선택되지 않은 경우 뉴스레터에 사용되는 마스터 템플릿입니다.',
		'The page you\'re looking for doesn\'t exist or has been moved.': '찾으시는 페이지가 존재하지 않거나 이동되었습니다.',
		'The secret value, not its ID. Secrets expire — note the expiry date.': '비밀의 ID가 아닌 값입니다. 비밀은 만료되므로 만료일을 기록해 두세요.',
		'The sender address in the email From header.': '이메일 From 헤더의 발신자 주소입니다.',
		'The verification link may have expired. Please try registering again.': '인증 링크가 만료되었을 수 있습니다. 다시 가입해 주세요.',
		'Theme': '테마',
		'This is a preview of the consent page. No authorization will be performed.': '동의 페이지의 미리보기입니다. 실제 인증은 수행되지 않습니다.',
		'This is a preview of the token staging page. In the real flow, the user\'s JWT would appear below.': '토큰 스테이징 페이지의 미리보기입니다. 실제 플로우에서는 사용자의 JWT가 아래에 표시됩니다.',
		'This is a preview. In the real flow, the user would be redirected back to': '미리보기입니다. 실제 플로우에서는 사용자가 다음으로 리디렉션됩니다:',
		'This is a preview. No real token was generated.': '미리보기입니다. 실제 토큰은 생성되지 않았습니다.',
		'This page is part of the Microsoft sign-in flow and can be closed.': '이 페이지는 Microsoft 로그인 과정의 일부이며 닫아도 됩니다.',
		'Time': '시간',
		'Title (required)': '제목 (필수)',
		'Toggle dark mode': '다크 모드 전환',
		'Token & Session': '토큰 및 세션',
		'Token Flow': '토큰 플로우',
		'Token Flow Preview': '토큰 플로우 미리보기',
		'Token Refresh Window (seconds)': '토큰 갱신 기간 (초)',
		'Token copied to clipboard': '토큰이 클립보드에 복사되었습니다',
		'Tokens': '토큰',
		'Tokens are replaced per-recipient at send time. The preview shows sample data.': '토큰은 발송 시 수신자별로 치환됩니다. 미리보기에는 샘플 데이터가 표시됩니다.',
		'Top Clicked URLs': '가장 많이 클릭된 URL',
		'Total Recipients': '전체 수신자',
		'Total Users': '전체 사용자',
		'Total batches': '전체 배치',
		'Total rows': '전체 행',
		'Two-Factor Authentication': '2단계 인증',
		'Two-factor authentication': '2단계 인증',
		'Two-factor authentication enabled successfully!': '2단계 인증이 성공적으로 활성화되었습니다!',
		'Two-factor authentication has been disabled.': '2단계 인증이 비활성화되었습니다.',
		'Type': '유형',
		'URL': 'URL',
		'UUID': 'UUID',
		'Unknown device': '알 수 없는 기기',
		'Unlimited': '무제한',
		'Unnamed': '이름 없음',
		'Unnamed User': '이름 없는 사용자',
		'Unsubscribes': '구독 취소',
		'Unverified': '미인증',
		'Updated': '업데이트됨',
		'Upload': '업로드',
		'Upload CSV File': 'CSV 파일 업로드',
		'Upload Icon': '아이콘 업로드',
		'Upload Logo': '로고 업로드',
		'Upload a CSV file containing the users you want to import. The first row should contain column headers (e.g. Email, First Name, Last Name).': '가져올 사용자가 포함된 CSV 파일을 업로드하세요. 첫 번째 행에는 열 머리글이 있어야 합니다 (예: Email, First Name, Last Name).',
		'Upload a square image. It will be resized to 256×256 pixels.': '정사각형 이미지를 업로드하세요. 256×256 픽셀로 크기가 조정됩니다.',
		'Uploading…': '업로드 중…',
		'Use TLS': 'TLS 사용',
		'Use a backup code instead': '백업 코드 사용',
		'Use a passkey': '패스키 사용',
		'Use authenticator app instead': '인증 앱 사용',
		'Use passkey': '패스키 사용',
		'Use password': '비밀번호 사용',
		'User': '사용자',
		'User Activated': '사용자 활성화됨',
		'User Dashboard': '사용자 대시보드',
		'User Deactivated': '사용자 비활성화됨',
		'User Deleted': '사용자 삭제됨',
		'User Login': '사용자 로그인',
		'User Registered': '사용자 등록됨',
		'User Updated': '사용자 업데이트됨',
		'User Verified': '사용자 인증됨',
		'User dashboard settings saved.': '사용자 대시보드 설정이 저장되었습니다.',
		'User updated successfully.': '사용자가 성공적으로 업데이트되었습니다.',
		'Username': '사용자명',
		'Username updated successfully.': '사용자명이 성공적으로 업데이트되었습니다.',
		'Users': '사용자',
		'Uses the WordPress REST API': 'WordPress REST API를 사용합니다',
		'Verification Link Expiry': '인증 링크 만료',
		'Verification URLs': '인증 URL',
		'Verification code sent to your email.': '인증 코드가 이메일로 전송되었습니다.',
		'Verification failed. The link may be invalid or expired.': '인증에 실패했습니다. 링크가 유효하지 않거나 만료되었을 수 있습니다.',
		'Verified': '인증됨',
		'Verify': '인증',
		'Verify Connection': '연결 확인',
		'Verify your identity': '본인 확인',
		'Verifying your email': '이메일 인증 중',
		'Verifying...': '인증 중...',
		'Version': '버전',
		'View all audit logs': '모든 감사 로그 보기',
		'View all notifications': '모든 알림 보기',
		'View and edit accounts': '계정 보기 및 편집',
		'View details': '상세 보기',
		'View transactions & balance': '거래 내역 및 잔액 보기',
		'View your notifications': '알림 보기',
		'View, search, and manage user accounts': '사용자 계정 조회, 검색 및 관리',
		'Visible': '표시',
		'Visible When Registered': '등록 시 표시',
		'Warning': '경고',
		'Wave': '웨이브',
		'Wave Interval (sec)': '웨이브 간격 (초)',
		'Wave Size': '웨이브 크기',
		'We sent a 6-digit code to': '6자리 코드를 전송했습니다:',
		'We sent a verification link to': '인증 링크를 전송했습니다:',
		'We sent a verification link to your email address.': '이메일 주소로 인증 링크를 전송했습니다.',
		'We\'ve sent you a verification link.': '인증 링크를 전송했습니다.',
		'Website': '웹사이트',
		'Website Name': '웹사이트 이름',
		'Website URL': '웹사이트 URL',
		'What this role grants access to...': '이 역할이 접근을 허용하는 항목...',
		'When disabled, the feed section is hidden from the user dashboard.': '비활성화하면 사용자 대시보드에서 피드 섹션이 숨겨집니다.',
		'When disabled, the identity service rejects new registrations.': '비활성화하면 인증 서비스가 새로운 가입을 거부합니다.',
		'When enabled, multiple accounts may share the same email address.': '활성화하면 여러 계정이 동일한 이메일 주소를 공유할 수 있습니다.',
		'When enabled, you won\'t receive promotional emails.': '활성화하면 프로모션 이메일을 수신하지 않습니다.',
		'Whitelisted IPs': '허용된 IP',
		'WordPress REST API detected successfully.': 'WordPress REST API가 성공적으로 감지되었습니다.',
		'Yes, I\'m sure': '네, 확실합니다',
		'Yes, confirm': '네, 확인합니다',
		'You are not registered with any applications yet.': '아직 등록된 애플리케이션이 없습니다.',
		'You have no notifications right now.': '현재 알림이 없습니다.',
		'Your Account': '내 계정',
		'Your account is protected with TOTP authenticator.': '계정이 TOTP 인증으로 보호되고 있습니다.',
		'Your assigned roles for this application': '이 애플리케이션에 대한 할당된 역할',
		'Your email has been verified! You can now sign in.': '이메일이 인증되었습니다! 이제 로그인할 수 있습니다.',
		'Your gateway to the Abstract platform. Manage your identity, applications, and security — all in one place.': 'Abstract 플랫폼의 관문입니다. 인증, 애플리케이션, 보안을 한 곳에서 관리하세요.',
		'Your password has been reset successfully.': '비밀번호가 성공적으로 재설정되었습니다.',
		'Your request to access': '접근 요청이',
		"You've previously granted access to": '이전에 액세스를 허용한 앱:',
		'allow all.': '모두 허용합니다.',
		'by': '작성자',
		'cancel this newsletter': '이 뉴스레터를 취소',
		'delete this application': '이 애플리케이션을 삭제',
		'delete this icon': '이 아이콘을 삭제',
		'delete this logo': '이 로고를 삭제',
		'delete this newsletter': '이 뉴스레터를 삭제',
		'delete this role': '이 역할을 삭제',
		'delete this template': '이 템플릿을 삭제',
		'dismiss': '닫기',
		'e.g. January Newsletter': '예: 1월 뉴스레터',
		'e.g. a1b2c3d4': 'e.g. a1b2c3d4',
		'e.g. admin, editor, viewer': '예: admin, editor, viewer',
		'has been submitted. An administrator will review and approve your access.': '제출되었습니다. 관리자가 검토 후 접근을 승인합니다.',
		'inserting into:': '삽입 위치:',
		'is an': '은(는)',
		'is requesting access to your account. By continuing, you allow this application to verify your identity': '이(가) 계정에 대한 접근을 요청하고 있습니다. 계속하면 이 애플리케이션이 본인 인증을 수행하도록 허용합니다',
		'just now': '방금',
		'key': '키',
		'of': '/',
		'or': '또는',
		'or Apple': '또는 Apple',
		'or Microsoft': '또는 Microsoft',
		'or Google': '또는 Google',
		'product.': '제품.',
		'region': '리전',
		'regions': '리전',
		'remove this icon': '이 아이콘 제거',
		'remove your avatar': '아바타 제거',
		'revoke all sessions': '모든 세션 해지',
		'session': '세션',
		'sessions': '세션',
		'to auto-resolve the WordPress REST API endpoint.': 'WordPress REST API 엔드포인트를 자동 감지합니다.',
		'to complete sign-in.': '로그인을 완료하세요.',
		'to fetch recent posts.': '최근 게시물을 가져옵니다.',
		'tokens': '토큰',
		'user@example.com': 'user@example.com',
		'username': 'username',
		'you@example.com': 'you@example.com',
		'— Not mapped —': '— 매핑 안 됨 —',
		'••••••••': '••••••••'
	},
	zh: {
		'Images': '图片',
		'Not rated': '未评分',
		'Upload progress': '上传进度',
		'Uploading… {{percent}}%': '正在上传… {{percent}}%',
		'Linked tickets': '关联工单',
		'Follow-up of': '跟进自',
		'Continued in': '后续工单',
		'Ticket attachments': '工单附件',
		'Routing': '分派',
		'Edit routing': '编辑分派',
		'Edit routing for {{name}}': '编辑 {{name}} 的分派',
		'Edit routing for {{category}} on {{product}}': '编辑 {{product}} 上 {{category}} 的分派',
		'Show routing for {{name}}': '显示 {{name}} 的分派',
		'Hide routing for {{name}}': '隐藏 {{name}} 的分派',
		'Product rule only': '仅产品规则',
		'No support-enabled product takes this category.': '没有启用支持的产品使用此类别。',
		'Notified': '接收通知',
		'Auto-assigned': '自动分配',
		'Routing for {{product}}': '{{product}} 的分派',
		'Routing for {{category}} on {{product}}': '{{product}} 上 {{category}} 的分派',
		'Applies to every ticket on {{product}}. Category rules add to it; for assignment, a category rule with auto-assign takes precedence.': '适用于 {{product}} 的每个工单。类别规则会在此基础上追加；分配时，设有自动分配的类别规则优先。',
		'Applies to {{category}} tickets on {{product}}, in addition to the product rule.': '在产品规则之外，适用于 {{product}} 上的 {{category}} 工单。',
		'Notify: gets an email and a notification for each new ticket.': '通知：每个新工单都会收到邮件和通知。',
		'Auto-assign: new tickets go to the least busy of these agents.': '自动分配：新工单会分配给这些客服中最空闲的一位。',
		'Notify {{name}}': '通知 {{name}}',
		'Auto-assign to {{name}}': '自动分配给 {{name}}',
		'Auto-assign': '自动分配',
		'Routing saved.': '已保存分派。',
		'Failed to save routing': '保存分派失败',
		'Assigned to {{name}} automatically': '已自动分配给 {{name}}',
		'Owner': '所有者',
		'People': '参与人员',
		'Remove {{name}} from this ticket?': '将 {{name}} 从此工单中移除？',
		'A ticket can have at most {{count}} people besides its owner.': '除所有者外，一个工单最多可有 {{count}} 人。',
		'Add someone by email': '通过电子邮件添加人员',
		'People you add need an Abstract ID account. They can read the ticket, reply to it and get its emails.': '添加的人员需要拥有 Abstract ID 账户。他们可以查看和回复此工单，并接收相关邮件。',
		'Leave this ticket? You will no longer be able to see it.': '退出此工单？退出后将无法再查看。',
		'Leave ticket': '退出工单',
		'{{email}} was added to the ticket.': '已将 {{email}} 添加到工单。',
		'Failed to add the person': '无法添加该人员',
		'{{name}} was removed from the ticket.': '已将 {{name}} 从工单中移除。',
		'Failed to remove the person': '无法移除该人员',
		'Deleted the attachment {{filename}}': '删除了附件 {{filename}}',
		'Delete {{name}}? The file is erased for good and cannot be restored.': '删除 {{name}}？文件将被永久清除，无法恢复。',
		'{{name}} was deleted.': '已删除 {{name}}。',
		'Failed to delete the attachment': '无法删除附件',
		'Delete {{name}}': '删除 {{name}}',
		'You left the ticket.': '您已退出工单。',
		'Failed to leave the ticket': '无法退出工单',
		'{{owner}} added you to this ticket.': '{{owner}} 已将您添加到此工单。',
		'Shared by {{name}}': '由 {{name}} 共享',
		'The ticket owner\'s support is no longer active, so replies are closed.': '工单所有者的支持服务已失效，因此无法再回复。',
		'Added {{name}} to the ticket': '将 {{name}} 添加到工单',
		'Removed {{name}} from the ticket': '将 {{name}} 从工单中移除',
		'Left the ticket': '已退出工单',
		'Support is currently turned off': '支持目前已关闭',
		'Tickets cannot be opened or answered right now. Please check back later.': '目前无法创建或回复工单，请稍后再来。',
		'Support is turned on.': '支持已开启。',
		'Support is turned off.': '支持已关闭。',
		'Support desk': '支持中心',
		'On. Customers whose license includes support can open tickets, and agents answer them from the Support Desk.': '开启。许可证包含支持服务的客户可以创建工单，客服在支持中心回复。',
		'Off. Support is hidden from customers and agents and the automatic sweeps are paused. Tickets and settings are kept.': '关闭。支持功能对客户和客服隐藏，自动处理暂停。工单和设置将被保留。',
		'Support desk enabled': '启用支持中心',
		'Notify': '通知',
		'Team address only': '仅团队地址',
		'There are no support agents yet. Assign the support role first.': '尚无支持客服。请先分配支持角色。',
		'Agents': '客服',
		'Editor mode': '编辑模式',
		'Write': '编写',
		'Markdown supported': '支持 Markdown',
		'Nothing to preview yet.': '暂无可预览内容。',
		'Preview {{name}}': '预览 {{name}}',
		'The full image could not be loaded.': '无法加载完整图片。',
		'or drop them here': '或拖放到此处',
		'No access to support?': '无法使用支持服务？',
		'Consider purchasing a license to get instant access to our in-house engineering team. Otherwise, you can get help from the Abstract community and on the Abstract Discord.': '购买许可证即可立即联系我们的内部工程团队。您也可以在 Abstract 社区和 Abstract Discord 上获得帮助。',
		'Abstract Community': 'Abstract 社区',
		'Abstract Discord': 'Abstract Discord',
		'Community URL': '社区 URL',
		'Discord invite': 'Discord 邀请链接',
		'Offered to users without access to support. Leave blank to offer none.': '向无法使用支持服务的用户显示。留空则不显示。',
		'A question or a minor inconvenience.': '问题或轻微不便。',
		'A resolved ticket untouched this long is closed. 0 turns this off.': '已解决的工单在此期间无操作将被关闭。0 表示关闭此功能。',
		'A short summary of the problem': '问题的简短概述',
		'A ticket waiting on the customer this long is resolved. 0 turns this off.': '等待客户回复达到此时长的工单将被标记为已解决。0 表示关闭此功能。',
		'Activity': '动态',
		'Add category': '添加类别',
		'Add note': '添加备注',
		'Agent': '客服',
		'Agents and automation': '客服与自动化',
		'All open': '所有未结',
		'All products': '所有产品',
		'Another product already uses this prefix.': '其他产品已使用此前缀。',
		'Any priority': '任意优先级',
		'Any product': '任意产品',
		'Any status': '任意状态',
		'Anyone': '任何人',
		'Anything you would like to add? (optional)': '还有什么想补充的吗？（可选）',
		'Apply': '应用',
		'Ask for logs': '索取日志',
		'Assign to me': '分配给我',
		'Assign to…': '分配给…',
		'Assigned to {{name}}': '已分配给 {{name}}',
		'Assignee': '负责人',
		'Attach files': '附加文件',
		'Attachments': '附件',
		'Auto-close after (days)': '自动关闭（天）',
		'Auto-resolve after (days)': '自动解决（天）',
		'Awaiting agent': '等待客服',
		'Awaiting customer': '等待客户',
		'Back to support': '返回支持',
		'Back to the desk': '返回支持台',
		'Breaching': '违反 SLA',
		'Bulk actions': '批量操作',
		'Templates': '模板',
		'Template saved.': '模板已保存。',
		'Categories': '类别',
		'Categories are optional. They help customers say what a ticket is about.': '类别是可选的，可帮助客户说明工单的主题。',
		'Category cleared': '已清除类别',
		'Category deleted.': '类别已删除。',
		'Category saved.': '类别已保存。',
		'Category set to {{name}}': '类别设为 {{name}}',
		'Choose a product': '选择产品',
		'Choose a product.': '请选择产品。',
		'Clear selection': '清除选择',
		'Close this ticket? You can open a follow-up later if you need to.': '关闭此工单？如有需要，稍后可以创建后续工单。',
		'Close ticket': '关闭工单',
		'Closed': '已关闭',
		'Closed automatically': '已自动关闭',
		'Comment': '评论',
		'Conversation': '对话',
		'Could not check your license': '无法检查您的许可证',
		'Create ticket': '创建工单',
		'Customers file tickets against a product while their license for it includes support. Agents answer them from the Support Desk.': '客户在其许可证包含支持服务期间可针对产品提交工单，客服在支持台中回复。',
		'Delete the template “{{name}}”?': '删除模板“{{name}}”？',
		'Delete the category “{{name}}”?': '删除类别“{{name}}”？',
		'Describe the problem.': '请描述问题。',
		'Dissatisfied': '不满意',
		'Edit template': '编辑模板',
		'Edit {{name}}': '编辑 {{name}}',
		'Enable support for a product under Settings → Admin → Support.': '请在 设置 → 管理 → 支持 中为产品启用支持。',
		'Enter a whole number of days.': '请输入整数天数。',
		'Enter the requester’s email address.': '请输入请求者的电子邮件地址。',
		'Every ticket filed against a support-enabled product.': '针对已启用支持的产品提交的所有工单。',
		'Failed to delete the template': '无法删除模板',
		'Failed to delete the category': '无法删除类别',
		'Failed to download the attachment': '无法下载附件',
		'Failed to load support': '无法加载支持信息',
		'Failed to load support settings': '无法加载支持设置',
		'Failed to load the ticket': '无法加载工单',
		'Failed to load tickets': '无法加载工单',
		'No tickets yet': '暂无工单',
		'Failed to open the ticket': '无法创建工单',
		'Failed to save support for this product': '无法保存此产品的支持设置',
		'Failed to save support settings': '无法保存支持设置',
		'Failed to save the template': '无法保存模板',
		'Failed to save the category': '无法保存类别',
		'Failed to send the message': '无法发送消息',
		'Failed to send the reply': '无法发送回复',
		'Failed to submit the rating': '无法提交评分',
		'Failed to update the ticket': '无法更新工单',
		'Failed to update the tickets': '无法更新工单',
		'Filed by {{name}}': '由 {{name}} 提交',
		'Files to attach': '要附加的文件',
		'First response': '首次响应',
		'First response (hours)': '首次响应（小时）',
		'First response target for {{priority}}': '{{priority}} 的首次响应目标',
		'Follows up on {{key}}': '跟进 {{key}}',
		'For requests that reached the team another way — by phone, chat or email.': '用于通过电话、聊天或电子邮件等其他途径到达团队的请求。',
		'Get help with the Abstract products you hold a license for.': '获取您持有许可证的 Abstract 产品的帮助。',
		'Give the ticket a subject.': '请为工单填写主题。',
		'High': '高',
		'Holders of this role are agents. Administrators always are.': '拥有此角色的用户是客服。管理员始终是客服。',
		'How did we do?': '我们的服务如何？',
		'Insert template…': '插入模板…',
		'Insert placeholder:': '插入占位符：',
		'Internal note': '内部备注',
		'Last activity': '最近动态',
		'Last heard': '最近回复',
		'Low': '低',
		'Met': '已达成',
		'Mine': '我的',
		'Missed': '未达成',
		'Neutral': '一般',
		'New': '新建',
		'New template': '新建模板',
		'New ticket': '新建工单',
		'New ticket on behalf of a customer': '代表客户新建工单',
		'No templates yet': '暂无模板',
		'No categories': '无类别',
		'No category': '无类别',
		'No product has support enabled': '没有产品启用了支持',
		'No product offers you support right now': '目前没有产品为您提供支持',
		'No support role — administrators only': '无支持角色 — 仅管理员',
		'No target': '无目标',
		'No ticket matches this view and these filters.': '没有符合此视图和筛选条件的工单。',
		'Nobody': '无人',
		'None of the Abstract products offer support through Abstract ID yet.': '目前还没有 Abstract 产品通过 Abstract ID 提供支持。',
		'Normal': '普通',
		'Not yet assigned': '尚未分配',
		'Note added.': '备注已添加。',
		'Nothing in this view': '此视图中没有内容',
		'Off': '关',
		'Offered for new tickets': '可用于新工单',
		'On': '开',
		'Only the person who opened this ticket can reply to it.': '只有创建此工单的人可以回复。',
		'Your support entitlement could not be confirmed right now. Please try again shortly.': '目前无法确认您的支持资格，请稍后重试。',
		'Open': '未结',
		'Open (any)': '未结（全部）',
		'Open a follow-up': '创建后续工单',
		'Opened': '创建于',
		'Operating system': '操作系统',
		'Overdue by {{time}}': '已超时 {{time}}',
		'Paused · {{time}} left': '已暂停 · 剩余 {{time}}',
		'Prefix': '前缀',
		'Priority': '优先级',
		'Priority changed from {{from}} to {{to}}': '优先级从 {{from}} 更改为 {{to}}',
		'Priority…': '优先级…',
		'Product': '产品',
		'Product version': '产品版本',
		'Production is down and there is no workaround.': '生产环境已中断且没有替代方案。',
		'Products': '产品',
		'Rated {{rating}} out of 5': '评分 {{rating}}/5',
		'Rating': '评分',
		'Receives SLA breach alerts for tickets nobody is assigned to.': '接收无人负责工单的 SLA 违约提醒。',
		'Remove {{name}}': '移除 {{name}}',
		'Reopen ticket': '重新打开工单',
		'Replies the team reuses. Placeholders are filled in from the ticket when a reply is inserted.': '团队可重复使用的回复。插入时会用工单信息填充占位符。',
		'Reply': '回复',
		'Reply sent.': '回复已发送。',
		'Requester': '请求者',
		'Requester email': '请求者电子邮件',
		'Resolution': '解决',
		'Resolution (hours)': '解决（小时）',
		'Resolution target for {{priority}}': '{{priority}} 的解决目标',
		'Resolved': '已解决',
		'Resolved automatically after no reply': '因无回复自动解决',
		'SLA': 'SLA',
		'SLA targets must be positive numbers of hours, or blank for none.': 'SLA 目标必须是正小时数，留空表示无目标。',
		'Satisfaction': '满意度',
		'Satisfied': '满意',
		'Save settings': '保存设置',
		'Save the answers the team gives most often, and insert them from any ticket.': '保存团队最常用的回答，并可在任何工单中插入。',
		'Search key, subject or requester…': '搜索编号、主题或请求者…',
		'Search tickets…': '搜索工单…',
		'Select all': '全选',
		'Select {{key}}': '选择 {{key}}',
		'Service level': '服务等级',
		'Service levels': '服务等级',
		'Set assignee': '设置负责人',
		'Set priority': '设置优先级',
		'Set status': '设置状态',
		'Showing {{from}} to {{to}} of {{total}}': '显示第 {{from}} 至 {{to}} 条，共 {{total}} 条',
		'Shown as a hint when a customer picks it.': '客户选择时显示为提示。',
		'Something is not working as expected.': '某些功能未按预期工作。',
		'Status after sending': '发送后的状态',
		'Status changed to {{to}}': '状态更改为 {{to}}',
		'Status: automatic': '状态：自动',
		'Status: {{status}}': '状态：{{status}}',
		'Status…': '状态…',
		'Submit rating': '提交评分',
		'Submit ticket': '提交工单',
		'Support': '支持',
		'Support Desk': '支持台',
		'Support Desk — {{count}} unassigned': '支持台 — {{count}} 个未分配',
		'Support available': '可获得支持',
		'Support comes with an active license. The support page explains the situation for each product.': '支持服务随有效许可证提供。支持页面会说明每个产品的情况。',
		'Support for {{name}}': '{{name}} 的支持',
		'Support is not available for this product yet.': '此产品暂不提供支持。',
		'Support is not available yet': '暂不提供支持',
		'Support needs licensing turned on for the product, and a ticket prefix — the LOD in LOD-1042.': '支持需要为产品启用许可功能并设置工单前缀（即 LOD-1042 中的 LOD）。',
		'Support not available': '不提供支持',
		'Support role': '支持角色',
		'Support saved for {{name}}.': '已保存 {{name}} 的支持设置。',
		'Support settings saved.': '支持设置已保存。',
		'Targets in hours of wall-clock time from when the ticket was opened. The resolution clock pauses while a ticket waits on the customer. Leave blank for no target.': '从工单创建起按实际时间计算的小时目标。工单等待客户时解决计时暂停。留空表示无目标。',
		'Team email': '团队电子邮件',
		'Tell us what is going wrong. The more detail, the faster we can help.': '请告诉我们出了什么问题。描述越详细，我们越能快速帮助您。',
		'Thank you for your feedback.': '感谢您的反馈。',
		'The customer must already have an account.': '客户必须已有账户。',
		'The license server for this product did not answer. Please try again shortly.': '此产品的许可证服务器未响应，请稍后重试。',
		'The prefix must be 2–10 uppercase letters or digits.': '前缀必须是 2–10 个大写字母或数字。',
		'The product the ticket is filed against': '工单所针对的产品',
		'The requester\'s first name': '请求者的名字',
		'The requester\'s full name': '请求者的全名',
		'The ticket reference, e.g. LOD-1042': '工单编号，例如 LOD-1042',
		'This ticket is closed.': '此工单已关闭。',
		'This ticket is closed. If the problem is back, open a follow-up and we will pick it up from here.': '此工单已关闭。如果问题再次出现，请创建后续工单，我们会从这里继续处理。',
		'Ticket': '工单',
		'Ticket closed.': '工单已关闭。',
		'Ticket opened': '工单已创建',
		'Ticket prefix for {{name}}': '{{name}} 的工单前缀',
		'Ticket reopened.': '工单已重新打开。',
		'Ticket updated': '工单已更新',
		'Ticket updated.': '工单已更新。',
		'Ticket {{key}} opened.': '工单 {{key}} 已创建。',
		'Tickets': '工单',
		'Title': '标题',
		'Turn on licensing for this product first.': '请先为此产品启用许可功能。',
		'Unassigned': '未分配',
		'Updated {{count}} ticket(s).': '已更新 {{count}} 个工单。',
		'Urgent': '紧急',
		'Very dissatisfied': '非常不满意',
		'Very satisfied': '非常满意',
		'Views': '视图',
		'Waiting for support': '等待支持回复',
		'Waiting for you': '等待您回复',
		'What did you do, what did you expect, and what happened instead? Markdown is supported.': '您做了什么，预期是什么，实际发生了什么？ 支持 Markdown。',
		'When something is not working, open a ticket and the support team will get back to you.': '如果遇到问题，请创建工单，支持团队会与您联系。',
		'Write a note only the support team can see…': '撰写仅支持团队可见的备注…',
		'Write your reply…': '撰写回复…',
		'You do not hold a license for this product.': '您没有此产品的许可证。',
		'Your license for this product does not include support.': '您此产品的许可证不包含支持服务。',
		'Your license for this product has expired.': '您此产品的许可证已过期。',
		'Your name': '您的姓名',
		'Your tickets': '您的工单',
		'Your work is significantly impaired.': '您的工作受到严重影响。',
		'{{count}} selected': '已选择 {{count}} 个',
		'{{name}} filed this ticket using a seat of your license. You can follow it, but only they can reply.': '{{name}} 使用您许可证的席位提交了此工单。您可以查看，但只有提交者可以回复。',
		'{{time}} left': '剩余 {{time}}',
		'Columns': '列',
		'Reset columns': '重置列',
		'2FA': '双重验证',
		'Newsletter': '电子报',
		'Enabled': '已启用',
		'Disabled': '已禁用',
		'Opted out': '已退订',
		'Subscribed': '已订阅',
		'Local': '本地',
		'Review your active sessions to sign out elsewhere.': '查看活跃会话以在其他设备上退出登录。',
		'Sign out on this device. Your other devices stay signed in.': '在此设备上退出登录。您的其他设备仍保持登录状态。',
		'All {{count}} of your licenses for this product have expired.': '您此产品的全部 {{count}} 个许可证均已过期。',
		'No active licenses': '没有有效的许可证',
		'Show {{count}} expired': '显示 {{count}} 个已过期',
		'Add all': '全部添加',
		'Add one at a time': '逐个添加',
		'Add several at once': '批量添加',
		'Added {{count}}.': '已添加 {{count}} 个。',
		'Added {{count}}. Skipped: {{skipped}}.': '已添加 {{count}} 个。已跳过：{{skipped}}。',
		'Email addresses': '电子邮件地址',
		'Everyone on that list already has seats on this license.': '列表中的所有人都已在此许可证上拥有席位。',
		'None of those look like email addresses.': '其中没有可识别的电子邮件地址。',
		'Paste at least one email address.': '请至少粘贴一个电子邮件地址。',
		'Separate addresses with commas, spaces or new lines. People who already have seats are skipped.': '用逗号、空格或换行分隔地址。已拥有席位的人将被跳过。',
		'colleague@example.com, another@example.com': 'colleague@example.com, another@example.com',
		'seats each': '每人席位',
		'{{count}} already assigned': '{{count}} 个已分配',
		'{{count}} not a valid address': '{{count}} 个不是有效地址',
		'{{needed}} seat(s) needed for {{people}} people, but only {{available}} left.': '{{people}} 人需要 {{needed}} 个席位，但仅剩 {{available}} 个。',
		'Group {{number}}': '分组 {{number}}',
		'Link {{number}}': '链接 {{number}}',
		'Remove group': '移除分组',
		'Remove link': '移除链接',
		'Add group': '添加分组',
		'Download Groups': '下载分组',
		'Heading for builds the backend files under no group. Blank uses “Other”.': '后端未归入任何分组的构建所用的标题。留空则使用“其他”。',
		'Name for ungrouped builds': '未分组构建的名称',
		'Names the groups the licensing backend files builds under. Order here is the order they appear; an unmapped group still shows, under its raw identifier.': '为许可后端归类构建所用的分组命名。此处的顺序即显示顺序；未映射的分组仍会以其原始标识符显示。',
		'Other': '其他',
		'Get a License URL': '获取许可证的 URL',
		'Get a license': '获取许可证',
		'Get a license for {{name}}': '获取 {{name}} 的许可证',
		'Offered to users who hold no license for this product. Blank makes no offer.': '向没有此产品许可证的用户展示。留空则不展示。',
		'Add link': '添加链接',
		'Display Name': '显示名称',
		'Documentation': '文档',
		'Documentation Links': '文档链接',
		'Shown below the user\'s licenses for this product, and linked from its card on the dashboard.': '显示在该产品的用户许可证下方，并从仪表板卡片链接。',
		'What customers call this product. Used across the license pages; blank uses the application name.': '客户对该产品的称呼。用于所有许可证页面；留空则使用应用名称。',
		'{{count}} expired': '{{count}} 个已过期',
		'Download {{name}}': '下载 {{name}}',
		'Builds appear here once they are linked to an entitlement on one of your active licenses.': '当构建与您某个有效许可证的授权项关联后，即会显示在此处。',
		'It offers {{count}} download(s) for your account.': '它为您的账户提供 {{count}} 个下载。',
		'Link builds to the entitlements your licenses grant to make them downloadable.': '将构建与许可证授予的授权项关联，即可供下载。',
		'No downloads available': '没有可用的下载',
		'Download': '下载',
		'Downloads': '下载',
		'Failed to load downloads': '无法加载下载内容',
		'Failed to start the download': '无法开始下载',
		'Latest': '最新',
		'Add': '添加',
		'Add a seat': '增加一个席位',
		'Assign at least one seat.': '请至少分配一个席位。',
		'Assign seats to a colleague': '为同事分配席位',
		'Discard changes': '放弃更改',
		'Email address': '电子邮件地址',
		'Enter a valid email address.': '请输入有效的电子邮件地址。',
		'Every seat on this license is yours to use. Assign a block below to share it.': '此许可证的所有席位均归您使用。在下方分配一组席位即可共享。',
		'Give blocks of seats to colleagues. They activate their own machines against the seats you assign; removing a block takes the seats back.': '将成组席位分配给同事。他们使用所分配的席位激活自己的计算机；移除该组即收回这些席位。',
		'No seats left to assign. Reduce a block above first.': '没有可分配的席位。请先减少上方的某一组。',
		'Not yet saved': '尚未保存',
		'Only {{count}} seat(s) left to assign.': '仅剩 {{count}} 个席位可分配。',
		'Remove a seat': '减少一个席位',
		'Remove assignment': '移除分配',
		'Seat budget': '席位预算',
		'That person already has seats on this license.': '该用户已在此许可证上拥有席位。',
		'{{assigned}} of {{total}} assigned': '已分配 {{assigned}} / {{total}}',
		'{{count}} seat(s) left for your own machines.': '还剩 {{count}} 个席位供您自己的计算机使用。',
		'{{count}} seat(s) over the license total.': '超出许可证总数 {{count}} 个席位。',
		'{{used}} of {{seats}} in use': '{{seats}} 个中已使用 {{used}} 个',
		'It holds {{count}} license(s) for your account.': '它为您的账户持有 {{count}} 个许可证。',
		'The backend answered, but refused to list your licenses. Check that it shares the same JWT_KEY as Abstract ID.': '后端已响应，但拒绝列出您的许可证。请确认它与 Abstract ID 使用相同的 JWT_KEY。',
		'This application is inactive, so its licenses are hidden from users regardless of the settings below.': '该应用处于非活动状态，无论下面如何设置，其许可证都不会向用户显示。',
		'A backend URL is required to enable licensing.': '启用许可管理需要填写后端 URL。',
		'Adapter': '适配器',
		'Backend reachable': '后端可访问',
		'Failed to save licensing configuration': '无法保存许可配置',
		'Failed to test the licensing backend': '无法测试许可后端',
		'Licensing Backends': '许可后端',
		'Licensing saved for {{name}}.': '已保存 {{name}} 的许可配置。',
		'No licensing backends': '没有许可后端',
		'No sublicense entitlement is configured on the backend, so seats can never be re-assigned.': '后端未配置子许可授权项，因此永远无法重新分配席位。',
		'Products whose licenses users can see from their Abstract ID account. Abstract ID stores no license data — it reads each backend live, as the signed-in user.': '用户可在 Abstract ID 账户中查看其许可证的产品。Abstract ID 不存储许可证数据，而是以登录用户的身份实时读取各后端。',
		'Show all applications': '显示所有应用',
		'Test connection': '测试连接',
		'This backend serves a different application.': '该后端服务于另一个应用。',
		'Turn on "Show all applications" to point a product at its license server.': '打开“显示所有应用”即可将产品指向其许可服务器。',
		'Unsaved': '未保存',
		'Users would see an empty license list. Check the URL points at this product’s license server.': '用户将看到空的许可证列表。请确认该 URL 指向此产品的许可服务器。',
		'{{configured}} of {{total}} applications have a licensing backend.': '{{total}} 个应用中有 {{configured}} 个配置了许可后端。',
		'License Activation Revoked': '许可证激活已撤销',
		'Support Ticket Created': '已创建支持工单',
		'Support Ticket Updated': '已更新支持工单',
		'Support Settings Changed': '已更改支持设置',
		'License Seats Updated': '许可证席位已更新',
		'API base including the version prefix, e.g. https://license.example.com/api/v1': '包含版本前缀的 API 基础地址，例如 https://license.example.com/api/v1',
		'Activated': '激活时间',
		'All seats on this license are yours to use.': '此许可证的所有席位均可由您自己使用。',
		'Allow seat re-assignment': '允许重新分配席位',
		'Assign seats': '分配席位',
		'Assigned seat': '已分配席位',
		'Assigned seats ({{assigned}}) exceed the license total ({{total}}).': '已分配席位（{{assigned}}）超出许可证总数（{{total}}）。',
		'Back to licenses': '返回许可证列表',
		'Backend URL': '后端 URL',
		'Discard': '放弃',
		'Entitlements': '授权项',
		'Every assignment needs an email address.': '每项分配都需要一个电子邮件地址。',
		'Expired': '已过期',
		'Expires': '到期时间',
		'Failed to load activations': '无法加载激活记录',
		'Failed to load license': '无法加载许可证',
		'Failed to load licenses': '无法加载许可证',
		'Failed to release seats': '无法释放席位',
		'Failed to save seat assignments': '无法保存席位分配',
		'Give blocks of seats to colleagues. They activate their own machines against the seats you assign; removing an assignment takes the seats back.': '将成组席位分配给同事。他们使用所分配的席位激活自己的计算机；移除分配即收回这些席位。',
		'Lets users see this product\'s licenses and activations from their Abstract ID account. Abstract ID stores no license data — it reads the backend live, as the signed-in user.': '让用户在 Abstract ID 账户中查看此产品的许可证与激活情况。Abstract ID 不存储任何许可证数据，而是以登录用户的身份实时读取后端。',
		'License': '许可证',
		'Licenses': '许可证',
		'Licenses issued to you across Abstract products, and the machines using them.': '您在各 Abstract 产品中持有的许可证，以及正在使用它们的计算机。',
		'Builds available to you for each Abstract product you are licensed for.': '您已获授权的每个 Abstract 产品可供下载的构建版本。',
		'Guides and references for each Abstract product.': '各 Abstract 产品的指南与参考资料。',
		'No documentation': '暂无文档',
		'This product publishes no documentation yet.': '该产品尚未发布任何文档。',
		'Licensing': '许可管理',
		'Licensing Backend': '许可后端',
		'Machine': '计算机',
		'Machines': '计算机',
		'Machines currently using a seat of this license.': '当前占用此许可证席位的计算机。',
		'My Licenses': '我的许可证',
		'No licensed products': '没有授权产品',
		'No licenses': '没有许可证',
		'No machine has activated this license yet.': '尚无计算机激活此许可证。',
		'No machines': '没有计算机',
		'No seats assigned': '未分配席位',
		'None of the products you have access to manage licenses through Abstract ID.': '您可访问的产品均未通过 Abstract ID 管理许可证。',
		'Release {{count}} seat(s)': '释放 {{count}} 个席位',
		'Released': '已释放',
		'Released {{count}} seat(s).': '已释放 {{count}} 个席位。',
		'Renews': '续订',
		'Save assignments': '保存分配',
		'Seat assignments': '席位分配',
		'Seat assignments saved.': '席位分配已保存。',
		'Seats': '席位',
		'Select': '选择',
		'Select {{machine}}': '选择 {{machine}}',
		'The backend still decides per license whether its owner may delegate seats; this only hides the controls for the whole product.': '后端仍按许可证决定其持有者是否可分配席位；此开关仅为整个产品隐藏相关控件。',
		'Valid': '有效期',
		'You have no licenses for this product yet.': '您还没有此产品的许可证。',
		'Your Licenses': '您的许可证',
		'colleague@example.com': 'colleague@example.com',
		'{{assigned}} of {{total}} seats assigned': '已分配 {{assigned}} / {{total}} 个席位',
		'{{count}} active': '{{count}} 个有效',
		'{{count}} free': '剩余 {{count}} 个',
		'{{count}} license(s)': '{{count}} 个许可证',
		'Collapse sidebar': '折叠侧边栏',
		'Expand sidebar': '展开侧边栏',
		'Something went wrong': '出错了',
		'Switch to dark mode': '切换到深色模式',
		'Switch to light mode': '切换到浅色模式',
		'Allow pop-ups for this site to sign in with Microsoft.': '请允许本站弹出窗口以使用 Microsoft 登录。',
		'and access the following': '并访问以下内容',
		'and access your profile information': '并访问您的个人资料信息',
		'2FA Disabled': '2FA 已禁用',
		'2FA Enabled': '2FA 已启用',
		'2FA Not Set': '2FA 未设置',
		'2FA QR Code': '2FA 二维码',
		'2FA is enabled': '2FA 已启用',
		'2FA is not enabled': '2FA 未启用',
		'6-digit code': '6位验证码',
		'A short bio or description...': '简短的个人简介或描述...',
		'About': '关于',
		'Access Granted': '已授予访问权限',
		'Access Key ID': 'Access Key ID',
		'Account': '账户',
		'Account Status': '账户状态',
		'Action': '操作',
		'Action Types': '操作类型',
		'Action URL (optional)': '操作 URL（可选）',
		'Actions': '操作',
		'Activation Email': '激活邮件',
		'Active': '活跃',
		'Active Sessions': '活跃会话',
		'Add Link': '添加链接',
		'Add a passkey to sign in without a password.': '添加通行密钥，无需密码即可登录。',
		'Add an extra layer of security using a TOTP authenticator app.': '使用 TOTP 身份验证器应用添加额外的安全层。',
		'Add external links that appear in the application sidebar for all users. Upload an icon image (128×128 PNG) and set the order to control placement alongside registered applications.': '添加在应用侧边栏中对所有用户显示的外部链接。上传图标图片（128×128 PNG）并设置排序以控制在已注册应用旁的位置。',
		'Add passkey': '添加通行密钥',
		'Added': '已添加',
		'Admin': '管理',
		'Admin Notes': '管理员备注',
		'Administration': '管理',
		'Administrator': '管理员',
		'Administrators': '管理员',
		'Admins': '管理员',
		'All Actions': '所有操作',
		'All Roles': '所有角色',
		'All Statuses': '所有状态',
		'All Users (active + imported)': '所有用户（活跃 + 导入）',
		'All apps': '所有应用',
		'All auth types': '所有认证类型',
		'All caught up!': '全部已读！',
		'All rights reserved.': '保留所有权利。',
		'All sessions revoked.': '已撤销所有会话。',
		'All statuses': '所有状态',
		'All users (active + imported)': '所有用户（活跃 + 导入）',
		'Allow Duplicate Emails': '允许重复邮箱',
		'Allowed redirect domains for authorization. One URL per line.': '授权允许的重定向域名。每行一个 URL。',
		'Already exist': '已存在',
		'Already exist (skipped):': '已存在（已跳过）：',
		'Already have an account?': '已有账户？',
		'Always Visible': '始终可见',
		'Amount': '金额',
		'Amt': '金额',
		'Analytics': '分析',
		'Apple Key ID': 'Apple 密钥 ID',
		'Apple Private Key (.p8)': 'Apple 私钥 (.p8)',
		'Apple Services ID': 'Apple Services ID',
		'Apple sign-in failed. Please try again.': 'Apple 登录失败，请重试。',
		'Apple sign-up failed. Please try again.': 'Apple 注册失败，请重试。',
		'Apple Team ID': 'Apple 团队 ID',
		'Application': '应用',
		'Application (client) ID': '应用程序(客户端) ID',
		'Application Created': '应用已创建',
		'Application Deleted': '应用已删除',
		'Application Name': '应用名称',
		'Application Updated': '应用已更新',
		'Application Usage': '应用使用情况',
		'Application name is required.': '应用名称为必填项。',
		'Application not found or is no longer active.': '未找到应用或应用已停用。',
		'Application updated successfully.': '应用更新成功。',
		'Applications': '应用',
		'Applications:': '应用：',
		'Apply Crop': '应用裁剪',
		'Apps you’re registered with': '您已注册的应用',
		'Are you sure?': '确定吗？',
		'Assign CSV columns to user fields. <strong>Email</strong> is required.': '将 CSV 列映射到用户字段。<strong>邮箱</strong>为必填项。',
		'At least 8 characters': '至少8个字符',
		'Audience': '受众',
		'Audience:': '受众：',
		'Audit Entries': '审计条目',
		'Audit Logs': '审计日志',
		'Audit Trail': '审计追踪',
		'Auth Provider': '认证提供者',
		'Authentication': '身份验证',
		'Authorization Successful': '授权成功',
		'Authorization URLs': '授权 URL',
		'Authorization failed. Please try again.': '授权失败，请重试。',
		'Authorize': '授权',
		'Authorized': '已授权',
		'Auto-Approve': '自动批准',
		'Auto-Approve Users': '自动批准用户',
		'Auto-approve': '自动批准',
		'Available Tokens': '可用令牌',
		'Available placeholders:': '可用占位符：',
		'Avatar removed.': '头像已移除。',
		'Avatar uploaded.': '头像已上传。',
		'Avg. interval per email': '每封邮件平均间隔',
		'Awaiting Approval': '等待审批',
		'Already Authorized': '已授权',
		'Back': '返回',
		'Back to Applications': '返回应用列表',
		'Back to Newsletters': '返回邮件通讯列表',
		'Back to Users': '返回用户列表',
		'Back to inline preview': '返回内联预览',
		'Back to sign in': '返回登录',
		'Backup Codes': '备用码',
		'Backup code': '备用码',
		'Bal': '余额',
		'Balance': '余额',
		'Base URL for accessing files publicly. If empty, uses the default path.': '公开访问文件的基础 URL。留空则使用默认路径。',
		'Basic Information': '基本信息',
		'Batch Configuration & Timing': '批次配置与时间',
		'Bio or description...': '简介或描述...',
		'Blacklisted IPs': 'IP 黑名单',
		'Body:': '正文：',
		'Bonus': '奖励',
		'Bounced Recipients Excluded': '已排除退信收件人',
		'Bounced users excluded': '已排除退信用户',
		'Branding text and links shown on the login and registration pages.': '登录和注册页面上显示的品牌文字和链接。',
		'Brief description (optional)': '简要描述（可选）',
		'Brief description of the application...': '应用的简要描述...',
		'Brief description...': '简要描述...',
		'Bucket Name': 'Bucket Name',
		'CIDR notation, comma-separated.': 'CIDR 格式，逗号分隔。',
		'Cache TTL (seconds)': '缓存 TTL（秒）',
		'Campaign Details': '活动详情',
		'Campaign Name': '活动名称',
		'Cancel': '取消',
		'Cancelled': '已取消',
		'Category': '分类',
		'Category IDs': '分类 ID',
		'Change Password': '修改密码',
		'Changing...': '修改中...',
		'Check your email': '请查收邮件',
		'Checking for existing users…': '正在检查现有用户…',
		'Choose a new password.': '请设置新密码。',
		'City, Country': '城市，国家',
		'Clear': '清除',
		'Click Rate': '点击率',
		'Click the link in the email to verify your account. If you don\'t see it, check your spam folder.': '点击邮件中的链接验证您的账户。如未收到，请检查垃圾邮件文件夹。',
		'Clicks': '点击',
		'Client Secret': '客户端密码',
		'Close': '关闭',
		'Close Preview': '关闭预览',
		'Comma-separated IPs or CIDRs': '逗号分隔的 IP 或 CIDR',
		'Comma-separated WordPress category IDs. Leave empty to show all categories.': '逗号分隔的 WordPress 分类 ID。留空显示所有分类。',
		'Comma-separated. Evaluated after whitelist.': '逗号分隔。在白名单之后评估。',
		'Common ports: 587 (STARTTLS), 465 (TLS), 25 (plain).': '常用端口：587 (STARTTLS)、465 (TLS)、25（明文）。',
		'Company': '公司',
		'Company name': '公司名称',
		'Completing sign-in…': '正在完成登录…',
		'Configure a Services ID and signing key to show the "Sign in with Apple" button on the login page.': '配置 Services ID 和签名密钥以在登录页面显示“使用 Apple 登录”按钮。',
		'Configure an Entra ID app registration to show the "Sign in with Microsoft" button on the login page.': '配置 Entra ID 应用注册以在登录页面显示“使用 Microsoft 登录”按钮。',
		'Configure Google OAuth 2.0 to show the "Sign in with Google" button on the login page.': '配置 Google OAuth 2.0 以在登录页面显示"使用 Google 登录"按钮。',
		'Configure an S3-compatible storage backend for file uploads (AWS S3, MinIO, DigitalOcean Spaces, etc.).': '配置兼容 S3 的存储后端用于文件上传（AWS S3、MinIO、DigitalOcean Spaces 等）。',
		'Confirm': '确认',
		'Confirm Disable': '确认禁用',
		'Confirm Import': '确认导入',
		'Confirm Password': '确认密码',
		'Confirm new password': '确认新密码',
		'Confirm password': '确认密码',
		'Contact Details': '联系方式',
		'Content': '内容',
		'Continue': '继续',
		'Continue to': '继续前往',
		'Continue to Dashboard': '继续前往仪表盘',
		'Continue with Apple': '使用 Apple 继续',
		'Continue with Google': '使用 Google 继续',
		'Continue with Microsoft': '使用 Microsoft 继续',
		'Copied to clipboard': '已复制到剪贴板',
		'Copy the token below and paste it into': '复制下方的令牌并粘贴到',
		'Copy to Clipboard': '复制到剪贴板',
		'Could not detect a WordPress REST API at this URL.': '无法在此 URL 检测到 WordPress REST API。',
		'Count': '数量',
		'Create Application': '创建应用',
		'Create Newsletter': '创建邮件通讯',
		'Create Password': '创建密码',
		'Create Role': '创建角色',
		'Create Template': '创建模板',
		'Create User': '创建用户',
		'Create a Password': '创建密码',
		'Create account': '创建账户',
		'Create an account': '创建账户',
		'Create credentials at': '在此创建凭据',
		'Create, manage and send newsletter campaigns.': '创建、管理和发送邮件通讯活动。',
		'Created': '创建时间',
		'Creating...': '创建中...',
		'Credentials & Preview': '凭据与预览',
		'Credit': '充值',
		'Crop Profile Picture': '裁剪头像',
		'Current': '当前',
		'Current Balance': '当前余额',
		'Current Password': '当前密码',
		'Current:': '当前：',
		'Custom Sidebar Links': '自定义侧边栏链接',
		'Dark': '深色',
		'Dark Mode': '深色模式',
		'Dashboard': '仪表盘',
		'Database': '数据库',
		'Date': '日期',
		'Debit': '扣款',
		'Default Email Master Template': '默认邮件主模板',
		'Define access roles': '定义访问角色',
		'Define access roles and assign them to users or applications.': '定义访问角色并分配给用户或应用。',
		'Delete': '删除',
		'Delivery': '发送',
		'Deny': '拒绝',
		'Description': '描述',
		'Description (optional)': '描述（可选）',
		'Details': '详情',
		'Detect': '检测',
		'Detecting...': '检测中...',
		'Devices and browsers where you\'re currently signed in.': '您当前已登录的设备和浏览器。',
		'Didn\'t receive the email?': '没有收到邮件？',
		'Directory (tenant) ID': '目录(租户) ID',
		'Disable 2FA': '禁用 2FA',
		'Dismiss': '忽略',
		'Display a WordPress news feed on the non-admin user dashboard.': '在非管理员用户仪表盘上显示 WordPress 新闻源。',
		'Display name for the website link on auth pages.': '认证页面上网站链接的显示名称。',
		'Display name next to the sender address.': '在发件人地址旁显示的名称。',
		'Doe': 'Doe',
		'Done': '完成',
		'Draft': '草稿',
		'Edit': '编辑',
		'Edit Application': '编辑应用',
		'Edit Newsletter': '编辑邮件通讯',
		'Edit Role': '编辑角色',
		'Edit Template': '编辑模板',
		'Edit User': '编辑用户',
		'Edit your account details': '编辑您的账户详情',
		'Eligible users': '符合条件的用户',
		'Email': '邮箱',
		'Email OTP Requested': '已请求邮箱 OTP',
		'Email Template Preview': '邮件模板预览',
		'Email Templates': '邮件模板',
		'Email Unverified': '邮箱未验证',
		'Email Verified': '邮箱已验证',
		'Email address and verification status': '邮箱地址和验证状态',
		'Email address updated successfully.': '邮箱地址更新成功。',
		'Email is required.': '邮箱为必填项。',
		'Email subject line...': '邮件主题...',
		'Emails Sent': '已发送邮件',
		'Emails Sent This Year': '本年已发送邮件',
		'Emails This Month': '本月邮件',
		'Emails This Week': '本周邮件',
		'Emails per batch': '每批邮件数',
		'Enable 2FA': '启用 2FA',
		'Enable News Feed': '启用新闻源',
		'Enable for port 465. For 587 with STARTTLS leave this off.': '端口 465 时启用。使用 587 端口的 STARTTLS 时请关闭此选项。',
		'Endpoint URL': 'Endpoint URL',
		'Enter a TOTP code or backup code to disable two-factor authentication.': '输入 TOTP 验证码或备用码以禁用两步验证。',
		'Enter a domain or URL — click': '输入域名或 URL — 点击',
		'Enter it below.': '请在下方输入。',
		'Enter one of your backup codes. Each code can only be used once.': '输入您的备用码之一。每个备用码仅可使用一次。',
		'Enter reset code': '输入重置码',
		'Enter the 6-digit code from your authenticator to complete setup:': '输入身份验证器中的6位验证码以完成设置：',
		'Enter the 6-digit code from your email:': '输入邮件中的6位验证码：',
		'Enter the 6-digit code sent to': '输入发送至以下地址的6位验证码',
		'Enter the code from your authenticator app.': '输入身份验证器应用中的验证码。',
		'Enter the code sent to your email.': '输入发送到您邮箱的验证码。',
		'Enter the email address to send a test message to.': '输入用于发送测试邮件的邮箱地址。',
		'Enter your email and we\'ll send you a reset code.': '输入您的邮箱，我们将发送重置码。',
		'Enter your email to get started.': '输入您的邮箱以开始。',
		'Environment': '环境',
		'Error': '错误',
		'Estimated duration': '预计时长',
		'Failed': '失败',
		'Failed to cancel newsletter': '取消邮件通讯失败',
		'Failed to change password': '修改密码失败',
		'Failed to create application': '创建应用失败',
		'Failed to create user': '创建用户失败',
		'Failed to delete application': '删除应用失败',
		'Failed to delete avatar': '删除头像失败',
		'Failed to delete icon': '删除图标失败',
		'Failed to delete logo': '删除 Logo 失败',
		'Failed to delete newsletter': '删除邮件通讯失败',
		'Failed to delete notification': '删除通知失败',
		'Failed to delete passkey': '删除通行密钥失败',
		'Failed to delete role': '删除角色失败',
		'Failed to delete template': '删除模板失败',
		'Failed to disable 2FA': '禁用 2FA 失败',
		'Failed to load admin statistics': '加载管理员统计数据失败',
		'Failed to load analytics': '加载分析数据失败',
		'Failed to load application': '加载应用失败',
		'Failed to load applications': '加载应用列表失败',
		'Failed to load audit logs': '加载审计日志失败',
		'Failed to load data': '加载数据失败',
		'Failed to load image.': '加载图片失败。',
		'Failed to load newsletters': '加载邮件通讯失败',
		'Failed to load notifications': '加载通知失败',
		'Failed to load passkeys': '加载通行密钥失败',
		'Failed to load preview': '加载预览失败',
		'Failed to load preview.': '加载预览失败。',
		'Failed to load profile': '加载个人资料失败',
		'Failed to load profile.': '加载个人资料失败。',
		'Failed to load roles': '加载角色失败',
		'Failed to load server preview': '加载服务器预览失败',
		'Failed to load sessions': '加载会话失败',
		'Failed to load settings': '加载设置失败',
		'Failed to load staging data.': '加载暂存数据失败。',
		'Failed to load templates': '加载模板失败',
		'Failed to load transactions': '加载交易记录失败',
		'Failed to load user': '加载用户失败',
		'Failed to mark all as read': '全部标记为已读失败',
		'Failed to mark as read': '标记为已读失败',
		'Failed to pause newsletter': '暂停邮件通讯失败',
		'Failed to record transaction': '记录交易失败',
		'Failed to register passkey': '注册通行密钥失败',
		'Failed to rename passkey': '重命名通行密钥失败',
		'Failed to resend.': '重新发送失败。',
		'Failed to reset password. Please try again.': '重置密码失败，请重试。',
		'Failed to resume newsletter': '恢复邮件通讯失败',
		'Failed to revoke session': '撤销会话失败',
		'Failed to revoke sessions': '撤销会话失败',
		'Failed to revoke sessions.': '撤销会话失败。',
		'Failed to save SMTP settings': '保存 SMTP 设置失败',
		'Failed to save newsletter': '保存邮件通讯失败',
		'Failed to save profile': '保存个人资料失败',
		'Failed to save role': '保存角色失败',
		'Failed to save security settings': '保存安全设置失败',
		'Failed to save settings': '保存设置失败',
		'Failed to save template': '保存模板失败',
		'Failed to send code. Please try again.': '发送验证码失败，请重试。',
		'Failed to send newsletter.': '发送邮件通讯失败。',
		'Failed to send notification': '发送通知失败',
		'Failed to send reset email. Please try again.': '发送重置邮件失败，请重试。',
		'Failed to send test email': '发送测试邮件失败',
		'Failed to send test email.': '发送测试邮件失败。',
		'Failed to send verification code': '发送验证码失败',
		'Failed to start 2FA setup': '启动 2FA 设置失败',
		'Failed to update application': '更新应用失败',
		'Failed to update user': '更新用户失败',
		'Failed to upload avatar': '上传头像失败',
		'Failed to upload icon': '上传图标失败',
		'Failed to upload logo': '上传 Logo 失败',
		'Feed URL': 'Feed URL',
		'Filtered by Application': '按应用筛选',
		'Filtered by application': '按应用筛选',
		'Filters': '筛选',
		'First Name': '名',
		'First name': '名',
		'First name is required.': '名为必填项。',
		'Follow Abstract on Twitter': '在 Twitter 上关注 Abstract',
		'Forgot Password': '忘记密码',
		'Forgot password?': '忘记密码？',
		'Found in the top-right of the Apple Developer portal.': '可在 Apple Developer 门户右上角找到。',
		'Framework': '框架',
		'From Email': '发件人邮箱',
		'From Name': '发件人名称',
		'General': '常规',
		'General Settings': '常规设置',
		'Get started in seconds — it\'s free.': '几秒即可开始 — 完全免费。',
		'Give your passkey a name to identify it later (e.g. "MacBook Touch ID").': '为您的通行密钥命名以便日后识别（例如"MacBook Touch ID"）。',
		'Global': '全局',
		'Global only': '仅全局',
		'Go to Dashboard': '前往仪表盘',
		'Go to sign in': '前往登录',
		'Good afternoon': '下午好',
		'Good evening': '晚上好',
		'Good morning': '早上好',
		'Google Client ID': 'Google Client ID',
		'Google Client Secret': 'Google Client Secret',
		'Google Sign-In': 'Google 登录',
		'Google sign-in failed. Please try again.': 'Google 登录失败，请重试。',
		'Google sign-up failed. Please try again.': 'Google 注册失败，请重试。',
		'HTML Content': 'HTML 内容',
		'Has password': '已设置密码',
		'Hello Jane!...': 'Hello Jane!...',
		'Hide password': '隐藏密码',
		'How long to cache feed results server-side. Default: 900 (15 minutes).': '服务端缓存新闻源结果的时长。默认：900（15分钟）。',
		'I\'ve saved my codes': '我已保存备用码',
		'ID': 'ID',
		'Identifier of the .p8 key enabled for Sign in with Apple.': '已启用“使用 Apple 登录”的 .p8 密钥的标识符。',
		'IP Access Control': 'IP 访问控制',
		'IP Address': 'IP 地址',
		'IP Restrictions': 'IP 限制',
		'Icon (Font Awesome class)': '图标（Font Awesome 类名）',
		'Icon Image': '图标图片',
		'Icon removed.': '图标已移除。',
		'Icon uploaded.': '图标已上传。',
		'Identity, simplified.': '身份管理，化繁为简。',
		'Import': '导入',
		'Import Users': '导入用户',
		'Import failed': '导入失败',
		'Imported': '已导入',
		'Imported users will be created as dormant accounts (authProvider = \'imported\'). They can receive newsletters and log in via email OTP without needing to register separately.': '导入的用户将创建为休眠账户（authProvider = \'imported\'）。他们可以接收邮件通讯并通过邮箱 OTP 登录，无需单独注册。',
		'Importing…': '导入中…',
		'Inactive': '未激活',
		'Increase security by creating a password for your account.': '为您的账户创建密码以增强安全性。',
		'Info': '信息',
		'Inline newsletter preview': '内联邮件通讯预览',
		'Insert token:': '插入令牌：',
		'Internal notes (only visible to admins)...': '内部备注（仅管理员可见）...',
		'Interval between batches': '批次间隔',
		'Invalid': '无效',
		'Invalid (skipped):': '无效（已跳过）：',
		'Invalid application ID.': '无效的应用 ID。',
		'Invalid code. Please try again.': '验证码无效，请重试。',
		'Invalid newsletter ID.': '无效的邮件通讯 ID。',
		'Invalid or expired code': '验证码无效或已过期',
		'Invalid or expired code.': '验证码无效或已过期。',
		'Invalid user ID.': '无效的用户 ID。',
		'John': 'John',
		'Join Abstract on Discord': '在 Discord 上加入 Abstract',
		'Joined': '加入时间',
		'Label': '标签',
		'Language': '语言',
		'Large heading on the auth page branding panel.': '认证页面品牌面板上的大标题。',
		'Last Login': '最后登录',
		'Last Name': '姓',
		'Last login:': '最后登录：',
		'Last name': '姓',
		'Last name is required.': '姓为必填项。',
		'Last used': '最后使用',
		'Latest News': '最新消息',
		'Leave all fields empty to use local disk storage.': '留空所有字段以使用本地磁盘存储。',
		'Leave as "None" for a global role that applies across all applications.': '选择"无"以创建适用于所有应用的全局角色。',
		'Leave empty for unlimited.': '留空表示无限制。',
		'Leave empty to accept any Microsoft account. Set a directory ID to restrict sign-in to one organisation.': '留空则接受任何 Microsoft 账号。填写目录 ID 可将登录限制在一个组织内。',
		'Leave empty to auto-generate the plain-text part from the HTML body.': '留空则根据 HTML 正文自动生成纯文本部分。',
		'Leave empty to disable Google Sign-In.': '留空以禁用 Google 登录。',
		'Leave empty to disable Sign in with Apple.': '留空以禁用 Apple 登录。',
		'Leave empty to disable Sign in with Microsoft.': '留空以禁用 Microsoft 登录。',
		'Light': '浅色',
		'Link icon': '链接图标',
		'Linked from login/register pages and emails.': '在登录/注册页面和邮件中链接。',
		'Linked on login and registration pages.': '在登录和注册页面上链接。',
		'Live Preview': '实时预览',
		'Loading audit logs…': '正在加载审计日志…',
		'Loading notifications...': '正在加载通知...',
		'Loading notifications…': '正在加载通知…',
		'Loading roles...': '正在加载角色...',
		'Loading…': '加载中…',
		'Location': '位置',
		'Login Heading': '登录标题',
		'Login Subheading': '登录副标题',
		'Login failed. Please try again.': '登录失败，请重试。',
		'Logins (24h)': '登录次数（24小时）',
		'Logo Image': 'Logo 图片',
		'Logo removed.': 'Logo 已移除。',
		'Logo uploaded.': 'Logo 已上传。',
		'Manage Users': '管理用户',
		'Manage active sessions': '管理活跃会话',
		'Manage passkey credentials': '管理通行密钥凭据',
		'Manage user accounts and permissions': '管理用户账户和权限',
		'Map Columns': '映射列',
		'Mark all as read': '全部标记为已读',
		'Mark as read': '标记为已读',
		'Master Template': '主模板',
		'Master Template:': '主模板：',
		'Max Forgot-Password Requests': '最大忘记密码请求次数',
		'Max Reset-Password Attempts': '最大重置密码尝试次数',
		'Media': '媒体',
		'Message (optional)': '消息（可选）',
		'Microsoft sign-in failed. Please try again.': 'Microsoft 登录失败，请重试。',
		'Microsoft sign-up failed. Please try again.': 'Microsoft 注册失败，请重试。',
		'Migration Contact Email': '迁移联系邮箱',
		'Must be 3–30 characters (letters, numbers, underscores).': '须为3–30个字符（字母、数字、下划线）。',
		'Must be at least 8 characters.': '须至少8个字符。',
		'Must match a Return URL registered on the Services ID exactly.': '必须与 Services ID 中注册的返回 URL 完全一致。',
		'My Application': '我的应用',
		'My Applications': '我的应用',
		'My Apps': '我的应用',
		'My Passkey': '我的通行密钥',
		'My Profile': '我的资料',
		'Name': '名称',
		'Name your passkey': '为通行密钥命名',
		'Name, username, and avatar': '姓名、用户名和头像',
		'Never': '从未',
		'Never used': '从未使用',
		'New Application': '新建应用',
		'New Newsletter': '新建邮件通讯',
		'New Password': '新密码',
		'New Role': '新建角色',
		'New Template': '新建模板',
		'New email address': '新邮箱地址',
		'New password': '新密码',
		'New password is required.': '新密码为必填项。',
		'New passwords do not match.': '两次输入的新密码不一致。',
		'New username': '新用户名',
		'New users': '新用户',
		'New users to import:': '待导入的新用户：',
		'News Feed': '新闻源',
		'Newsletter Cancelled': '邮件通讯已取消',
		'Newsletter Created': '邮件通讯已创建',
		'Newsletter Deleted': '邮件通讯已删除',
		'Newsletter Paused': '邮件通讯已暂停',
		'Newsletter Preview': '邮件通讯预览',
		'Newsletter Resumed': '邮件通讯已恢复',
		'Newsletter Sent': '邮件通讯已发送',
		'Newsletter Started': '邮件通讯已开始',
		'Newsletter Updated': '邮件通讯已更新',
		'Newsletter cancelled.': '邮件通讯已取消。',
		'Newsletter created.': '邮件通讯已创建。',
		'Newsletter default': '邮件通讯默认',
		'Newsletter deleted.': '邮件通讯已删除。',
		'Newsletter dispatch started.': '邮件通讯已开始发送。',
		'Newsletter paused.': '邮件通讯已暂停。',
		'Newsletter preview': '邮件通讯预览',
		'Newsletter resumed.': '邮件通讯已恢复。',
		'Newsletter updated.': '邮件通讯已更新。',
		'Newsletters': '邮件通讯',
		'Next': '下一步',
		'No Backend Response': '无后端响应',
		'No Recipients': '无收件人',
		'No active sessions.': '无活跃会话。',
		'No application registrations yet.': '尚无应用注册。',
		'No applications configured.': '尚未配置应用。',
		'No applications found.': '未找到应用。',
		'No applications match your filters': '无应用匹配您的筛选条件',
		'No applications registered yet': '尚未注册应用',
		'No applications registered.': '尚未注册应用。',
		'No audit logs found.': '未找到审计日志。',
		'No email templates yet': '尚无邮件模板',
		'No master template': '无主模板',
		'No new users to import. All valid email addresses already exist in the system.': '无新用户可导入。所有有效邮箱地址已存在于系统中。',
		'No newsletters found.': '未找到邮件通讯。',
		'No notifications yet.': '暂无通知。',
		'No passkeys registered yet.': '尚未注册通行密钥。',
		'No password — signs in via email OTP': '无密码 — 通过邮箱 OTP 登录',
		'No recipients match the audience criteria. Adjust the audience settings before sending.': '无收件人符合受众条件。请在发送前调整受众设置。',
		'No roles defined yet': '尚未定义角色',
		'No roles defined yet.': '尚未定义角色。',
		'No roles match your filters': '无角色匹配您的筛选条件',
		'No settings found.': '未找到设置。',
		'No settings found. Save defaults to create the settings row.': '未找到设置。保存默认值以创建设置记录。',
		'No subject yet': '尚无主题',
		'No templates match your filters': '无模板匹配您的筛选条件',
		'No transactions yet.': '暂无交易记录。',
		'No users found': '未找到用户',
		'No users match your filters': '无用户匹配您的筛选条件',
		'No, cancel': '取消',
		'Non-Registered Redirect URL': '未注册重定向 URL',
		'None': '无',
		'None (Global)': '无（全局）',
		'Not configured': '未配置',
		'Nothing here yet': '暂无内容',
		'Notifications': '通知',
		'OAuth': 'OAuth',
		'Open Rate': '打开率',
		'Open your authenticator app and enter the 6-digit code.': '打开身份验证器应用并输入6位验证码。',
		'Opens': '打开',
		'Opt out of newsletters': '退订邮件通讯',
		'Opted-out users excluded': '已排除退订用户',
		'Optionally register imported users to one or more applications. This step is optional — you can skip it to import users without application registrations.': '可选择将导入的用户注册到一个或多个应用。此步骤为可选 — 您可以跳过以直接导入用户而不进行应用注册。',
		'Or enter manually:': '或手动输入：',
		'Order': '排序',
		'Overview': '概览',
		'Page Not Found': '页面未找到',
		'Paragraph text below the heading.': '标题下方的段落文字。',
		'Passkey deleted.': '通行密钥已删除。',
		'Passkey registered successfully!': '通行密钥注册成功！',
		'Passkey renamed.': '通行密钥已重命名。',
		'Passkey sign-in failed. Please try again.': '通行密钥登录失败，请重试。',
		'Passkeys': '通行密钥',
		'Password': '密码',
		'Password Changed': '密码已更改',
		'Password Reset Completed': '密码重置完成',
		'Password Reset Requested': '已请求密码重置',
		'Password changed successfully.': '密码修改成功。',
		'Password created successfully.': '密码创建成功。',
		'Password is required.': '密码为必填项。',
		'Password must be at least 6 characters.': '密码须至少6个字符。',
		'Password must be at least 8 characters.': '密码须至少8个字符。',
		'Passwordless': '免密码',
		'Passwords do not match.': '两次输入的密码不一致。',
		'Paste the full contents of the .p8 file downloaded from Apple.': '粘贴从 Apple 下载的 .p8 文件的完整内容。',
		'Pause': '暂停',
		'Paused': '已暂停',
		'Pending': '待处理',
		'Performed By': '执行者',
		'Personal Information': '个人信息',
		'Plain text version...': '纯文本版本...',
		'Plain-Text Fallback (optional)': '纯文本备用（可选）',
		'Platform configuration': '平台配置',
		'Please enter a backup code.': '请输入备用码。',
		'Please enter a new password.': '请输入新密码。',
		'Please enter a valid code to disable 2FA.': '请输入有效的验证码以禁用 2FA。',
		'Please enter a valid email address.': '请输入有效的邮箱地址。',
		'Please enter a valid, available username.': '请输入有效且可用的用户名。',
		'Please enter the 6-digit verification code.': '请输入6位验证码。',
		'Please enter your current password.': '请输入您的当前密码。',
		'Please wait while we verify your account.': '正在验证您的账户，请稍候。',
		'Policies': '政策',
		'Preferences': '偏好设置',
		'Prev': '上一步',
		'Preview': '预览',
		'Preview (first 5 rows)': '预览（前5行）',
		'Preview Consent': '预览授权',
		'Preview Token Flow': '预览令牌流程',
		'Previous': '上一页',
		'Private Key': '私钥',
		'Profile': '个人资料',
		'Profile Picture': '头像',
		'Profile updated successfully.': '个人资料更新成功。',
		'Public Content': '公开内容',
		'Public URL (optional)': '公开 URL（可选）',
		'Purchase': '购买',
		'Quick Actions': '快捷操作',
		'Rate Limiting': '速率限制',
		'Re-enter your new password': '再次输入新密码',
		'Re-enter your password': '再次输入密码',
		'Reason': '原因',
		'Recent Activity': '最近活动',
		'Recent Notifications': '最近通知',
		'Recipient Breakdown': '收件人明细',
		'Recipient Email': '收件人邮箱',
		'Recipients': '收件人',
		'Record': '记录',
		'Record Transaction': '记录交易',
		'Redirect URI': '重定向 URI',
		'Refresh': '刷新',
		'Refresh Stats': '刷新统计',
		'Refund': '退款',
		'Region': '区域',
		'Register again': '重新注册',
		'Register and manage applications that use this identity provider.': '注册和管理使用此身份提供者的应用。',
		'Register and manage apps': '注册和管理应用',
		'Register this exact URL as a Web redirect URI on the app. It must end in /auth/microsoft/callback.': '请将此 URL 原样注册为应用的 Web 重定向 URI，必须以 /auth/microsoft/callback 结尾。',
		'Register to Applications': '注册到应用',
		'Registration failed. Please try again.': '注册失败，请重试。',
		'Reload all administration statistics': '重新加载所有管理统计数据',
		'Remove': '移除',
		'Remove Icon': '移除图标',
		'Replace Icon': '替换图标',
		'Required for server-side token verification.': '服务端令牌验证所需。',
		'Resend code': '重新发送验证码',
		'Reset Password': '重置密码',
		'Reset code is invalid or expired.': '重置码无效或已过期。',
		'Reset password': '重置密码',
		'Resized to 128×128': '已调整为 128×128',
		'Resized to 512×512': '已调整为 512×512',
		'Resume': '恢复',
		'Retry': '重试',
		'Return URL': '返回 URL',
		'Review': '审核',
		'Review Data': '审核数据',
		'Review system activity and security events': '查看系统活动和安全事件',
		'Review the details below before sending this newsletter.': '发送此邮件通讯前请查看以下详情。',
		'Review the validation results below before importing.': '导入前请查看以下验证结果。',
		'Revoke': '撤销',
		'Revoke All Sessions': '撤销所有会话',
		'Revoke all others': '撤销其他所有',
		'Revoking…': '撤销中…',
		'Role': '角色',
		'Role Changed': '角色已更改',
		'Role Created': '角色已创建',
		'Role Deleted': '角色已删除',
		'Role Name': '角色名称',
		'Role Updated': '角色已更新',
		'Role name is required.': '角色名称为必填项。',
		'Roles': '角色',
		'Row': '行',
		'S3 Storage': 'S3 存储',
		'S3-compatible endpoint (e.g. https://s3.amazonaws.com or your MinIO URL).': '兼容 S3 的端点（例如 https://s3.amazonaws.com 或您的 MinIO URL）。',
		'Sign in with Apple': '使用 Apple 登录',
		'Sign in with Microsoft': '使用 Microsoft 登录',
		'Sign up with Apple': '使用 Apple 注册',
		'Sign up with Microsoft': '使用 Microsoft 注册',
		'Signing you out…': '正在退出登录…',
		'SMTP': 'SMTP',
		'SMTP Configuration': 'SMTP 配置',
		'SMTP Host': 'SMTP 主机',
		'SMTP Port': 'SMTP 端口',
		'SMTP Status': 'SMTP 状态',
		'SMTP connection verified successfully.': 'SMTP 连接验证成功。',
		'SMTP settings saved successfully.': 'SMTP 设置保存成功。',
		'SMTP verification failed': 'SMTP 验证失败',
		'Save': '保存',
		'Save Changes': '保存更改',
		'Save Profile': '保存资料',
		'Save SMTP': '保存 SMTP',
		'Save Security Settings': '保存安全设置',
		'Save Settings': '保存设置',
		'Save these codes in a safe place. Each can be used once if you lose your authenticator. They will not be shown again.': '请将这些备用码保存在安全的地方。如果您丢失了身份验证器，每个备用码可使用一次。它们不会再次显示。',
		'Saving...': '保存中...',
		'Scan with your authenticator app:': '使用身份验证器应用扫描：',
		'Scheduled': '已计划',
		'Scoped to Application': '应用范围',
		'Search': '搜索',
		'Search applications...': '搜索应用...',
		'Search by name or email...': '按姓名或邮箱搜索...',
		'Search logs...': '搜索日志...',
		'Search name or subject…': '搜索名称或主题…',
		'Search roles...': '搜索角色...',
		'Search templates...': '搜索模板...',
		'Seconds before expiry during which a refresh is allowed. Default 4320 (72 min).': '过期前允许刷新的秒数。默认 4320（72分钟）。',
		'Secret Access Key': 'Secret Access Key',
		'Secret is configured': '密钥已配置',
		'Secure authentication, role management, and user administration — all in one place.': '安全的身份验证、角色管理和用户管理 — 尽在一处。',
		'Security': '安全',
		'Security & Access Control': '安全与访问控制',
		'Security settings saved successfully.': '安全设置保存成功。',
		'Select…': '请选择…',
		'Send': '发送',
		'Send Notification': '发送通知',
		'Send Test Email': '发送测试邮件',
		'Send reset code': '发送重置码',
		'Send test email': '发送测试邮件',
		'Sender Identity': '发件人身份',
		'Sending': '发送中',
		'Sending...': '发送中...',
		'Sent': '已发送',
		'Sent At': '发送时间',
		'Server': '服务器',
		'Server Preview': '服务器预览',
		'Server-rendered newsletter preview': '服务器渲染的邮件通讯预览',
		'Service Active': '服务运行中',
		'Session Locations': '会话位置',
		'Session revoked.': '会话已撤销。',
		'Sessions': '会话',
		'Settings': '设置',
		'Settings Changed': '设置已更改',
		'Settings saved successfully.': '设置保存成功。',
		'Show password': '显示密码',
		'Showing': '显示',
		'Shown during account migration / data transfer.': '在账户迁移/数据传输期间显示。',
		'Sidebar link icon removed.': '侧边栏链接图标已移除。',
		'Sidebar link icon uploaded.': '侧边栏链接图标已上传。',
		'Sign Out': '退出登录',
		'Sign in': '登录',
		'Sign in or Register': '登录或注册',
		'Sign in securely with fingerprint, face recognition, or security keys.': '使用指纹、面部识别或安全密钥安全登录。',
		'Sign in to': '登录到',
		'Sign in with Google': '使用 Google 登录',
		'Sign in with a passkey': '使用通行密钥登录',
		'Sign in with email code instead': '改用邮箱验证码登录',
		'Sign in with password': '使用密码登录',
		'Sign up with Google': '使用 Google 注册',
		'Signups This Week': '本周注册',
		'Signups This Year': '本年注册',
		'Skip': '跳过',
		'Social Account Linked': '社交账号已关联',
		'Stack trace': '堆栈追踪',
		'Start typing HTML content to see a preview': '开始输入 HTML 内容以查看预览',
		'Status': '状态',
		'Status & Features': '状态与功能',
		'Status:': '状态：',
		'Stay up to date with your account activity': '随时了解您的账户动态',
		'Subject': '主题',
		'Subject Line': '邮件主题',
		'Subject:': '主题：',
		'Success': '成功',
		'Synced': '已同步',
		'System': '系统',
		'System Errors': '系统错误',
		'System Information': '系统信息',
		'Target': '目标',
		'Template': '模板',
		'Template Name': '模板名称',
		'Template Preview': '模板预览',
		'Template created.': '模板已创建。',
		'Template deleted.': '模板已删除。',
		'Template name and subject are required.': '模板名称和主题为必填项。',
		'Template updated.': '模板已更新。',
		'Terms of Service': '服务条款',
		'Terms of Service URL': '服务条款 URL',
		'Test email sent to your address.': '测试邮件已发送到您的地址。',
		'Text Content (fallback)': '文本内容（备用）',
		'The application you were trying to sign in to was not found or is no longer active.': '您尝试登录的应用未找到或已停用。',
		'The master template used by newsletters when no specific template is selected.': '未选择特定模板时邮件通讯使用的主模板。',
		'The page you\'re looking for doesn\'t exist or has been moved.': '您访问的页面不存在或已被移动。',
		'The secret value, not its ID. Secrets expire — note the expiry date.': '填写密码的值而非其 ID。密码会过期，请记录过期日期。',
		'The sender address in the email From header.': '邮件 From 头中的发件人地址。',
		'The verification link may have expired. Please try registering again.': '验证链接可能已过期。请重新注册。',
		'Theme': '主题',
		'This is a preview of the consent page. No authorization will be performed.': '这是授权页面的预览。不会执行实际授权。',
		'This is a preview of the token staging page. In the real flow, the user\'s JWT would appear below.': '这是令牌暂存页面的预览。在实际流程中，用户的 JWT 将显示在下方。',
		'This is a preview. In the real flow, the user would be redirected back to': '这是预览。在实际流程中，用户将被重定向回',
		'This is a preview. No real token was generated.': '这是预览。未生成真实令牌。',
		'This page is part of the Microsoft sign-in flow and can be closed.': '此页面是 Microsoft 登录流程的一部分，可以关闭。',
		'Time': '时间',
		'Title (required)': '标题（必填）',
		'Toggle dark mode': '切换深色模式',
		'Token & Session': '令牌与会话',
		'Token Flow': '令牌流程',
		'Token Flow Preview': '令牌流程预览',
		'Token Refresh Window (seconds)': '令牌刷新窗口（秒）',
		'Token copied to clipboard': '令牌已复制到剪贴板',
		'Tokens': '令牌',
		'Tokens are replaced per-recipient at send time. The preview shows sample data.': '令牌在发送时按收件人替换。预览显示的是示例数据。',
		'Top Clicked URLs': '热门点击 URL',
		'Total Recipients': '总收件人数',
		'Total Users': '总用户数',
		'Total batches': '总批次数',
		'Total rows': '总行数',
		'Two-Factor Authentication': '两步验证',
		'Two-factor authentication': '两步验证',
		'Two-factor authentication enabled successfully!': '两步验证已成功启用！',
		'Two-factor authentication has been disabled.': '两步验证已禁用。',
		'Type': '类型',
		'URL': 'URL',
		'UUID': 'UUID',
		'Unknown device': '未知设备',
		'Unlimited': '无限制',
		'Unnamed': '未命名',
		'Unnamed User': '未命名用户',
		'Unsubscribes': '退订',
		'Unverified': '未验证',
		'Updated': '更新时间',
		'Upload': '上传',
		'Upload CSV File': '上传 CSV 文件',
		'Upload Icon': '上传图标',
		'Upload Logo': '上传 Logo',
		'Upload a CSV file containing the users you want to import. The first row should contain column headers (e.g. Email, First Name, Last Name).': '上传包含待导入用户的 CSV 文件。第一行应为列标题（如 Email、First Name、Last Name）。',
		'Upload a square image. It will be resized to 256×256 pixels.': '上传正方形图片，将被调整为 256×256 像素。',
		'Uploading…': '上传中…',
		'Use TLS': '使用 TLS',
		'Use a backup code instead': '改用备用码',
		'Use a passkey': '使用通行密钥',
		'Use authenticator app instead': '改用身份验证器应用',
		'Use passkey': '使用通行密钥',
		'Use password': '使用密码',
		'User': '用户',
		'User Activated': '用户已激活',
		'User Dashboard': '用户仪表盘',
		'User Deactivated': '用户已停用',
		'User Deleted': '用户已删除',
		'User Login': '用户登录',
		'User Registered': '用户已注册',
		'User Updated': '用户已更新',
		'User Verified': '用户已验证',
		'User dashboard settings saved.': '用户仪表盘设置已保存。',
		'User updated successfully.': '用户更新成功。',
		'Username': '用户名',
		'Username updated successfully.': '用户名更新成功。',
		'Users': '用户',
		'Uses the WordPress REST API': '使用 WordPress REST API',
		'Verification Link Expiry': '验证链接有效期',
		'Verification URLs': '验证 URL',
		'Verification code sent to your email.': '验证码已发送到您的邮箱。',
		'Verification failed. The link may be invalid or expired.': '验证失败。链接可能无效或已过期。',
		'Verified': '已验证',
		'Verify': '验证',
		'Verify Connection': '验证连接',
		'Verify your identity': '验证您的身份',
		'Verifying your email': '正在验证您的邮箱',
		'Verifying...': '验证中...',
		'Version': '版本',
		'View all audit logs': '查看所有审计日志',
		'View all notifications': '查看所有通知',
		'View and edit accounts': '查看和编辑账户',
		'View details': '查看详情',
		'View transactions & balance': '查看交易与余额',
		'View your notifications': '查看您的通知',
		'View, search, and manage user accounts': '查看、搜索和管理用户账户',
		'Visible': '可见',
		'Visible When Registered': '注册后可见',
		'Warning': '警告',
		'Wave': '批次',
		'Wave Interval (sec)': '批次间隔（秒）',
		'Wave Size': '批次大小',
		'We sent a 6-digit code to': '我们已发送6位验证码至',
		'We sent a verification link to': '我们已发送验证链接至',
		'We sent a verification link to your email address.': '我们已发送验证链接到您的邮箱。',
		'We\'ve sent you a verification link.': '我们已向您发送验证链接。',
		'Website': '网站',
		'Website Name': '网站名称',
		'Website URL': '网站 URL',
		'What this role grants access to...': '此角色授予的访问权限...',
		'When disabled, the feed section is hidden from the user dashboard.': '禁用后，新闻源部分将从用户仪表盘中隐藏。',
		'When disabled, the identity service rejects new registrations.': '禁用后，身份服务将拒绝新注册。',
		'When enabled, multiple accounts may share the same email address.': '启用后，多个账户可以共享同一邮箱地址。',
		'When enabled, you won\'t receive promotional emails.': '启用后，您将不再收到推广邮件。',
		'Whitelisted IPs': 'IP 白名单',
		'WordPress REST API detected successfully.': 'WordPress REST API 检测成功。',
		'Yes, I\'m sure': '是的，我确定',
		'Yes, confirm': '确认',
		'You are not registered with any applications yet.': '您尚未注册任何应用。',
		'You have no notifications right now.': '您目前没有通知。',
		'Your Account': '您的账户',
		'Your account is protected with TOTP authenticator.': '您的账户已通过 TOTP 身份验证器保护。',
		'Your assigned roles for this application': '您在此应用的分配角色',
		'Your email has been verified! You can now sign in.': '您的邮箱已验证！现在可以登录了。',
		'Your gateway to the Abstract platform. Manage your identity, applications, and security — all in one place.': '您的 Abstract 平台入口。在一处管理您的身份、应用和安全设置。',
		'Your password has been reset successfully.': '您的密码已成功重置。',
		'Your request to access': '您的访问请求',
		"You've previously granted access to": '您之前已授权访问',
		'allow all.': '允许全部。',
		'by': '由',
		'cancel this newsletter': '取消此邮件通讯',
		'delete this application': '删除此应用',
		'delete this icon': '删除此图标',
		'delete this logo': '删除此 Logo',
		'delete this newsletter': '删除此邮件通讯',
		'delete this role': '删除此角色',
		'delete this template': '删除此模板',
		'dismiss': '忽略',
		'e.g. January Newsletter': '例如 一月通讯',
		'e.g. a1b2c3d4': 'e.g. a1b2c3d4',
		'e.g. admin, editor, viewer': '例如 admin、editor、viewer',
		'has been submitted. An administrator will review and approve your access.': '已提交。管理员将审核并批准您的访问请求。',
		'inserting into:': '插入到：',
		'is an': '是一个',
		'is requesting access to your account. By continuing, you allow this application to verify your identity': '正在请求访问您的账户。继续操作即表示您允许此应用验证您的身份',
		'just now': '刚刚',
		'key': '密钥',
		'of': '/',
		'or': '或',
		'or Apple': '或 Apple',
		'or Microsoft': '或 Microsoft',
		'or Google': '或 Google',
		'product.': '产品。',
		'region': '区域',
		'regions': '区域',
		'remove this icon': '移除此图标',
		'remove your avatar': '移除您的头像',
		'revoke all sessions': '撤销所有会话',
		'session': '会话',
		'sessions': '会话',
		'to auto-resolve the WordPress REST API endpoint.': '以自动解析 WordPress REST API 端点。',
		'to complete sign-in.': '以完成登录。',
		'to fetch recent posts.': '以获取最新文章。',
		'tokens': '令牌',
		'user@example.com': 'user@example.com',
		'username': '用户名',
		'you@example.com': 'you@example.com',
		'— Not mapped —': '— 未映射 —',
		'••••••••': '••••••••'
	}
};

/** All translatable strings keyed by locale code. */
export default translations;
